import { CLOUDINARY_BASE_URL } from "../config/cloudinary";

const img = (path) => `${CLOUDINARY_BASE_URL}${path}`;

const map = (query) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

const lunchCrowd = {
  high: "🔴 混みやすい",
  medium: "🟡 普通",
  low: "🟢 比較的入りやすい",
};

export const blogArticles = {
  cafe: {
    id: 1,
    slug: "cafe",
    template: "shops",
    category: "Cafe",
    title: "宮古島のおすすめ厳選カフェ",
    description:
      "海が見える絶景カフェから、緑に囲まれた癒しカフェ、雨の日でも楽しめるカフェまで。宮古島旅行で立ち寄りたいおすすめカフェを厳選して紹介します。",
    date: "2026.06.27",
    readTime: "8分",
    mainImage: img("v1783352246/panipani_top_pnt17c.jpg"),
    leadText:
      "宮古島には、ただ食事をするだけではなく、景色や空間ごと楽しめるカフェがたくさんあります。オーシャンビュー、自然に囲まれたお店、雨の日でも過ごしやすい場所、島の食材を味わえるカフェ、写真や動画に残したくなる映えカフェまで、旅の途中で立ち寄りたいお店をカテゴリ別に紹介します。",
    tocImage: img(
      "v1783352339/AD_4nXf2yA3puqm63h-XEHfk_ltPQ-m0Sy4IQCU-m0yCaojShxZt7-CDQQ1B8UUjJ5iQC-szsuwzS9Vq4ScPOBElN52vu_oxEkcKu2UbdK-gsQe_WVuQKT9E9iGjaVqKC7vIMduz6M-_ylvli6.png",
    ),
    toc: [
      "絶景を楽しめるオーシャンビューカフェ",
      "緑に囲まれたカフェ",
      "雨の日でも楽しめるカフェ",
      "宮古島の食材を楽しめるカフェ",
      "映えるカフェ",
    ],
    points: [
      {
        number: "01",
        title: "絶景を楽しめるオーシャンビューカフェ",
        area: "海が見えるカフェ",
        text: "宮古島らしい青い海を眺めながら過ごせるカフェ。ドライブの途中や、海遊びの前後に立ち寄るだけで、旅の満足度が一気に上がります。",
        shops: [
          {
            name: "Sea Horse Club Cafe",
            area: "伊良部島",
            images: [
              "https://www.instagram.com/p/DY3mcMRRgcf/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl:
              "https://www.google.com/maps/search/?api=1&query=Sea%20Horse%20Club%20Cafe%20%E5%AE%AE%E5%8F%A4%E5%B3%B6%20%E4%BC%8A%E8%89%AF%E9%83%A8%E5%B3%B6",
            instagramUrl: "",
            instagramLabel: "",
            baeScore: 5,
            recommendedMenu: "ランチプレート / 南国ドリンク",
            businessHours: "11:00～16:30, 18:00～21:00",
            closedDays: "火曜日",
            text: "伊良部島で海を感じながら過ごせるカフェ。プール付きの開放感ある空間が魅力で、リゾート感のある写真を撮りたい人にもおすすめです。",
            rows: [
              ["住所", "沖縄県宮古島市伊良部エリア"],
              ["雰囲気", "プール / リゾート / 開放感"],
              ["おすすめ", "ランチ / カフェタイム / ゆっくり過ごす"],
              [
                "撮影ポイント",
                "プールや南国感のある背景を入れて撮ると映えやすい",
              ],
            ],
            hashtags: [
              "#SeaHorseClubCafe",
              "#伊良部島カフェ",
              "#プール付きカフェ",
            ],
          },
          {
            name: "OHAMAテラス",
            area: "池間島",
            images: [
              "https://www.instagram.com/p/CGgJO1zgvUz/?igsh=anc5YXQybXExZHd1",
            ],
            mapUrl: map("OHAMAテラス 宮古島 池間島"),
            // instagramUrl: 'https://www.instagram.com/ohama0303/',
            instagramLabel: "@ohama0303",
            baeScore: 5,
            recommendedMenu:
              "タコライス / トロピカルドリンク / マンゴーシャーベット",
            businessHours: "10時00分～16時30分",
            closedDays: "木曜日",
            text: "池間島の海を一望できるテラスカフェ。海風を感じられる開放的な空間で、サンセット時間にも立ち寄りたい場所です。",
            rows: [
              ["雰囲気", "テラス / 海景色 / 開放感"],
              ["おすすめ", "ランチ / ドリンク / 海を見ながら休憩"],
              ["撮影ポイント", "海を背景に、ドリンクや料理を手前に置いて撮る"],
            ],
            hashtags: ["#OHAMAテラス", "#池間島", "#テラスカフェ"],
          },
          {
            name: "gelato cafe Ninufa",
            area: "池間島",
            images: [
              "https://www.instagram.com/p/DXS9-rckT33/?img_index=7&igsh=MTN4NmdmaXlzbnhmaw==",
            ],
            mapUrl: map("gelato cafe Ninufa 宮古島 池間島"),
            instagramUrl: "",
            instagramLabel: "",
            baeScore: 4,
            recommendedMenu: "ジェラート",
            businessHours: "10:00～17:00",
            closedDays: "水曜日",
            text: "池間島で海を眺めながらジェラートを楽しめるカフェ。ドライブ途中の休憩にも使いやすく、暑い日の立ち寄りにぴったりです。",
            rows: [
              ["雰囲気", "海景色 / ジェラート / ドライブ"],
              ["おすすめ", "ジェラート / カフェ休憩 / 池間島ドライブ"],
              ["撮影ポイント", "海を背景にジェラートを手前に入れる"],
            ],
            hashtags: ["#Ninufa", "#池間島カフェ", "#ジェラート"],
          },
        ],
        hashtags: ["#オーシャンビュー", "#海カフェ", "#宮古ブルー"],
      },

      {
        number: "02",
        title: "緑に囲まれたカフェ",
        area: "自然を感じるカフェ",
        text: "海だけではなく、緑や花に囲まれた空間で過ごせるカフェも宮古島の魅力。日差しが強い日や、少し落ち着いて過ごしたい日におすすめです。",
        shops: [
          {
            name: "農家れすとらん 楽園の果実",
            area: "来間島",
            images: [
              "https://www.instagram.com/p/DXZJc7QkRug/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map("農家れすとらん 楽園の果実 宮古島 来間島"),
            instagramUrl: "",
            instagramLabel: "",
            baeScore: 2,
            recommendedMenu:
              "マンゴースイーツ / 島野菜ランチ / トロピカルジュース",
            businessHours: "11:00～18:00",
            closedDays: "火曜日",
            text: "来間島で島フルーツや島野菜を楽しめる人気店。南国らしい緑と果物の雰囲気があり、ランチにもスイーツ休憩にも使いやすい場所です。",
            rows: [
              ["雰囲気", "南国フルーツ / 来間島 / 島食材"],
              ["おすすめ", "ランチ / マンゴースイーツ / ドライブ休憩"],
              ["撮影ポイント", "マンゴーや南国ドリンクを手前に入れて撮る"],
            ],
            hashtags: ["#楽園の果実", "#来間島カフェ", "#宮古島マンゴー"],
          },
          {
            name: "パニパニ",
            area: "来間島",
            images: [
              "https://www.instagram.com/p/DZv9p_zTjZx/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map("パニパニ 宮古島 来間島"),
            instagramUrl: "",
            instagramLabel: "",
            baeScore: 5,
            recommendedMenu: "南国ドリンク / スイーツ",
            businessHours: "10:00〜15:30",
            closedDays: "なし",
            text: "ジャングルのような自然に囲まれた、独特の世界観があるカフェ。ブランコ席など、写真に残したくなる演出が魅力です。",
            rows: [
              ["雰囲気", "ジャングル感 / 来間島 / 個性派"],
              ["おすすめ", "南国ドリンク / 休憩 / 写真撮影"],
              ["撮影ポイント", "ブランコ席や緑を背景に撮る"],
            ],
            hashtags: ["#パニパニ", "#来間島カフェ", "#映えカフェ"],
          },
          {
            name: "島茶屋ヤッカヤッカ",
            area: "来間島",
            images: [
              "https://www.instagram.com/p/DPGKivtkw3j/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map("ヤッカヤッカ 宮古島 来間島"),
            instagramUrl: "",
            instagramLabel: "",
            baeScore: 1,
            recommendedMenu: "島食材ランチ",
            businessHours: "11:30〜17:00",
            closedDays: "なし",
            text: "来間島にある古民家風のカフェ。地元食材を使った料理を、静かな空間でゆっくり楽しみたい人におすすめです。",
            rows: [
              ["雰囲気", "古民家風 / 静か / 島食材"],
              ["おすすめ", "ランチ / 来間島ドライブ / 穴場"],
              ["撮影ポイント", "古民家の雰囲気と料理を一緒に撮る"],
            ],
            hashtags: ["#ヤッカヤッカ", "#来間島カフェ", "#隠れ家カフェ"],
          },
        ],
        hashtags: ["#自然カフェ", "#緑に囲まれたカフェ", "#癒し時間"],
      },

      {
        number: "03",
        title: "雨の日でも楽しめるカフェ",
        area: "天気が悪い日の過ごし方",
        text: "雨の日の宮古島でも、カフェ時間をうまく使えば旅を楽しめます。屋内でゆっくり過ごせるお店や、コーヒー、ランチ、軽食を楽しめる場所を選ぶのがおすすめです。",
        shops: [
          {
            name: "DOUG’S BURGER",
            area: "平良下里",
            images: [
              "https://www.instagram.com/p/C9XGmvLS4DD/?igsh=bnFpNnlkaXh3OWlm",
            ],
            mapUrl: map("DOUG’S BURGER 宮古島"),
            instagramUrl: "",
            instagramLabel: "",
            baeScore: 1,
            recommendedMenu: "宮古牛バーガー",
            businessHours: "要確認",
            closedDays: "要確認",
            text: "宮古島で有名なグルメバーガー店。天気が悪い日でもしっかりランチを楽しみたい時に使いやすいお店です。",
            rows: [
              ["雰囲気", "バーガー / カジュアル / 人気店"],
              ["おすすめ", "宮古牛バーガー / ランチ"],
              ["撮影ポイント", "バーガーを寄りで撮ってボリューム感を出す"],
            ],
            hashtags: ["#DOUGSBURGER", "#宮古牛バーガー", "#宮古島ランチ"],
          },
          {
            name: "ブルーシール 宮古島パイナガマ店",
            area: "パイナガマ周辺",
            images: [
              "https://www.instagram.com/p/DaFn7nbgQVg/?igsh=b3FqMjU0amJ0bTNu",
            ],
            mapUrl: map("ブルーシール 宮古島パイナガマ店"),
            websiteUrl:
              "https://rtrp.jp/spots/7ea77865-1ebf-43f7-bf28-6f2f2aec2b65/",
            websiteLabel: "ブルーシール 宮古島パイナガマ店",
            baeScore: 5,
            recommendedMenu: "アイスクリーム / ドリンク",
            businessHours: "要確認",
            closedDays: "要確認",
            text: "パイナガマビーチ近くにあるブルーシール。雨で海遊びができない日でも、アイスやドリンクで気分を切り替えやすい場所です。",
            rows: [
              ["雰囲気", "海近く / アイスクリーム / 立ち寄りやすい"],
              ["おすすめ", "アイスクリーム / ドリンク / テイクアウト"],
              ["撮影ポイント", "カラフルなアイスを手前に入れて撮る"],
            ],
            hashtags: ["#ブルーシール", "#パイナガマ", "#雨の日カフェ"],
          },
        ],
        hashtags: ["#雨の日", "#宮古島カフェ巡り", "#室内で楽しむ"],
      },

      {
        number: "04",
        title: "宮古島の食材を楽しめるカフェ",
        area: "島食材・フルーツ",
        text: "宮古島らしさを味わうなら、島野菜やマンゴー、南国フルーツを使ったカフェがおすすめ。観光だけではなく、食からも宮古島を感じられます。",
        shops: [
          {
            name: "ユートピアファーム宮古島",
            area: "上野宮国",
            images: [
              "https://www.instagram.com/p/DZ4iPDRCaac/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map("ユートピアファーム宮古島"),
            instagramUrl: "https://www.instagram.com/yu_topia_farm/",
            instagramLabel: "@yu_topia_farm",
            baeScore: 2,
            recommendedMenu: "マンゴースムージー / 南国フルーツスイーツ",
            businessHours: "10:00〜18:00",
            closedDays: "不定休",
            text: "南国の花やフルーツに囲まれた農園カフェ。マンゴーやパパイヤなど、宮古島らしいフルーツスイーツを楽しみたい人におすすめです。",
            rows: [
              ["雰囲気", "花 / フルーツ / 南国感"],
              ["おすすめ", "フルーツスイーツ / ドリンク / 観光ついで"],
              ["撮影ポイント", "花やグリーンを背景にスイーツを撮る"],
            ],
            hashtags: ["#ユートピアファーム", "#マンゴー", "#宮古島フルーツ"],
          },
          {
            name: "楽園の果実",
            area: "来間島",
            images: [
              "https://www.instagram.com/p/DMZybZoRmH6/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map("楽園の果実 来間島 宮古島"),
            instagramUrl: "https://www.instagram.com/rakuen_kajitsu/",
            instagramLabel: "@rakuen_kajitsu",
            baeScore: 3,
            recommendedMenu: "マンゴーパフェ / フルーツスイーツ",
            businessHours: "要確認",
            closedDays: "要確認",
            text: "南国フルーツやスイーツを楽しみたい時におすすめ。来間島ドライブと合わせて立ち寄りやすいカフェです。",
            rows: [
              ["雰囲気", "南国フルーツ / スイーツ / 来間島"],
              ["おすすめ", "マンゴー系スイーツ / フルーツメニュー"],
              ["撮影ポイント", "色のあるスイーツを自然光で撮る"],
            ],
            hashtags: ["#楽園の果実", "#来間島", "#マンゴー"],
          },
          {
            name: "ブルータートルファーム マンゴーカフェ",
            area: "平良松原",
            images: [
              "https://www.instagram.com/p/DaAX9DdGXTg/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map("ブルータートルファーム マンゴーカフェ 宮古島"),
            instagramUrl: "",
            instagramLabel: "",
            baeScore: 5,
            recommendedMenu: "マンゴースイーツ",
            businessHours: "毎日 10:00〜17:30",
            closedDays: "なし",
            text: "マンゴー農園が運営するカフェ。新鮮なマンゴーを使ったスイーツを楽しみたい人におすすめです。",
            rows: [
              ["雰囲気", "マンゴー農園 / スイーツ / 南国感"],
              ["おすすめ", "マンゴースイーツ / 季節限定メニュー"],
              ["撮影ポイント", "マンゴーの色味を自然光で明るく撮る"],
            ],
            hashtags: ["#マンゴーカフェ", "#宮古島マンゴー", "#スイーツ"],
          },
        ],
        hashtags: ["#島食材", "#宮古島グルメ", "#フルーツ"],
      },

      {
        number: "05",
        title: "映えるカフェ",
        area: "写真・動画に残したいカフェ",
        text: "旅の思い出として写真や動画に残したいなら、色・背景・光が揃うカフェがおすすめ。ドリンクやスイーツだけでなく、外観や周辺の景色まで含めて撮ると映えます。",
        shops: [
          {
            name: "島cafe とぅんからや",
            area: "宮古島南部",
            images: [
              "https://www.instagram.com/p/DaXuln0gbOj/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map("島cafe とぅんからや 宮古島"),
            instagramUrl: "https://www.instagram.com/sima_cafe_tounkaraya/",
            instagramLabel: "@sima_cafe_tounkaraya",
            baeScore: 5,
            recommendedMenu: "宮古牛タコライス",
            businessHours: "11:30〜16:00",
            closedDays: "月曜日",
            text: "高台から海を見下ろせるロケーションが魅力のカフェ。テラス席からの景色が写真映えしやすく、宮古島らしい空気感を残せます。",
            rows: [
              ["雰囲気", "海が見える / 南国感 / ゆったり"],
              ["おすすめ", "ランチ / カフェタイム / 景色重視"],
              ["撮影ポイント", "テラス席や海が見える角度で撮ると映えやすい"],
            ],
            hashtags: ["#島cafeとぅんからや", "#海カフェ", "#絶景カフェ"],
          },
          {
            name: "HARRY'S Shrimp Truck",
            area: "西平安名崎方面",
            images: [
              "https://www.instagram.com/p/DYCYkl0EmO0/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map("HARRY'S Shrimp Truck 宮古島"),
            instagramUrl: "",
            instagramLabel: "",
            baeScore: 5,
            recommendedMenu: "ガーリックシュリンプ",
            businessHours: "要確認",
            closedDays: "要確認",
            text: "ハワイ風のフードトラックで、ガーリックシュリンプが人気。カラフルな見た目とボリューム感で、写真にも残しやすいスポットです。",
            rows: [
              ["雰囲気", "フードトラック / ハワイ感 / カジュアル"],
              ["おすすめ", "ガーリックシュリンプ / ドライブ途中"],
              ["撮影ポイント", "トラックと料理を一緒に入れる"],
            ],
            hashtags: [
              "#HARRYSShrimpTruck",
              "#ガーリックシュリンプ",
              "#宮古島ランチ",
            ],
          },
          {
            name: "SHISA'S CAFE&BBQ",
            area: "平良荷川取",
            images: [
              "https://www.instagram.com/p/DK9LSSmRpSS/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map("SHISA'S CAFE&BBQ 宮古島"),
            instagramUrl: "",
            instagramLabel: "",
            baeScore: 5,
            recommendedMenu: "BBQ / カフェメニュー",
            businessHours: "要確認",
            closedDays: "要確認",
            text: "南国らしいカラフルな外観が印象的なカフェレストラン。写真映えする外観や、BBQを楽しめる雰囲気が魅力です。",
            rows: [
              ["雰囲気", "カラフル / 南国 / BBQ"],
              ["おすすめ", "BBQ / 写真撮影 / グループ利用"],
              ["撮影ポイント", "外観の色味を背景にして撮る"],
            ],
            hashtags: ["#SHISASCAFE", "#宮古島BBQ", "#映えカフェ"],
          },
          {
            name: "ブルータートルファーム マンゴーカフェ",
            area: "平良松原",
            images: [
              "https://www.instagram.com/p/DaAX9DdGXTg/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map("ブルータートルファーム マンゴーカフェ 宮古島"),
            instagramUrl: "https://www.instagram.com/blueturtlefarm_miyako/",
            instagramLabel: "@blueturtlefarm_miyako",
            baeScore: 5,
            recommendedMenu: "マンゴースイーツ",
            businessHours: "毎日 10:00〜17:30",
            closedDays: "なし",
            text: "マンゴー農園が運営するカフェ。鮮やかなマンゴースイーツや南国感のある雰囲気を写真に残したい人におすすめです。",
            rows: [
              ["雰囲気", "マンゴー農園 / スイーツ / 南国感"],
              ["おすすめ", "マンゴースイーツ / 季節限定メニュー"],
              ["撮影ポイント", "マンゴーの色味を明るく入れて撮る"],
            ],
            hashtags: ["#マンゴーカフェ", "#宮古島マンゴー", "#映えカフェ"],
          },
        ],
        hashtags: ["#映えカフェ", "#宮古島写真", "#旅動画"],
      },
    ],
  },
  "bae-cafe-best5": {
    id: 7,
    slug: "bae-cafe-best5",
    template: "shops",
    categoryKey: "cafe",
    category: "Cafe",
    title: "写真撮るならここ！映えるカフェBEST6",
    description:
      "宮古島で写真や動画に残したい、海・緑・南国感がきれいに映えるカフェを厳選。旅行中に立ち寄りたい映えカフェBEST6を紹介します。",
    date: "2026.07.22",
    readTime: "6分",
    mainImage: img(
      "v1783352339/AD_4nXf2yA3puqm63h-XEHfk_ltPQ-m0Sy4IQCU-m0yCaojShxZt7-CDQQ1B8UUjJ5iQC-szsuwzS9Vq4ScPOBElN52vu_oxEkcKu2UbdK-gsQe_WVuQKT9E9iGjaVqKC7vIMduz6M-_ylvli6.png",
    ),
    leadText:
      "宮古島でカフェに行くなら、味だけでなく写真に残したくなる景色や空間も大事。海が見える席、南国らしい緑、カラフルな外観、ドリンクやスイーツがきれいに撮れるお店など、旅の思い出を写真や動画に残しやすいカフェをBEST6として厳選しました。",
    tocImage: img(
      "v1783352339/AD_4nXf2yA3puqm63h-XEHfk_ltPQ-m0Sy4IQCU-m0yCaojShxZt7-CDQQ1B8UUjJ5iQC-szsuwzS9Vq4ScPOBElN52vu_oxEkcKu2UbdK-gsQe_WVuQKT9E9iGjaVqKC7vIMduz6M-_ylvli6.png",
    ),
    toc: [
      "Sea Horse Club Cafe",
      "OHAMAテラス",
      "パニパニ",
      "ブルーシール 宮古島パイナガマ店",
      "島cafe とぅんからや",
      "ブルータートルファーム マンゴーカフェ",
    ],
    points: [
      {
        number: "01",
        title: "Sea Horse Club Cafe",
        area: "伊良部島 / プール / リゾート感",
        text: "プール付きの開放感ある空間で、宮古島らしいリゾート感を写真に残しやすいカフェ。海遊びの前後や伊良部島ドライブの途中にも立ち寄りやすい場所です。",
        shops: [
          {
            name: "Sea Horse Club Cafe",
            area: "伊良部島",
            images: [
              "https://www.instagram.com/p/DY3mcMRRgcf/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl:
              "https://www.google.com/maps/search/?api=1&query=Sea%20Horse%20Club%20Cafe%20%E5%AE%AE%E5%8F%A4%E5%B3%B6%20%E4%BC%8A%E8%89%AF%E9%83%A8%E5%B3%B6",
            baeScore: 5,
            recommendedMenu: "ランチプレート / 南国ドリンク",
            businessHours: "11:00～16:30, 18:00～21:00",
            closedDays: "火曜日",
            text: "伊良部島で海を感じながら過ごせるカフェ。プール付きの開放感ある空間が魅力で、リゾート感のある写真を撮りたい人にもおすすめです。",
            rows: [
              ["雰囲気", "プール / リゾート / 開放感"],
              [
                "撮影ポイント",
                "プールや南国感のある背景を入れて撮ると映えやすい",
              ],
            ],
            hashtags: [
              "#SeaHorseClubCafe",
              "#伊良部島カフェ",
              "#プール付きカフェ",
            ],
          },
        ],
        hashtags: ["#リゾートカフェ", "#伊良部島", "#映えカフェ"],
      },
      {
        number: "02",
        title: "OHAMAテラス",
        area: "池間島 / 海景色 / テラス",
        text: "池間島の海を一望できるテラスカフェ。料理やドリンクを手前に置いて、奥に宮古ブルーを入れるだけで旅らしい写真になります。",
        shops: [
          {
            name: "OHAMAテラス",
            area: "池間島",
            images: [
              "https://www.instagram.com/p/CGgJO1zgvUz/?igsh=anc5YXQybXExZHd1",
            ],
            mapUrl: map("OHAMAテラス 宮古島 池間島"),
            instagramLabel: "@ohama0303",
            baeScore: 5,
            recommendedMenu:
              "タコライス / トロピカルドリンク / マンゴーシャーベット",
            businessHours: "10時00分～16時30分",
            closedDays: "木曜日",
            text: "池間島の海を一望できるテラスカフェ。海風を感じられる開放的な空間で、晴れた日の写真にぴったりです。",
            rows: [
              ["雰囲気", "テラス / 海景色 / 開放感"],
              ["撮影ポイント", "海を背景に、ドリンクや料理を手前に置いて撮る"],
            ],
            hashtags: ["#OHAMAテラス", "#池間島", "#テラスカフェ"],
          },
        ],
        hashtags: ["#宮古ブルー", "#海カフェ", "#池間島"],
      },
      {
        number: "03",
        title: "パニパニ",
        area: "来間島 / 緑 / 南国感",
        text: "来間島の緑に囲まれた、独特の世界観があるカフェ。ブランコ席や自然の背景を使うと、海とは違う宮古島らしい写真が撮れます。",
        shops: [
          {
            name: "パニパニ",
            area: "来間島",
            images: [
              "https://www.instagram.com/p/DZv9p_zTjZx/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map("パニパニ 宮古島 来間島"),
            baeScore: 5,
            recommendedMenu: "南国ドリンク / スイーツ",
            businessHours: "10:00〜15:30",
            closedDays: "なし",
            text: "ジャングルのような自然に囲まれた、独特の世界観があるカフェ。ブランコ席など、写真に残したくなる演出が魅力です。",
            rows: [
              ["雰囲気", "ジャングル感 / 来間島 / 個性派"],
              ["撮影ポイント", "ブランコ席や緑を背景に撮る"],
            ],
            hashtags: ["#パニパニ", "#来間島カフェ", "#映えカフェ"],
          },
        ],
        hashtags: ["#来間島", "#自然カフェ", "#南国感"],
      },
      {
        number: "04",
        title: "ブルーシール 宮古島パイナガマ店",
        area: "パイナガマ / アイス / カラフル",
        text: "カラフルなアイスやドリンクを、パイナガマ周辺の空気感と一緒に撮りたい時におすすめ。雨の日や海帰りにも立ち寄りやすい映えスポットです。",
        shops: [
          {
            name: "ブルーシール 宮古島パイナガマ店",
            area: "パイナガマ周辺",
            images: [
              "https://www.instagram.com/p/DaFn7nbgQVg/?igsh=b3FqMjU0amJ0bTNu",
            ],
            mapUrl: map("ブルーシール 宮古島パイナガマ店"),
            websiteUrl:
              "https://rtrp.jp/spots/7ea77865-1ebf-43f7-bf28-6f2f2aec2b65/",
            websiteLabel: "ブルーシール 宮古島パイナガマ店",
            baeScore: 5,
            recommendedMenu: "アイスクリーム / ドリンク",
            businessHours: "要確認",
            closedDays: "要確認",
            text: "パイナガマビーチ近くにあるブルーシール。カラフルなアイスを手前に入れるだけで、旅らしい写真になります。",
            rows: [
              ["雰囲気", "海近く / アイスクリーム / 立ち寄りやすい"],
              ["撮影ポイント", "カラフルなアイスを手前に入れて撮る"],
            ],
            hashtags: ["#ブルーシール", "#パイナガマ", "#宮古島スイーツ"],
          },
        ],
        hashtags: ["#アイスクリーム", "#カラフル", "#宮古島カフェ"],
      },
      {
        number: "05",
        title: "島cafe とぅんからや",
        area: "宮古島南部 / 海が見える / 絶景カフェ",
        text: "高台から海を見下ろせるロケーションが魅力。テラス席や海が見える角度で撮ると、宮古島らしい穏やかな雰囲気を残せます。",
        shops: [
          {
            name: "島cafe とぅんからや",
            area: "宮古島南部",
            images: [
              "https://www.instagram.com/p/DaXuln0gbOj/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map("島cafe とぅんからや 宮古島"),
            instagramUrl: "https://www.instagram.com/sima_cafe_tounkaraya/",
            instagramLabel: "@sima_cafe_tounkaraya",
            baeScore: 5,
            recommendedMenu: "宮古牛タコライス",
            businessHours: "11:30〜16:00",
            closedDays: "月曜日",
            text: "高台から海を見下ろせるロケーションが魅力のカフェ。テラス席からの景色が写真映えしやすく、宮古島らしい空気感を残せます。",
            rows: [
              ["雰囲気", "海が見える / 南国感 / ゆったり"],
              ["撮影ポイント", "テラス席や海が見える角度で撮ると映えやすい"],
            ],
            hashtags: ["#島cafeとぅんからや", "#海カフェ", "#絶景カフェ"],
          },
        ],
        hashtags: ["#絶景カフェ", "#宮古島写真", "#旅動画"],
      },
      {
        number: "06",
        title: "ブルータートルファーム マンゴーカフェ",
        area: "平良松原 / マンゴー / 南国スイーツ",
        text: "マンゴー農園が運営するカフェ。鮮やかなマンゴースイーツや南国らしい雰囲気を写真に残したい人におすすめです。",
        shops: [
          {
            name: "ブルータートルファーム マンゴーカフェ",
            area: "平良松原",
            images: [
              "https://www.instagram.com/p/DaAX9DdGXTg/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map("ブルータートルファーム マンゴーカフェ 宮古島"),
            instagramUrl: "https://www.instagram.com/blueturtlefarm_miyako/",
            instagramLabel: "@blueturtlefarm_miyako",
            baeScore: 5,
            recommendedMenu: "マンゴースイーツ",
            businessHours: "毎日 10:00〜17:30",
            closedDays: "なし",
            text: "マンゴー系スイーツを楽しみたい時にチェックしたいカフェ。販売状況は季節や投稿で変わるため、来店前に確認がおすすめです。",
            rows: [
              ["雰囲気", "マンゴー農園 / スイーツ / 南国感"],
              ["おすすめ", "マンゴースイーツ / 季節限定メニュー"],
              ["撮影ポイント", "マンゴーの色味を自然光で明るく撮る"],
            ],
            hashtags: ["#マンゴーカフェ", "#宮古島マンゴー", "#映えカフェ"],
          },
        ],
        hashtags: ["#マンゴーカフェ", "#宮古島スイーツ", "#映えカフェ"],
      },
    ],
  },
  "cafe-by-area": {
    id: 14,
    slug: "cafe-by-area",
    template: "shops",
    mediaLayout: "split",
    categoryKey: "cafe",
    category: "Cafe",
    title: "場所別で探す宮古島のおすすめカフェ",
    description:
      "伊良部島、来間島、池間島、宮古島本島のエリア別に、ドライブ途中で立ち寄りやすいおすすめカフェを紹介します。",
    date: "2026.07.25",
    readTime: "7分",
    mainImage: img(
      "v1783352339/AD_4nXf2yA3puqm63h-XEHfk_ltPQ-m0Sy4IQCU-m0yCaojShxZt7-CDQQ1B8UUjJ5iQC-szsuwzS9Vq4ScPOBElN52vu_oxEkcKu2UbdK-gsQe_WVuQKT9E9iGjaVqKC7vIMduz6M-_ylvli6.png",
    ),
    leadText:
      "宮古島でカフェを探す時は、行きたいエリアから選ぶと旅の動線がかなり楽になります。伊良部島、来間島、池間島、宮古島本島に分けて、ドライブや観光の途中に立ち寄りやすいカフェをまとめました。",
    tocImage: img("v1783352246/panipani_top_pnt17c.jpg"),
    toc: [
      "伊良部島で行きたいカフェ",
      "来間島で行きたいカフェ",
      "池間島で行きたいカフェ",
      "宮古島本島で行きたいカフェ",
    ],
    points: [
      {
        number: "01",
        title: "伊良部島で行きたいカフェ",
        area: "伊良部島 / リゾート感 / 海ドライブ",
        text: "伊良部大橋を渡って海沿いをドライブする日は、開放感のあるカフェを組み合わせるのがおすすめ。海遊びや写真撮影の前後に寄ると、伊良部島らしいリゾート感まで楽しめます。",
        shops: [
          {
            name: "Sea Horse Club Cafe",
            area: "伊良部島",
            images: [
              "https://www.instagram.com/p/DY3mcMRRgcf/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl:
              "https://www.google.com/maps/search/?api=1&query=Sea%20Horse%20Club%20Cafe%20%E5%AE%AE%E5%8F%A4%E5%B3%B6%20%E4%BC%8A%E8%89%AF%E9%83%A8%E5%B3%B6",
            baeScore: 5,
            recommendedMenu: "ランチプレート / 南国ドリンク",
            businessHours: "11:00～16:30, 18:00～21:00",
            closedDays: "火曜日",
            text: "プール付きの開放感ある空間が魅力のカフェ。伊良部島ドライブの途中に、リゾート感のある写真を残したい人にもおすすめです。",
            rows: [
              ["おすすめシーン", "伊良部島ドライブ / 海遊び後 / 写真撮影"],
              ["雰囲気", "プール / リゾート / 開放感"],
              ["撮影ポイント", "プールや南国感のある背景を入れて撮る"],
            ],
            hashtags: [
              "#SeaHorseClubCafe",
              "#伊良部島カフェ",
              "#プール付きカフェ",
            ],
          },
          {
            name: "Blue Turtle",
            area: "伊良部島",
            images: [
              "https://www.instagram.com/p/DTZdliiE1Xt/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map("Blue Turtle 宮古島 伊良部 1352-16"),
            instagramUrl: "https://www.instagram.com/blueturtle_miyako/",
            instagramLabel: "@blueturtle_miyako",
            baeScore: 5,
            recommendedMenu: "カフェごはん / スムージー / スイーツ",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "渡口の浜近くにある、海を感じながら過ごせる人気カフェ。伊良部島ドライブ中に、ランチやカフェ休憩、海を背景にした写真を楽しみたい時におすすめです。",
            rows: [
              ["住所", "〒906-0503 沖縄県宮古島市伊良部伊良部1352-16"],
              ["おすすめシーン", "伊良部島ドライブ / 海カフェ / ランチ"],
              ["雰囲気", "ビーチ近く / テラス / リゾート感"],
              [
                "撮影ポイント",
                "海や白い外観を背景に、ドリンクや料理を入れて撮る",
              ],
            ],
            hashtags: ["#BlueTurtle", "#伊良部島カフェ", "#海カフェ"],
          },
        ],
        hashtags: ["#伊良部島", "#伊良部島カフェ", "#宮古島ドライブ"],
      },
      {
        number: "02",
        title: "来間島で行きたいカフェ",
        area: "来間島 / 南国感 / 緑",
        text: "来間島は、緑に囲まれたカフェや島食材を楽しめるお店が多いエリア。来間大橋や竜宮城展望台と合わせて、ゆっくり島時間を過ごしたい日に向いています。",
        shops: [
          {
            name: "パニパニ",
            area: "来間島",
            images: [
              "https://www.instagram.com/p/DZv9p_zTjZx/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map("パニパニ 宮古島 来間島"),
            baeScore: 5,
            recommendedMenu: "南国ドリンク / スイーツ",
            businessHours: "10:00〜15:30",
            closedDays: "なし",
            text: "ジャングルのような自然に囲まれた、独特の世界観があるカフェ。ブランコ席など、写真に残したくなる演出が魅力です。",
            rows: [
              ["おすすめシーン", "来間島ドライブ / 写真撮影 / 休憩"],
              ["雰囲気", "ジャングル感 / 来間島 / 個性派"],
              ["撮影ポイント", "ブランコ席や緑を背景に撮る"],
            ],
            hashtags: ["#パニパニ", "#来間島カフェ", "#映えカフェ"],
          },
          {
            name: "島茶屋ヤッカヤッカ",
            area: "来間島",
            images: [
              "https://www.instagram.com/p/DPGKivtkw3j/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map("ヤッカヤッカ 宮古島 来間島"),
            baeScore: 1,
            recommendedMenu: "島食材ランチ",
            businessHours: "11:30〜17:00",
            closedDays: "なし",
            text: "来間島にある古民家風のカフェ。地元食材を使った料理を、静かな空間でゆっくり楽しみたい人におすすめです。",
            rows: [
              ["おすすめシーン", "ランチ / 来間島ドライブ / ゆっくり過ごす"],
              ["雰囲気", "古民家風 / 静か / 島食材"],
              ["撮影ポイント", "古民家の雰囲気と料理を一緒に撮る"],
            ],
            hashtags: ["#ヤッカヤッカ", "#来間島カフェ", "#隠れ家カフェ"],
          },
        ],
        hashtags: ["#来間島", "#来間島カフェ", "#自然カフェ"],
      },
      {
        number: "03",
        title: "池間島で行きたいカフェ",
        area: "池間島 / 海景色 / 北部ドライブ",
        text: "池間島方面は、海を眺めながら休憩できるカフェが魅力。池間大橋や北部ドライブの途中に入れると、宮古ブルーを見ながら気持ちよく過ごせます。",
        shops: [
          {
            name: "OHAMAテラス",
            area: "池間島",
            images: [
              "https://www.instagram.com/p/CGgJO1zgvUz/?igsh=anc5YXQybXExZHd1",
            ],
            mapUrl: map("OHAMAテラス 宮古島 池間島"),
            instagramLabel: "@ohama0303",
            baeScore: 5,
            recommendedMenu:
              "タコライス / トロピカルドリンク / マンゴーシャーベット",
            businessHours: "10時00分～16時30分",
            closedDays: "木曜日",
            text: "池間島の海を一望できるテラスカフェ。海風を感じられる開放的な空間で、晴れた日の写真にもぴったりです。",
            rows: [
              ["おすすめシーン", "池間島ドライブ / 海を見ながらランチ"],
              ["雰囲気", "テラス / 海景色 / 開放感"],
              ["撮影ポイント", "海を背景に、ドリンクや料理を手前に置いて撮る"],
            ],
            hashtags: ["#OHAMAテラス", "#池間島", "#テラスカフェ"],
          },
          {
            name: "gelato cafe Ninufa",
            area: "池間島",
            images: [
              "https://www.instagram.com/p/DXS9-rckT33/?img_index=7&igsh=MTN4NmdmaXlzbnhmaw==",
            ],
            mapUrl: map("gelato cafe Ninufa 宮古島 池間島"),
            baeScore: 4,
            recommendedMenu: "ジェラート",
            businessHours: "10:00～17:00",
            closedDays: "水曜日",
            text: "池間島で海を眺めながらジェラートを楽しめるカフェ。暑い日のドライブ休憩や、写真を撮りながらの寄り道にぴったりです。",
            rows: [
              ["おすすめシーン", "池間島ドライブ / 暑い日の休憩 / スイーツ"],
              ["雰囲気", "海景色 / ジェラート / ドライブ"],
              ["撮影ポイント", "海を背景にジェラートを手前に入れる"],
            ],
            hashtags: ["#Ninufa", "#池間島カフェ", "#ジェラート"],
          },
        ],
        hashtags: ["#池間島", "#池間島カフェ", "#宮古ブルー"],
      },
      {
        number: "04",
        title: "宮古島本島で行きたいカフェ",
        area: "宮古島 / 市街地 / 南部",
        text: "宮古島本島は、市街地で立ち寄りやすいお店から海が見えるカフェまで選択肢が多いエリア。予定の前後に入れやすく、雨の日や最終日にも使いやすいです。",
        shops: [
          {
            name: "島cafe とぅんからや",
            area: "宮古島南部",
            images: [
              "https://www.instagram.com/p/DaXuln0gbOj/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map("島cafe とぅんからや 宮古島"),
            instagramUrl: "https://www.instagram.com/sima_cafe_tounkaraya/",
            instagramLabel: "@sima_cafe_tounkaraya",
            baeScore: 5,
            recommendedMenu: "宮古牛タコライス",
            businessHours: "11:30〜16:00",
            closedDays: "月曜日",
            text: "高台から海を見下ろせるロケーションが魅力のカフェ。テラス席からの景色が写真映えしやすく、宮古島らしい空気感を残せます。",
            rows: [
              ["おすすめシーン", "南部ドライブ / ランチ / 絶景カフェ"],
              ["雰囲気", "海が見える / 南国感 / ゆったり"],
              ["撮影ポイント", "テラス席や海が見える角度で撮る"],
            ],
            hashtags: ["#島cafeとぅんからや", "#海カフェ", "#絶景カフェ"],
          },
          {
            name: "SHISA'S CAFE & BBQ",
            area: "宮古島",
            mapUrl: map("SHISA'S CAFE BBQ 宮古島"),
            instagramUrl: "https://www.instagram.com/shisas_cafe_bbq/",
            instagramLabel: "@shisas_cafe_bbq",
            baeScore: 4,
            recommendedMenu: "カフェメニュー / BBQ",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "宮古島本島でカフェやBBQ気分を楽しみたい時に候補に入れたいお店。友達同士や家族旅行で、食事と島らしい雰囲気を楽しみたい時におすすめです。",
            rows: [
              ["おすすめシーン", "宮古島本島 / カフェ / BBQ"],
              ["雰囲気", "カジュアル / グループ向け / 島時間"],
              ["撮影ポイント", "料理や店内の雰囲気を自然に撮る"],
            ],
            hashtags: ["#shisas_cafe_bbq", "#宮古島カフェ", "#宮古島BBQ"],
          },
          {
            name: "ブルータートルファーム マンゴーカフェ",
            area: "平良松原",
            images: [
              "https://www.instagram.com/p/DaAX9DdGXTg/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map(
              "ブルータートルファーム マンゴーカフェ 沖縄県宮古島市平良松原1760-3",
            ),
            instagramUrl: "https://www.instagram.com/blueturtlefarm_miyako/",
            instagramLabel: "@blueturtlefarm_miyako",
            baeScore: 5,
            recommendedMenu: "マンゴースイーツ",
            businessHours: "毎日 10:00〜17:30",
            closedDays: "なし",
            text: "マンゴー農園が運営するカフェ。南国らしいマンゴースイーツを楽しみたい日や、写真映えするスイーツを探している時におすすめです。",
            rows: [
              ["おすすめシーン", "宮古島本島 / スイーツ / カフェ巡り"],
              ["雰囲気", "マンゴー農園 / 南国感 / 明るいスイーツ"],
              ["撮影ポイント", "マンゴーの色味と自然光を入れて撮る"],
            ],
            hashtags: ["#マンゴーカフェ", "#宮古島マンゴー", "#宮古島カフェ"],
          },
        ],
        hashtags: ["#宮古島カフェ", "#市街地カフェ", "#絶景カフェ"],
      },
    ],
  },
  "recommend-lunch": {
    id: 2,
    slug: "recommend-lunch",
    template: "shops",
    mediaLayout: "split",
    hideBaeScore: true,
    categoryKey: "gourmet",
    category: "Gourmet",
    title: "宮古島のおすすめランチ・グルメ",
    description:
      "宮古島旅行で立ち寄りたいランチ・グルメを厳選。カレー、島食材ランチ、カフェごはん、肉料理まで、観光の合間に使いやすいお店を紹介します。",
    date: "2026.06.28",
    readTime: "7分",
    mainImage: img("v1784292789/DSC00325_htmozu.jpg"),
    leadText:
      "宮古島には、海やカフェだけでなく、ランチで立ち寄りたい魅力的なお店もたくさんあります。スパイスカレー、島食材を使ったランチ、ゆっくり過ごせるカフェごはん、しっかり食べたい肉料理まで、旅の途中で使いやすいグルメスポットをまとめました。",
    tocImage: img("v1784190360/image6_ya4nkg.webp"),
    toc: [
      "宮古島で食べたいカレー・スパイス系ランチ",
      "島時間を楽しめるカフェごはん",
      "しっかり食べたい肉・グリル系ランチ",
    ],
    points: [
      {
        number: "01",
        title: "宮古島で食べたいカレー・スパイス系ランチ",
        area: "カレー / スパイス / 個性派ランチ",
        text: "宮古島でランチに迷ったら、スパイス系のお店もおすすめ。暑い日のカレーや、旅先で少し個性的なごはんを食べたい時にぴったりです。",
        shops: [
          {
            name: "Spice & Fresh",
            area: "宮古島",
            genre: "カレー / スパイス料理",
            mapUrl: map("Spice and Fresh 宮古島"),
            instagramUrl:
              "https://www.instagram.com/p/DAia_YYT-Nb/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            instagramLabel: "",
            baeScore: 4,
            recommendedMenu: "スパイスカレー / ランチプレート",
            businessHours: "7:30〜10:30 / 11:30〜14:00（売切次第終了）",
            closedDays: "木曜日（変更の場合あり）",
            text: "スパイス感のあるランチを楽しみたい時に候補に入れたいお店。カフェ系とは違う、しっかり食べられる宮古島ランチとして使いやすいです。",
            rows: [
              ["雰囲気", "スパイス / カジュアル / ランチ"],
              ["おすすめ", "カレー / スパイス料理 / ひとりランチ"],
              ["撮影ポイント", "カレーの色味と皿全体を真上から撮る"],
            ],
            hashtags: ["#SpiceAndFresh", "#宮古島ランチ", "#宮古島カレー"],
          },
          {
            name: "Moses Curry",
            area: "宮古島",
            genre: "カレー / スパイス料理",
            mapUrl: map("Moses Curry 宮古島"),
            instagramUrl:
              "https://www.instagram.com/p/DLEUnxnxJ9D/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            instagramLabel: "",
            baeScore: 4,
            recommendedMenu: "カレー / スパイスランチ",
            businessHours: "営業日・時間はInstagramで要確認",
            closedDays: "不定休",
            text: "カレー気分の日に行きたいグルメスポット。宮古島のランチ候補として、カフェ巡りとは少し違う満足感があります。",
            rows: [
              ["雰囲気", "カレー / スパイス / ローカル感"],
              ["おすすめ", "ランチ / カレー / スパイス料理"],
              [
                "撮影ポイント",
                "カレーとサイドを一緒に入れてボリューム感を出す",
              ],
            ],
            hashtags: ["#MosesCurry", "#宮古島カレー", "#宮古島グルメ"],
          },
          {
            name: "デンみ",
            area: "宮古島",
            genre: "定食 / ローカル食堂",
            mapUrl: map("デンみ 宮古島"),
            instagramUrl:
              "https://www.instagram.com/p/Cf0TeCMPTAG/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            instagramLabel: "",
            baeScore: 3,
            recommendedMenu: "ランチ / 定食",
            businessHours:
              "11:00〜15:00 / 18:00〜23:00（L.O.22:00、日曜は22:00閉店）",
            closedDays: "月曜日",
            text: "ローカル感のあるランチ候補として入れておきたいお店。観光客向けすぎない、宮古島らしいごはんを探している時におすすめです。",
            rows: [
              ["雰囲気", "ローカル / 気軽 / ランチ"],
              ["おすすめ", "定食 / ランチ / 普段使い"],
              ["撮影ポイント", "料理を自然光でシンプルに撮る"],
            ],
            hashtags: ["#デンみ", "#宮古島ランチ", "#ローカルグルメ"],
          },
        ],
        hashtags: ["#宮古島カレー", "#スパイスランチ", "#宮古島グルメ"],
      },

      {
        number: "02",
        title: "島時間を楽しめるカフェごはん",
        area: "カフェランチ / 島食材 / ゆっくり",
        text: "観光の合間に少しゆっくりしたい時は、カフェごはん系のお店が使いやすいです。来間島ドライブや市街地散策と合わせて立ち寄りたいお店をまとめました。",
        shops: [
          {
            name: "カフェ ウエスヤ",
            area: "平良",
            genre: "カフェごはん / ランチ",
            mapUrl: map("カフェ ウエスヤ 宮古島"),
            instagramUrl:
              "https://www.instagram.com/p/DQjG_miEu2_/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            instagramLabel: "",
            baeScore: 3,
            recommendedMenu: "ランチ / 手作りごはん",
            businessHours: "11:30〜14:00 / 18:30〜22:30",
            closedDays: "水曜日・木曜日",
            text: "落ち着いた雰囲気でランチを楽しみたい時におすすめのカフェ。派手さよりも、ゆっくり食事をしたい日に合います。",
            rows: [
              ["雰囲気", "落ち着く / ローカル / カフェごはん"],
              ["おすすめ", "ランチ / ひとりごはん / ゆっくり滞在"],
              ["撮影ポイント", "料理と店内の空気感を自然に撮る"],
            ],
            hashtags: ["#ウエスヤ", "#宮古島ランチ", "#カフェごはん"],
          },
          {
            name: "島茶屋ヤッカヤッカ",
            area: "来間島",
            genre: "カフェごはん / 島食材ランチ",
            mapUrl: map("ヤッカヤッカ 宮古島 来間島"),
            instagramUrl:
              "https://www.instagram.com/p/DPGKivtkw3j/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            instagramLabel: "",
            baeScore: 3,
            recommendedMenu: "島食材ランチ",
            businessHours: "11:30〜なくなり次第終了",
            closedDays: "不定休",
            text: "来間島にある、島時間を感じられるカフェごはんスポット。ドライブ途中にゆっくりランチしたい時に使いやすいです。",
            rows: [
              ["雰囲気", "来間島 / 島時間 / ゆっくり"],
              ["おすすめ", "ランチ / 島食材 / ドライブ途中"],
              ["撮影ポイント", "料理と外の雰囲気を一緒に入れる"],
            ],
            hashtags: ["#ヤッカヤッカ", "#来間島ランチ", "#宮古島カフェ"],
          },
          {
            name: "麺屋サマー太陽",
            area: "宮古島",
            genre: "ラーメン / つけ麺",
            mapUrl: map("麺屋サマー太陽 宮古島"),
            instagramUrl:
              "https://www.instagram.com/reel/DS7HF2NE1B5/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            instagramLabel: "",
            baeScore: 3,
            recommendedMenu: "ラーメン / つけ麺",
            businessHours: "10:30〜14:30（完売次第終了）",
            closedDays: "水曜日・土曜日",
            text: "宮古島でラーメン気分の日に候補に入れたいお店。観光中のランチにも使いやすく、しっかり食べたい時におすすめです。",
            rows: [
              ["雰囲気", "ラーメン屋 / 気軽 / ランチ"],
              ["おすすめ", "ラーメン / つけ麺 / 観光途中のランチ"],
              ["撮影ポイント", "麺とスープが分かるように寄りで撮る"],
            ],
            hashtags: ["#麺屋サマー太陽", "#宮古島ラーメン", "#宮古島ランチ"],
          },
        ],
        hashtags: ["#カフェごはん", "#宮古島ランチ", "#来間島ランチ"],
      },

      {
        number: "03",
        title: "しっかり食べたい肉・グリル系ランチ",
        area: "肉料理 / グリル / 満足ランチ",
        text: "海遊びやドライブの後にしっかり食べたい時は、肉料理やグリル系のお店がおすすめ。ボリューム感のあるランチで、旅の満足度も上がります。",
        shops: [
          {
            name: "GOZERO GRILL",
            area: "宮古島",
            genre: "肉料理 / グリル",
            mapUrl: map("GOZERO GRILL 宮古島"),
            instagramUrl:
              "https://www.instagram.com/p/C6s1uSdJ8Y9/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            instagramLabel: "",
            baeScore: 4,
            recommendedMenu: "グリル料理 / 肉ランチ",
            businessHours: "7:00〜10:00 / 11:30〜14:30 / 18:00〜22:00",
            closedDays: "不定休",
            text: "しっかり肉料理を食べたい時に候補に入れたいグリル系のお店。海遊びや撮影の後のランチにも相性が良いです。",
            rows: [
              ["雰囲気", "グリル / 肉料理 / ボリューム"],
              ["おすすめ", "ランチ / ディナー / しっかり食べたい日"],
              ["撮影ポイント", "肉料理を寄りで撮ってシズル感を出す"],
            ],
            hashtags: ["#GOZEROGRILL", "#宮古島グルメ", "#宮古島ランチ"],
          },
          {
            name: "DOUG’S BURGER",
            area: "平良下里",
            genre: "ハンバーガー / 宮古牛",
            mapUrl: map("DOUG’S BURGER 宮古島"),
            instagramUrl:
              "https://www.instagram.com/p/C9XGmvLS4DD/?igsh=bnFpNnlkaXh3OWlm",
            instagramLabel: "",
            baeScore: 4,
            recommendedMenu: "宮古牛バーガー",
            businessHours: "11:00〜20:00（L.O.19:30）",
            closedDays: "なし",
            text: "宮古島で有名なグルメバーガー店。ボリュームのあるランチを楽しみたい時や、しっかり食べたい日におすすめです。",
            rows: [
              ["雰囲気", "バーガー / カジュアル / 人気店"],
              ["おすすめ", "宮古牛バーガー / ランチ"],
              ["撮影ポイント", "バーガーを寄りで撮ってボリューム感を出す"],
            ],
            hashtags: ["#DOUGSBURGER", "#宮古牛バーガー", "#宮古島ランチ"],
          },
          {
            name: "HARRY'S Shrimp Truck",
            area: "西平安名崎方面",
            genre: "ガーリックシュリンプ / フードトラック",
            mapUrl: map("HARRY'S Shrimp Truck 宮古島"),
            instagramUrl:
              "https://www.instagram.com/p/DYCYkl0EmO0/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            instagramLabel: "",
            baeScore: 5,
            recommendedMenu: "ガーリックシュリンプ",
            businessHours: "11:00〜17:00",
            closedDays: "年中無休（天候等で休業の場合あり）",
            text: "ハワイ風のフードトラックで、ガーリックシュリンプが人気。ドライブ途中に立ち寄りやすく、写真にも残しやすいグルメスポットです。",
            rows: [
              ["雰囲気", "フードトラック / ハワイ感 / カジュアル"],
              ["おすすめ", "ガーリックシュリンプ / ドライブ途中"],
              ["撮影ポイント", "トラックと料理を一緒に入れる"],
            ],
            hashtags: [
              "#HARRYSShrimpTruck",
              "#ガーリックシュリンプ",
              "#宮古島ランチ",
            ],
          },
        ],
        hashtags: ["#肉ランチ", "#宮古島グルメ", "#宮古島ランチ"],
      },
    ],
  },
  "night-dinner-top5": {
    id: 21,
    slug: "night-dinner-top5",
    template: "shops",
    mediaLayout: "split",
    hideBaeScore: true,
    categoryKey: "gourmet",
    category: "Gourmet",
    title: "宮古島の夜ご飯TOP5",
    description:
      "宮古島旅行の夜に行きたい夜ご飯のお店TOP5。島おでん、民謡居酒屋、ローカル居酒屋、宮古牛まで、初めての宮古島でも選びやすいお店を紹介します。",
    date: "2026.07.31",
    readTime: "6分",
    mainImage: img("v1784292789/DSC00325_htmozu.jpg"),
    leadText:
      "宮古島の夜は、昼間の海とはまた違う楽しさがあります。島料理をゆっくり味わえる居酒屋、三線ライブで旅気分が上がるお店、宮古牛をしっかり楽しめる焼肉店まで、旅行中の夜ご飯で候補に入れたいお店を5つに絞って紹介します。人気店は混みやすいので、行きたいお店は早めの予約がおすすめです。",
    tocImage: img("v1784292789/DSC00325_htmozu.jpg"),
    toc: [
      "宮古島らしい島料理を楽しむ夜ご飯",
      "にぎやかに楽しめる居酒屋",
      "宮古牛・肉料理で満足する夜",
    ],
    points: [
      {
        number: "01",
        title: "宮古島らしい島料理を楽しむ夜ご飯",
        area: "島料理 / 居酒屋 / 初日の夜",
        text: "初めての宮古島なら、まずは島料理を味わえるお店がおすすめ。泡盛や沖縄料理と一緒に、旅の夜らしい時間を過ごせます。",
        shops: [
          {
            name: "島おでんたから",
            area: "平良",
            genre: "島おでん / 沖縄料理 / 居酒屋",
            mapUrl: map("島おでんたから 宮古島"),
            recommendedMenu: "島おでん / てびち / 沖縄料理",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "宮古島の夜ご飯で外せない定番候補。島おでんや沖縄料理をゆっくり味わいたい時におすすめです。",
            rows: [
              ["雰囲気", "ローカル / 人気店 / 島料理"],
              ["おすすめ", "初日の夜 / 島料理 / 居酒屋"],
              ["注意", "人気店のため早めの予約がおすすめ"],
            ],
            hashtags: ["#島おでんたから", "#宮古島グルメ", "#夜ご飯"],
          },
          {
            name: "うまりずま",
            area: "平良",
            genre: "民謡居酒屋 / 島料理",
            mapUrl: map("うまりずま 宮古島"),
            recommendedMenu: "島料理 / 泡盛 / 居酒屋メニュー",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "宮古島らしい雰囲気で夜ご飯を楽しみたい時に候補に入れたいお店。島料理とお酒を一緒に楽しめます。",
            rows: [
              ["雰囲気", "民謡居酒屋 / にぎやか / 旅気分"],
              ["おすすめ", "友達旅行 / 島料理 / 宮古島の夜"],
              ["注意", "ライブや混雑状況は事前確認がおすすめ"],
            ],
            hashtags: ["#うまりずま", "#宮古島グルメ", "#夜遊び"],
          },
        ],
        hashtags: ["#島料理", "#宮古島グルメ", "#夜ご飯"],
      },
      {
        number: "02",
        title: "にぎやかに楽しめる居酒屋",
        area: "居酒屋 / 夜遊び / グループ旅行",
        text: "ご飯だけでなく、宮古島の夜の雰囲気まで楽しみたい人には居酒屋がおすすめ。食事後のバーや夜カフェにもつなげやすいです。",
        shops: [
          {
            name: "美ら島",
            area: "平良",
            genre: "民謡居酒屋 / 島料理",
            mapUrl: map("美ら島 宮古島 民謡居酒屋"),
            recommendedMenu: "島料理 / 民謡ライブ / 泡盛",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "三線や島唄の雰囲気を楽しみたい夜におすすめ。旅行らしい夜ご飯にしたい時に選びやすいお店です。",
            rows: [
              ["雰囲気", "民謡ライブ / 観光向け / にぎやか"],
              ["おすすめ", "グループ旅行 / 初宮古島 / 夜遊び前"],
              ["注意", "ライブ時間と席の空きは事前確認がおすすめ"],
            ],
            hashtags: ["#美ら島", "#宮古島グルメ", "#夜遊び"],
          },
          {
            name: "でいりぐち",
            area: "平良",
            genre: "居酒屋 / 島料理",
            mapUrl: map("でいりぐち 宮古島"),
            recommendedMenu: "島料理 / 居酒屋メニュー",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "気軽に宮古島の夜ご飯を楽しみたい時に候補に入れたい居酒屋。旅の予定に組み込みやすい一軒です。",
            rows: [
              ["雰囲気", "カジュアル / 居酒屋 / 食事しやすい"],
              ["おすすめ", "友達旅行 / 夜ご飯 / 2軒目前"],
              ["注意", "混雑する日もあるため予約がおすすめ"],
            ],
            hashtags: ["#でいりぐち", "#宮古島居酒屋", "#夜ご飯"],
          },
        ],
        hashtags: ["#宮古島居酒屋", "#夜遊び", "#宮古島グルメ"],
      },
      {
        number: "03",
        title: "宮古牛・肉料理で満足する夜",
        area: "焼肉 / 宮古牛 / 特別な夜",
        text: "しっかり食べたい夜や、少し特別感を出したい日は肉料理もおすすめ。海で遊んだ後の夜ご飯にも相性が良いです。",
        shops: [
          {
            name: "焼肉喜八",
            area: "平良",
            genre: "焼肉 / 宮古牛",
            mapUrl: map("焼肉喜八 宮古島"),
            recommendedMenu: "焼肉 / 宮古牛",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "宮古島で焼肉を食べたい夜に候補に入れたいお店。旅の夜ご飯をしっかり満足させたい時におすすめです。",
            rows: [
              ["雰囲気", "焼肉 / しっかりご飯 / 特別感"],
              ["おすすめ", "宮古牛 / ディナー / ご褒美ごはん"],
              ["注意", "人気店のため早めの予約がおすすめ"],
            ],
            hashtags: ["#焼肉喜八", "#宮古牛", "#宮古島グルメ"],
          },
        ],
        hashtags: ["#宮古牛", "#焼肉", "#宮古島ディナー"],
      },
    ],
  },
  "miyakojima-yakiniku-top3": {
    id: 23,
    slug: "miyakojima-yakiniku-top3",
    template: "shops",
    mediaLayout: "split",
    hideBaeScore: true,
    categoryKey: "gourmet",
    category: "Gourmet",
    title: "宮古島焼肉店TOP3",
    description:
      "宮古島旅行の夜に行きたい焼肉店TOP3。宮古牛をしっかり楽しめる人気店を、価格帯の目安つきで紹介します。",
    date: "2026.07.31",
    readTime: "5分",
    mainImage: img("v1784292789/DSC00325_htmozu.jpg"),
    leadText:
      "海で遊んだ日の夜や、少し特別なディナーにしたい日は焼肉がおすすめです。宮古牛を楽しめるお店、落ち着いて食事しやすいお店、グループ旅行で使いやすいお店をTOP3でまとめました。価格帯は目安なので、最新メニューや営業状況は来店前に確認してください。",
    tocImage: img("v1784292789/DSC00325_htmozu.jpg"),
    toc: ["1位：焼肉なかお", "2位：焼肉喜八", "3位：焼武者"],
    points: [
      {
        number: "01",
        title: "1位：焼肉なかお",
        area: "宮古牛 / 特別な夜 / 人気店",
        text: "宮古牛をしっかり楽しみたい夜に候補に入れたい焼肉店。旅行のディナーを少し贅沢にしたい時や、記念日・女子旅の夜にも使いやすい一軒です。",
        shops: [
          {
            name: "焼肉なかお",
            area: "平良",
            genre: "焼肉 / 宮古牛",
            mapUrl: map("焼肉なかお 宮古島"),
            recommendedMenu: "宮古牛 / 盛り合わせ",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "宮古牛の盛り合わせを中心に、しっかり焼肉を楽しみたい人向け。人気店なので早めの予約がおすすめです。",
            rows: [
              ["価格帯", "目安 ¥8,000〜¥12,000 / 1名"],
              ["おすすめ", "宮古牛 / 記念日 / しっかりディナー"],
              ["注意", "価格や営業日は来店前に要確認"],
            ],
            hashtags: ["#焼肉なかお", "#宮古牛", "#焼肉"],
          },
        ],
        hashtags: ["#宮古牛", "#焼肉", "#宮古島グルメ"],
      },
      {
        number: "02",
        title: "2位：焼肉喜八",
        area: "宮古牛 / ご褒美ごはん / 市街地",
        text: "宮古島で焼肉を食べたい時に名前が上がりやすい人気店。旅の夜ご飯をしっかり満足させたい時におすすめです。",
        shops: [
          {
            name: "焼肉喜八",
            area: "平良",
            genre: "焼肉 / 宮古牛",
            mapUrl: map("焼肉喜八 宮古島"),
            recommendedMenu: "焼肉 / 宮古牛 / 冷麺",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "観光の夜にも組み込みやすい焼肉店。宮古牛を楽しみつつ、サイドメニューまでゆっくり味わいたい人に向いています。",
            rows: [
              ["価格帯", "目安 ¥5,000〜¥9,000 / 1名"],
              ["おすすめ", "宮古牛 / 友達旅行 / 夜ご飯"],
              ["注意", "人気店のため予約がおすすめ"],
            ],
            hashtags: ["#焼肉喜八", "#宮古牛", "#夜ご飯"],
          },
        ],
        hashtags: ["#宮古牛", "#宮古島ディナー", "#焼肉"],
      },
      {
        number: "03",
        title: "3位：焼武者",
        area: "焼肉 / 大人旅 / しっかりご飯",
        text: "落ち着いて焼肉を楽しみたい夜に候補に入れたいお店。海やツアーの後に、ゆっくり食事をしたい人におすすめです。",
        shops: [
          {
            name: "焼武者",
            area: "平良",
            genre: "焼肉 / ディナー",
            mapUrl: map("焼武者 宮古島"),
            recommendedMenu: "焼肉 / 肉料理",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "少し落ち着いた焼肉ディナーにしたい時の候補。混雑日もあるため、旅行日程が決まったら早めに確認しておくと安心です。",
            rows: [
              ["価格帯", "目安 ¥8,000〜¥10,000 / 1名"],
              ["おすすめ", "焼肉 / 大人旅 / ご褒美ごはん"],
              ["注意", "営業時間・定休日は事前確認がおすすめ"],
            ],
            hashtags: ["#焼武者", "#焼肉", "#宮古島グルメ"],
          },
        ],
        hashtags: ["#焼肉", "#宮古島グルメ", "#夜ご飯"],
      },
    ],
  },
  "miyakojima-gelato-best5": {
    id: 22,
    slug: "miyakojima-gelato-best5",
    template: "shops",
    mediaLayout: "split",
    hideBaeScore: true,
    categoryKey: "gourmet",
    category: "Gourmet",
    title: "宮古島でジェラート食べるならここ5選",
    description:
      "宮古島旅行で立ち寄りたいジェラート・アイスのお店5選。リッコジェラート、Ninufa、ブルーシール、雪塩ミュージアム、ななみカフェを紹介します。",
    date: "2026.07.31",
    readTime: "5分",
    mainImage: img(
      "v1783352339/AD_4nXf2yA3puqm63h-XEHfk_ltPQ-m0Sy4IQCU-m0yCaojShxZt7-CDQQ1B8UUjJ5iQC-szsuwzS9Vq4ScPOBElN52vu_oxEkcKu2UbdK-gsQe_WVuQKT9E9iGjaVqKC7vIMduz6M-_ylvli6.png",
    ),
    leadText:
      "宮古島の暑い日やドライブ途中に食べたくなるのが、冷たいジェラートやアイス。市街地で行きやすい人気店、池間島や伊良部島ドライブで寄りたいお店、宮古島らしい素材を楽しめるスポットまで、旅行中に立ち寄りやすい5店をまとめました。",
    tocImage: img(
      "v1783352339/AD_4nXf2yA3puqm63h-XEHfk_ltPQ-m0Sy4IQCU-m0yCaojShxZt7-CDQQ1B8UUjJ5iQC-szsuwzS9Vq4ScPOBElN52vu_oxEkcKu2UbdK-gsQe_WVuQKT9E9iGjaVqKC7vIMduz6M-_ylvli6.png",
    ),
    toc: [
      "市街地で行きやすいジェラート",
      "ドライブ途中に寄りたいアイス",
      "宮古島らしい素材を楽しむスイーツ",
    ],
    points: [
      {
        number: "01",
        title: "市街地で行きやすいジェラート",
        area: "平良 / 食後のデザート / 街歩き",
        text: "夜ご飯の後や市街地散策の途中に寄りやすいお店。ホテルが平良周辺なら、旅程に入れやすいのが魅力です。",
        shops: [
          {
            name: "リッコジェラート",
            area: "平良",
            genre: "ジェラート / カフェ",
            mapUrl: map("リッコジェラート 宮古島"),
            recommendedMenu: "ジェラート / 島素材フレーバー",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "火曜日・水曜日の場合あり",
            text: "宮古島のジェラートでまず候補に入れたい人気店。島素材を使ったフレーバーを楽しみたい人におすすめです。",
            rows: [
              ["雰囲気", "市街地 / 人気店 / 食後のデザート"],
              ["おすすめ", "ジェラート / 街歩き / スイーツ"],
              ["注意", "営業時間や定休日は事前確認がおすすめ"],
            ],
            hashtags: ["#リッコジェラート", "#ジェラート", "#宮古島スイーツ"],
          },
          {
            name: "ブルーシール 宮古島パイナガマ店",
            area: "パイナガマ周辺",
            genre: "アイスクリーム / スイーツ",
            mapUrl: map("ブルーシール 宮古島パイナガマ店"),
            recommendedMenu: "ブルーシールアイス / ドリンク",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "パイナガマビーチ周辺で立ち寄りやすいアイス店。海帰りや雨の日の休憩にも使いやすいスポットです。",
            rows: [
              ["雰囲気", "カラフル / 海近く / 立ち寄りやすい"],
              ["おすすめ", "アイス / パイナガマ散策 / 家族旅行"],
              ["撮影ポイント", "カラフルなアイスと店内を一緒に撮る"],
            ],
            hashtags: ["#ブルーシール", "#宮古島スイーツ", "#パイナガマ"],
          },
        ],
        hashtags: ["#ジェラート", "#宮古島スイーツ", "#市街地"],
      },
      {
        number: "02",
        title: "ドライブ途中に寄りたいアイス",
        area: "池間島 / 伊良部島 / ドライブ",
        text: "海を見に行く日の途中に寄りたいスイーツスポット。暑い日の休憩にも、写真を残す寄り道にもぴったりです。",
        shops: [
          {
            name: "Ikemajima gelato cafe Ninufa",
            area: "池間島",
            genre: "ジェラート / カフェ",
            mapUrl: map("Ikemajima gelato cafe Ninufa 宮古島"),
            recommendedMenu: "ジェラート",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "水曜日の場合あり",
            text: "池間島ドライブで寄りたいジェラートカフェ。海を見に行く流れで立ち寄りやすく、暑い日の休憩にぴったりです。",
            rows: [
              ["雰囲気", "池間島 / ドライブ / 海の近く"],
              ["おすすめ", "ジェラート / 池間島方面 / 休憩"],
              ["撮影ポイント", "ジェラートと海ドライブの雰囲気を一緒に残す"],
            ],
            hashtags: ["#Ninufa", "#池間島カフェ", "#ジェラート"],
          },
          {
            name: "ななみカフェ",
            area: "伊良部島",
            genre: "スイーツ / ジェラート",
            mapUrl: map("ななみカフェ 宮古島 伊良部島"),
            recommendedMenu: "ジェラート / スイーツ",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "火曜日・金曜日の場合あり",
            text: "伊良部島ドライブの途中で甘いものを食べたい時に候補に入れたいカフェ。橋を渡る日の寄り道に使いやすいです。",
            rows: [
              ["雰囲気", "伊良部島 / スイーツ / ドライブ休憩"],
              ["おすすめ", "ジェラート / カフェ休憩 / 伊良部島"],
              ["注意", "営業日は事前確認がおすすめ"],
            ],
            hashtags: ["#ななみカフェ", "#伊良部島カフェ", "#宮古島スイーツ"],
          },
        ],
        hashtags: ["#池間島", "#伊良部島", "#宮古島ドライブ"],
      },
      {
        number: "03",
        title: "宮古島らしい素材を楽しむスイーツ",
        area: "雪塩 / 島素材 / お土産",
        text: "宮古島らしい素材を楽しむなら、雪塩や島の食材を使ったスイーツもおすすめ。観光と一緒に組み込みやすいスポットです。",
        shops: [
          {
            name: "雪塩ミュージアム",
            area: "宮古島北部",
            genre: "ソフトクリーム / お土産",
            mapUrl: map("雪塩ミュージアム 宮古島"),
            recommendedMenu: "雪塩ソフトクリーム",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "雪塩ソフトクリームを楽しめる観光スポット。西平安名崎や池間島方面のドライブと合わせて寄りやすいです。",
            rows: [
              ["雰囲気", "観光 / お土産 / ソフトクリーム"],
              ["おすすめ", "雪塩ソフト / 北部ドライブ / 休憩"],
              ["撮影ポイント", "ソフトクリームと青空を一緒に撮る"],
            ],
            hashtags: ["#雪塩ミュージアム", "#雪塩ソフト", "#宮古島スイーツ"],
          },
        ],
        hashtags: ["#雪塩", "#宮古島スイーツ", "#ドライブ"],
      },
    ],
  },

  "miyakojima-sweets-best14": {
    id: 24,
    slug: "miyakojima-sweets-best14",
    template: "shops",
    mediaLayout: "split",
    categoryKey: "gourmet",
    category: "Gourmet",
    title: "宮古島スイーツ特集 14選",
    description:
      "宮古島旅行で立ち寄りたいスイーツ店14選。スムージー、マンゴースイーツ、さたぱんびん、ブルーシール、ドーナツ、クレープ、カフェスイーツまでまとめて紹介します。",
    date: "2026.07.31",
    readTime: "8分",
    mainImage: img("v1784690818/23_mbegc4.png"),
    leadText:
      "宮古島には、海遊びやドライブの合間に立ち寄りたいスイーツ店がたくさんあります。マンゴー、スムージー、さたぱんびん、アイス、ドーナツ、クレープ、カフェスイーツまで、旅の途中で甘いものを楽しみたい時におすすめのお店をまとめました。",
    tocImage: img("v1784690818/23_mbegc4.png"),
    toc: ["宮古島スイーツ特集 14選"],
    points: [
      {
        number: "01",
        title: "宮古島スイーツ特集 14選",
        area: "スムージー / マンゴー / さたぱんびん / カフェ",
        text: "市街地で行きやすいお店から、伊良部島・池間島ドライブで寄りたいお店まで、宮古島旅行中に甘いものを楽しめるスポットをまとめました。",
        shops: [
          {
            name: "EIGHT smoothie's",
            area: "平良西仲宗根",
            mapUrl: map("EIGHT smoothie's 沖縄県宮古島市平良西仲宗根460-5"),
            instagramUrl: "https://www.instagram.com/8renta_miyakojima/",
            instagramLabel: "@8renta_miyakojima",
            genre: "スムージー / スイーツ",
            recommendedMenu: "スムージー",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "市街地周辺でスムージーを楽しみたい時に立ち寄りたいお店。ドライブ前後の休憩にも使いやすいです。",
            rows: [["住所", "沖縄県宮古島市平良西仲宗根460-5"]],
            hashtags: ["#宮古島スイーツ", "#スムージー", "#宮古島カフェ"],
          },
          {
            name: "Su She Maro",
            area: "平良下里",
            mapUrl: map("Su She Maro 沖縄県宮古島市平良下里510-6"),
            instagramUrl: "https://www.instagram.com/sushemaro/",
            instagramLabel: "@sushemaro",
            genre: "スイーツ / カフェ",
            recommendedMenu: "スイーツ",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "平良エリアで甘いものを楽しみたい時に候補に入れたいお店。市街地散策の途中にも寄りやすいです。",
            rows: [["住所", "沖縄県宮古島市平良下里510-6"]],
            hashtags: ["#SuSheMaro", "#宮古島スイーツ", "#宮古島カフェ"],
          },
          {
            name: "ブルータートルファーム マンゴーカフェ",
            area: "平良松原",
            mapUrl: map(
              "ブルータートルファーム マンゴーカフェ 沖縄県宮古島市平良松原1760-3",
            ),
            images: [
              "https://www.instagram.com/p/DaAX9DdGXTg/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            instagramUrl: "https://www.instagram.com/blueturtlefarm_miyako/",
            instagramLabel: "@blueturtlefarm_miyako",
            genre: "マンゴー / カフェ",
            recommendedMenu: "マンゴースイーツ",
            businessHours: "毎日 10:00〜17:30",
            closedDays: "なし",
            text: "マンゴー系スイーツを楽しみたい時にチェックしたいカフェ。販売状況は季節や投稿で変わるため、来店前に確認がおすすめです。",
            rows: [
              ["住所", "沖縄県宮古島市平良松原1760-3"],
              [
                "メモ",
                "現在は上のマンゴーが載っていないバージョンで販売の場合あり",
              ],
            ],
            hashtags: ["#マンゴーカフェ", "#宮古島マンゴー", "#宮古島スイーツ"],
          },
          {
            name: "ぶーずやー",
            area: "伊良部島",
            mapUrl: map("ぶーずやー 沖縄県宮古島市伊良部伊良部1396"),
            instagramUrl: "https://www.instagram.com/bu_zuya_/",
            instagramLabel: "@bu_zuya_",
            genre: "スイーツ / 島のおやつ",
            recommendedMenu: "スイーツ",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "伊良部島ドライブ中に甘いものを楽しみたい時に候補に入れたいお店。島時間を感じながら立ち寄れます。",
            rows: [["住所", "沖縄県宮古島市伊良部伊良部1396"]],
            hashtags: ["#ぶーずやー", "#伊良部島グルメ", "#宮古島スイーツ"],
          },
          {
            name: "七福さたぱんびん",
            area: "平良西里",
            mapUrl: map("七福さたぱんびん 沖縄県宮古島市平良西里274-1"),
            instagramUrl: "https://www.instagram.com/7729_sou/",
            instagramLabel: "@7729_sou",
            genre: "さたぱんびん / 島のおやつ",
            recommendedMenu: "さたぱんびん",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "宮古島らしいおやつを食べたい時におすすめ。街歩きやお土産探しの途中にも立ち寄りやすいです。",
            rows: [["住所", "沖縄県宮古島市平良西里274-1"]],
            hashtags: ["#七福さたぱんびん", "#さたぱんびん", "#宮古島スイーツ"],
          },
          {
            name: "Shirabari mango factory",
            area: "平良西仲宗根",
            mapUrl: map(
              "Shirabari mango factory 沖縄県宮古島市平良西仲宗根742-3",
            ),
            instagramUrl: "https://www.instagram.com/shirabarimango/",
            instagramLabel: "@shirabarimango",
            genre: "マンゴー / スイーツ",
            recommendedMenu: "マンゴースイーツ",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "宮古島のマンゴーを楽しみたい時にチェックしたいお店。季節限定メニューは事前確認がおすすめです。",
            rows: [["住所", "沖縄県宮古島市平良西仲宗根742-3"]],
            hashtags: ["#shirabarimango", "#宮古島マンゴー", "#宮古島スイーツ"],
          },
          {
            name: "ブルーシール 宮古島パイナガマ",
            area: "平良久貝",
            mapUrl: map(
              "ブルーシール 宮古島パイナガマ 沖縄県宮古島市平良久貝654-23",
            ),
            instagramUrl: "https://www.instagram.com/blueseal_painagama/",
            instagramLabel: "@blueseal_painagama",
            genre: "アイスクリーム",
            recommendedMenu: "ブルーシールアイス",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "パイナガマ周辺で立ち寄りやすいアイス店。海帰りやドライブ途中の休憩にもぴったりです。",
            rows: [["住所", "沖縄県宮古島市平良久貝654-23"]],
            hashtags: ["#ブルーシール", "#パイナガマ", "#宮古島スイーツ"],
          },
          {
            name: "海美来",
            area: "池間島",
            mapUrl: map("海美来 沖縄県宮古島市平良池間1173-7"),
            genre: "売店 / 島スイーツ",
            recommendedMenu: "ドライブ休憩のスイーツ",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "池間島ドライブの途中に立ち寄りやすいスポット。海を見に行く日の休憩にも使いやすいです。",
            rows: [["住所", "沖縄県宮古島市平良池間1173-7"]],
            hashtags: ["#海美来", "#池間島", "#宮古島スイーツ"],
          },
          {
            name: "ensemble coffee",
            area: "平良久貝",
            mapUrl: map(
              "ensemble coffee 沖縄県宮古島市平良久貝1068-9 中山店舗1-西",
            ),
            instagramUrl:
              "https://www.instagram.com/ensemblecoffee.miyakoisland/",
            instagramLabel: "@ensemblecoffee.miyakoisland",
            genre: "コーヒー / カフェスイーツ",
            recommendedMenu: "コーヒー / カフェスイーツ",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "コーヒーと一緒に甘いものを楽しみたい時におすすめ。落ち着いたカフェ時間を過ごしたい日に向いています。",
            rows: [["住所", "沖縄県宮古島市平良久貝1068-9 中山店舗1-西"]],
            hashtags: ["#ensemblecoffee", "#宮古島カフェ", "#宮古島スイーツ"],
          },
          {
            name: "バーニーズクレープ",
            area: "平良西里",
            mapUrl: map("バーニーズクレープ 沖縄県宮古島市平良西里251-10"),
            instagramUrl: "https://www.instagram.com/berniescrepe/",
            instagramLabel: "@berniescrepe",
            genre: "クレープ",
            recommendedMenu: "クレープ",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "街歩き中にクレープを楽しみたい時に立ち寄りたいお店。食べ歩きスイーツにもおすすめです。",
            rows: [["住所", "沖縄県宮古島市平良西里251-10"]],
            hashtags: ["#バーニーズクレープ", "#クレープ", "#宮古島スイーツ"],
          },
          {
            name: "ニンギン珈琲",
            area: "平良久貝",
            mapUrl: map("ニンギン珈琲 沖縄県宮古島市平良久貝670-4 1階"),
            instagramUrl: "https://www.instagram.com/ningincoffee_ninginkukan/",
            instagramLabel: "@ningincoffee_ninginkukan",
            genre: "コーヒー / カフェ",
            recommendedMenu: "コーヒー / カフェスイーツ",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "コーヒーと一緒にゆっくり過ごしたい時におすすめ。旅の合間の休憩にも使いやすいカフェです。",
            rows: [["住所", "沖縄県宮古島市平良久貝670-4 1階"]],
            hashtags: ["#ニンギン珈琲", "#宮古島カフェ", "#宮古島スイーツ"],
          },
          {
            name: "LB CAFE",
            area: "平良西里",
            mapUrl: map("LB CAFE 沖縄県宮古島市平良西里1886-1"),
            instagramUrl: "https://www.instagram.com/lb_cafe_1886/",
            instagramLabel: "@lb_cafe_1886",
            genre: "カフェ / スイーツ",
            recommendedMenu: "カフェスイーツ",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "宮古島本島でカフェ休憩したい時に候補に入れたいお店。ドライブ途中にも立ち寄りやすいです。",
            rows: [["住所", "沖縄県宮古島市平良西里1886-1"]],
            hashtags: ["#LBCAFE", "#宮古島カフェ", "#宮古島スイーツ"],
          },
          {
            name: "島cafeとぅんからや",
            area: "上野新里",
            mapUrl: map("島cafeとぅんからや 沖縄県宮古島市上野新里1214"),
            instagramUrl: "https://www.instagram.com/sima_cafe_tounkaraya/",
            instagramLabel: "@sima_cafe_tounkaraya",
            genre: "絶景カフェ / スイーツ",
            recommendedMenu: "カフェスイーツ / ドリンク",
            businessHours: "11:30〜16:00",
            closedDays: "月曜日",
            text: "海を見下ろせるロケーションが魅力のカフェ。景色もスイーツも楽しみたい日におすすめです。",
            rows: [["住所", "沖縄県宮古島市上野新里1214"]],
            hashtags: ["#島cafeとぅんからや", "#絶景カフェ", "#宮古島スイーツ"],
          },
          {
            name: "Burwood Donuts",
            area: "平良下里",
            mapUrl: map("Burwood Donuts 沖縄県宮古島市平良下里816-2"),
            instagramUrl: "https://www.instagram.com/burwood_donuts/",
            instagramLabel: "@burwood_donuts",
            genre: "ドーナツ",
            recommendedMenu: "ドーナツ",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "ドーナツ好きならチェックしたいお店。市街地周辺で甘いものを買いたい時にも便利です。",
            rows: [["住所", "沖縄県宮古島市平良下里816-2"]],
            hashtags: ["#BurwoodDonuts", "#ドーナツ", "#宮古島スイーツ"],
          },
        ],
        hashtags: ["#宮古島スイーツ", "#宮古島カフェ", "#宮古島グルメ"],
      },
    ],
  },
  "recommend-soba": {
    id: 3,
    slug: "recommend-soba",
    template: "shops",
    mediaLayout: "split",
    categoryKey: "gourmet",
    category: "Gourmet",
    title: "宮古そばの名店5選",
    description:
      "宮古島旅行で一度は食べたい宮古そばの名店5選。市街地で行きやすいお店から、ドライブ中に立ち寄りたいお店まで紹介します。",
    date: "2026.06.28",
    readTime: "7分",
    mainImage: img("v1784689797/soba_yyrxly.jpg"),
    leadText:
      "宮古島グルメで外せないのが、島のソウルフード「宮古そば」。あっさりした出汁、ストレート麺、三枚肉やかまぼこが入った一杯は、観光の合間のランチにもぴったりです。今回は、市街地やドライブ中に立ち寄りやすい名店を5つに絞って紹介します。",
    tocImage: img("v1784689797/soba_yyrxly.jpg"),
    featuredShopNames: [
      "古謝そば屋",
      "お食事処 じんく屋",
      "にいまそば",
      "くになか食堂",
      "丸吉食堂",
    ],
    toc: [
      "平良市街地で行きやすい宮古そば",
      "北部・池間方面で寄りたい宮古そば",
      "南部・城辺方面で食べたい宮古そば",
    ],
    points: [
      {
        number: "01",
        title: "平良市街地で行きやすい宮古そば",
        area: "平良 / 市街地 / 空港からも行きやすい",
        text: "宮古島の中心地・平良エリアで行きやすい宮古そば。到着日や帰る前、天気が悪い日、ホテル周辺でランチを探したい時にも使いやすいエリアです。",
        shops: [
          {
            name: "古謝そば屋",
            area: "平良下里",
            images: [img("v1782544105/%EF%BC%91%EF%BC%91_j8gtip.jpg")],
            mapUrl: map("古謝そば屋 宮古島"),
            instagramUrl: "",
            instagramLabel: "",
            recommendedMenu: "宮古そば / ソーキそば / 古謝そば",
            businessHours: "要確認",
            closedDays: "要確認",
            text: "宮古そばの定番として外せない人気店。市街地からもアクセスしやすく、初めて宮古そばを食べる人にもおすすめです。",
            rows: [
              ["昼の混雑度", lunchCrowd.high],
              ["雰囲気", "定番 / 清潔感 / 観光でも入りやすい"],
              ["おすすめ", "宮古そば / ソーキそば / 初めての宮古そば"],
            ],
            hashtags: ["#古謝そば屋", "#宮古そば", "#宮古島ランチ"],
          },
          {
            name: "お食事処 じんく屋",
            area: "平良下里",
            images: [img("v1782544103/%EF%BC%99_nk1ewv.jpg")],
            mapUrl: map("お食事処 じんく屋 宮古島"),
            instagramUrl: "",
            instagramLabel: "",
            recommendedMenu: "宮古そば / 定食",
            businessHours: "要確認",
            closedDays: "要確認",
            text: "市街地から行きやすいローカル食堂。宮古そばだけでなく定食系もあるので、しっかり食べたいランチにも使いやすいです。",
            rows: [
              ["昼の混雑度", lunchCrowd.medium],
              ["雰囲気", "ローカル / 食堂 / 気軽"],
              ["おすすめ", "宮古そば / 定食 / 普段使いランチ"],
            ],
            hashtags: ["#じんく屋", "#宮古そば", "#宮古島ランチ"],
          },
          {
            name: "菊栄食堂",
            area: "平良西里",
            images: [img("v1782544346/DJI_20260619092553_0013_D_mggybx.jpg")],
            mapUrl: map("菊栄食堂 宮古島"),
            instagramUrl: "",
            instagramLabel: "",
            recommendedMenu: "宮古そば / 食堂メニュー",
            businessHours: "要確認",
            closedDays: "要確認",
            text: "昔ながらの食堂感が魅力のお店。観光向けすぎない雰囲気で、ローカルな宮古そばランチを楽しみたい人に合います。",
            rows: [
              ["昼の混雑度", lunchCrowd.medium],
              ["雰囲気", "レトロ / 食堂 / ローカル"],
              ["おすすめ", "宮古そば / 早めのランチ / 地元感"],
            ],
            hashtags: ["#菊栄食堂", "#宮古そば", "#宮古島食堂"],
          },
        ],
        hashtags: ["#平良ランチ", "#宮古そば", "#宮古島市街地"],
      },

      {
        number: "02",
        title: "北部・池間方面で寄りたい宮古そば",
        area: "狩俣 / 池間島方面 / 北部ドライブ",
        text: "池間島や西平安名崎方面へドライブする日に寄りやすい宮古そば。観光スポットとセットでランチを組みやすいエリアです。",
        shops: [
          {
            name: "にいまそば",
            area: "平良狩俣",
            images: [img("v1782544103/%EF%BC%99_nk1ewv.jpg")],
            mapUrl: map("にいまそば 宮古島"),
            instagramUrl: "https://www.instagram.com/niimasoba/",
            instagramLabel: "@niimasoba",
            recommendedMenu: "宮古そば",
            businessHours: "要確認",
            closedDays: "要確認",
            text: "狩俣エリアにある人気の宮古そば店。池間島方面へ行く前後に立ち寄りやすく、北部ドライブの日にぴったりです。",
            rows: [
              ["昼の混雑度", lunchCrowd.high],
              ["雰囲気", "北部 / ドライブ / 落ち着く"],
              ["おすすめ", "宮古そば / 池間島方面のランチ"],
            ],
            hashtags: ["#にいまそば", "#宮古そば", "#池間島ドライブ"],
          },
          {
            name: "お食事処 すむばり",
            area: "平良狩俣",
            images: [img("v1782544105/%EF%BC%91%EF%BC%91_j8gtip.jpg")],
            mapUrl: map("お食事処 すむばり 宮古島"),
            instagramUrl: "",
            instagramLabel: "",
            recommendedMenu: "すむばりそば / ソーキそば / タコ丼",
            businessHours: "要確認",
            closedDays: "要確認",
            text: "池間大橋方面へ向かう途中に立ち寄りやすい食堂。タコ料理やそば系メニューもあり、北部ドライブの日に使いやすいです。",
            rows: [
              ["昼の混雑度", lunchCrowd.medium],
              ["雰囲気", "食堂 / 北部ドライブ / ローカル"],
              ["おすすめ", "すむばりそば / タコ丼 / ドライブ途中"],
            ],
            hashtags: ["#すむばり", "#宮古そば", "#池間島ドライブ"],
          },
          {
            name: "くになか食堂",
            area: "平良東仲宗根",
            images: [img("v1782544346/DJI_20260619092553_0013_D_mggybx.jpg")],
            mapUrl: map("くになか食堂 宮古島"),
            instagramUrl: "https://www.instagram.com/kuninaka1982/",
            instagramLabel: "@kuninaka1982",
            recommendedMenu: "宮古そば / てんぷら",
            businessHours: "要確認",
            closedDays: "要確認",
            text: "宮古そばとてんぷらを楽しめるローカル食堂。北部方面へ向かう前のランチや、市街地から少し外れた場所で食べたい時に候補に入れたいお店です。",
            rows: [
              ["昼の混雑度", lunchCrowd.high],
              ["雰囲気", "ローカル / てんぷら / 食堂"],
              ["おすすめ", "宮古そば / てんぷら / 気軽なランチ"],
            ],
            hashtags: ["#くになか食堂", "#宮古そば", "#宮古島てんぷら"],
          },
        ],
        hashtags: ["#北部ドライブ", "#池間島ランチ", "#宮古そば"],
      },

      {
        number: "03",
        title: "南部・城辺方面で食べたい宮古そば",
        area: "城辺 / 上野 / 南部ドライブ",
        text: "東平安名崎やシギラ方面、南部ドライブの日に立ち寄りたい宮古そば。市街地から少し離れた場所で、宮古島らしい食堂ランチを楽しめます。",
        shops: [
          {
            name: "丸吉食堂",
            area: "城辺砂川",
            images: [img("v1782544103/%EF%BC%99_nk1ewv.jpg")],
            mapUrl: map("丸吉食堂 宮古島"),
            instagramUrl: "",
            instagramLabel: "",
            recommendedMenu: "宮古そば / ソーキそば",
            businessHours: "要確認",
            closedDays: "要確認",
            text: "昔ながらの雰囲気が残る宮古そばの名店。にんにくの効いたスープが特徴で、しっかり印象に残る一杯を食べたい人におすすめです。",
            rows: [
              ["昼の混雑度", lunchCrowd.high],
              ["雰囲気", "老舗 / ローカル / 昔ながら"],
              ["おすすめ", "宮古そば / ソーキそば / しっかり味"],
            ],
            hashtags: ["#丸吉食堂", "#宮古そば", "#宮古島グルメ"],
          },
          {
            name: "宮古そば まっすぐ",
            area: "上野",
            images: [img("v1782544346/DJI_20260619092553_0013_D_mggybx.jpg")],
            mapUrl: map("宮古そば まっすぐ 宮古島"),
            instagramUrl: "https://www.instagram.com/miyakosoba.massugu/",
            instagramLabel: "@miyakosoba.massugu",
            recommendedMenu: "宮古そば",
            businessHours: "要確認",
            closedDays: "要確認",
            text: "王道の宮古そばを楽しめるお店。上野方面やシギラ方面へ行く日のランチ候補として入れておきたい一軒です。",
            rows: [
              ["昼の混雑度", lunchCrowd.medium],
              ["雰囲気", "王道 / きれいめ / ドライブ"],
              ["おすすめ", "宮古そば / 上野方面ランチ"],
            ],
            hashtags: ["#宮古そばまっすぐ", "#宮古そば", "#宮古島ランチ"],
          },
          {
            name: "皆愛屋",
            area: "下地与那覇",
            images: [img("v1782544105/%EF%BC%91%EF%BC%91_j8gtip.jpg")],
            mapUrl: map("皆愛屋 宮古島"),
            instagramUrl: "",
            instagramLabel: "",
            recommendedMenu: "ゆし豆腐そば / 宮古そば",
            businessHours: "要確認",
            closedDays: "要確認",
            text: "与那覇前浜方面や下地エリアでランチを探す時に候補に入れたいお店。豆腐系のやさしい味わいを楽しみたい人におすすめです。",
            rows: [
              ["昼の混雑度", lunchCrowd.medium],
              ["雰囲気", "下地 / やさしい味 / ローカル"],
              ["おすすめ", "ゆし豆腐そば / 南部方面ランチ"],
            ],
            hashtags: ["#皆愛屋", "#ゆし豆腐そば", "#宮古島ランチ"],
          },
        ],
        hashtags: ["#南部ドライブ", "#城辺ランチ", "#宮古そば"],
      },
    ],
  },

  "recommend-sata-andagi": {
    id: 4,
    slug: "recommend-sata-andagi",
    template: "shops",
    mediaLayout: "split",
    categoryKey: "gourmet",
    category: "Gourmet",
    title: "宮古島でサーターアンダギー食べるならここ5選",
    description:
      "宮古島旅行で食べたいサーターアンダギー・さたぱんびん特集。なかゆくい商店、ななみカフェ、カフェ オルオキ、海美来、七福さたぱんびんを紹介します。",
    date: "2026.06.28",
    readTime: "6分",
    mainImage: img("v1784690818/23_mbegc4.png"),
    leadText:
      "沖縄のおやつとして人気のサーターアンダギー。宮古島では「さたぱんびん」と呼ばれることもあり、伊良部島を中心に、揚げたてを楽しめるお店や、ドライブ中に立ち寄りたいローカルなお店があります。今回は、宮古島旅行で一度は食べたいサーターアンダギー系のお店をまとめました。",
    tocImage: img("v1784690818/23_mbegc4.png"),
    toc: ["サーターアンダギーならここ5選"],
    points: [
      {
        number: "01",
        title: "サーターアンダギーならここ5選",
        area: "伊良部島・池間島・市街地 / テイクアウト / 島のおやつ",
        text: "宮古島でサーターアンダギーやさたぱんびんを食べるなら、ここに行ってください。伊良部島や池間島のドライブ途中、市街地での散策、旅のおやつ、お土産探しにも立ち寄りやすいお店をまとめました。",
        shops: [
          {
            name: "なかゆくい商店",
            area: "伊良部島",
            images: [
              "https://www.instagram.com/p/C_K0zEXvglQ/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map("なかゆくい商店 宮古島 伊良部島"),
            instagramUrl: "",
            instagramLabel: "",
            recommendedMenu: "紅芋ぱんびん / さたぱんびんアイス",
            businessHours: "金・土・日・火・水 9:30～12:00 / 13:30～16:00",
            closedDays: "月曜日・木曜日",
            text: "宮古島のサーターアンダギー系おやつで外せない人気店。紅芋ぱんびんは、伊良部島ドライブの途中で食べたい一品です。",
            rows: [
              ["昼の混雑度", lunchCrowd.high],
              ["雰囲気", "伊良部島 / テイクアウト / 人気店"],
              ["おすすめ", "紅芋ぱんびん / 揚げたて / ドライブ途中"],
            ],
            hashtags: ["#なかゆくい商店", "#紅芋ぱんびん", "#さたぱんびん"],
          },
          {
            name: "ななみカフェ",
            area: "伊良部島",
            images: [
              "https://www.instagram.com/reel/C0IVlH6vH4F/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map("ななみカフェ 宮古島 伊良部島"),
            instagramUrl: "",
            instagramLabel: "",
            recommendedMenu: "サーターアンダギー / 紅芋 / 黒糖",
            businessHours: "土・日・月・水・木 11:00～16:00",
            closedDays: "金曜日・火曜日",
            text: "サーターアンダギーを食べ比べしたい時に候補に入れたいお店。伊良部島エリアで、旅のおやつやテイクアウトにも使いやすいです。",
            rows: [
              ["昼の混雑度", lunchCrowd.low],
              ["雰囲気", "伊良部島 / テイクアウト / おやつ"],
              ["おすすめ", "サーターアンダギー / 食べ比べ / お土産"],
            ],
            hashtags: [
              "#ななみカフェ",
              "#サーターアンダギー",
              "#伊良部島グルメ",
            ],
          },
          {
            name: "カフェ オルオキ",
            area: "伊良部島",
            images: [
              "https://www.instagram.com/p/DE823GHzx50/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            ],
            mapUrl: map("カフェ オルオキ 沖縄県宮古島市上地115"),
            instagramUrl: "",
            instagramLabel: "",
            recommendedMenu: "サーターアンダギー / カフェスイーツ",
            businessHours: "毎日 11:00～17:00",
            closedDays: "なし",
            text: "伊良部島でカフェ時間と一緒に甘いものを楽しみたい時に候補に入れたいお店。比較的入りやすく、ドライブ途中の休憩にも使いやすいです。",
            rows: [
              ["住所", "〒906-0304 沖縄県宮古島市上地115"],
              ["昼の混雑度", lunchCrowd.low],
              ["雰囲気", "カフェ / 比較的入りやすい / 休憩"],
              ["おすすめ", "サーターアンダギー / カフェ休憩 / ドライブ途中"],
            ],
            hashtags: ["#カフェオルオキ", "#伊良部島カフェ", "#宮古島スイーツ"],
          },
          {
            name: "海美来 紅芋もち",
            area: "池間島",
            mapUrl: map("海美来 紅芋もち 〒906-0421 沖縄県宮古島市平良池間1173-7"),
            instagramUrl: "https://www.instagram.com/p/DE823GHzx50/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
            instagramLabel: "カフェ オルオキと同じInstagram",
            recommendedMenu: "青いサーターアンダギー / 紅芋もち",
            businessHours: "毎日 9:30～18:00",
            closedDays: "なし",
            text: "池間島ドライブで立ち寄りやすい海美来。名物の紅芋もちに加えて、カフェ オルオキの青いサーターアンダギーもここで食べられます。比較的入りやすく、海を見に行く途中の休憩にもおすすめです。",
            rows: [
              ["住所", "〒906-0421 沖縄県宮古島市平良池間1173-7"],
              ["昼の混雑度", lunchCrowd.low],
              ["雰囲気", "池間島 / 比較的入りやすい / ドライブ休憩"],
              ["おすすめ", "青いサーターアンダギー / 紅芋もち"],
              ["おすすめメニュー", "青いサーターアンダギー / 紅芋もち"],
              ["営業時間", "毎日 9:30～18:00"],
              ["定休日", "なし"],
              ["電話番号", "0980-75-2121"],
              ["価格帯", "1～1,000円"],
            ],
            hashtags: ["#海美来", "#池間島", "#紅芋もち", "#サーターアンダギー"],
          },
          {
            name: "七福さたぱんびん",
            area: "平良西里",
            images: ["https://www.instagram.com/p/C7pjzPFSodQ/"],
            mapUrl: map("七福さたぱんびん 沖縄県宮古島市平良西里274-1"),
            instagramUrl: "https://www.instagram.com/p/C7pjzPFSodQ/",
            instagramLabel: "Instagramの投稿を見る",
            recommendedMenu: "さたぱんびん",
            businessHours: "9:30～15:00（まれに10:00～16:00）※売り切れ次第終了",
            closedDays: "不定休",
            text: "観光客にはまだあまり知られていない、平良西里の穴場。比較的入りやすく、宮古島らしいさたぱんびんを気軽に楽しめます。売り切れ次第終了のため、早めの来店がおすすめです。",
            rows: [
              ["住所", "〒906-0012 沖縄県宮古島市平良字西里274-1"],
              ["昼の混雑度", lunchCrowd.low],
              ["雰囲気", "観光客が知らない穴場 / 比較的入りやすい"],
              ["おすすめ", "さたぱんびん / 穴場 / 街歩き途中"],
              ["おすすめメニュー", "さたぱんびん"],
              ["営業時間", "9:30～15:00（まれに10:00～16:00）/ 売り切れ次第終了"],
              ["定休日", "不定休"],
            ],
            hashtags: ["#七福さたぱんびん", "#さたぱんびん", "#宮古島スイーツ", "#宮古島穴場"],
          },
        ],
        hashtags: ["#伊良部島グルメ", "#池間島グルメ", "#宮古島穴場", "#サーターアンダギー", "#さたぱんびん"],
      },
    ],
  },

  "drive-scenic-spots": {
    id: 5,
    slug: "drive-scenic-spots",
    template: "spots",
    category: "Spot",
    title: "宮古島で車で行ける絶景スポット9選",
    description:
      "ドライブで行ける宮古島の絶景スポットを紹介。海のグラデーション、橋、白砂のビーチ、サンセットが綺麗に見える場所までまとめました。",
    date: "2026.06.20",
    readTime: "7分",
    mainImage: img("v1782544346/DJI_20260619092553_0013_D_mggybx.jpg"),
    leadText:
      "宮古島には、車で行けるだけで感動できる絶景スポットがたくさんあります。宮古ブルーの海を見渡せる橋、白砂のビーチ、岬の絶景、そして夕日が綺麗に見えるサンセットスポットまで、ドライブで回りやすい場所をまとめました。",
    tocImage: img("v1782544346/DJI_20260619092553_0013_D_mggybx.jpg"),
    toc: [
      "伊良部大橋",
      "与那覇前浜ビーチ",
      "砂山ビーチ",
      "17END",
      "東平安名崎",
      "パイナガマビーチ",
      "牧山展望台",
      "佐和田の浜",
      "トゥリバーサンセットビーチ",
    ],
    spots: [
      {
        number: "01",
        title: "伊良部大橋",
        area: "宮古島〜伊良部島",
        instagramUrl:
          "https://www.instagram.com/reel/CxFzVNtPl3E/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
        mapUrl: map("伊良部大橋 宮古島"),
        text: "宮古ブルーの海の上をまっすぐ進むような景色が楽しめる定番ドライブスポット。車で渡るだけでも宮古島らしい絶景を感じられます。",
        rows: [
          ["おすすめ", "ドライブ / 海のグラデーション / 橋の景色"],
          ["撮影時間", "午前中〜昼過ぎ"],
          ["ポイント", "橋の上での停車は不可。安全な場所から撮影"],
        ],
        hashtags: [
          "#伊良部大橋",
          "#宮古ブルー",
          "#宮古島ドライブ",
          "#ドローン",
        ],
      },
      {
        number: "02",
        title: "与那覇前浜ビーチ",
        area: "宮古島南西部",
        instagramUrl:
          "https://www.instagram.com/p/DPtK9wSj8RH/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
        mapUrl: map("与那覇前浜ビーチ 宮古島"),
        text: "白い砂浜と透明度の高い海が広がる人気ビーチ。車でアクセスしやすく、日中の海も夕方の雰囲気も綺麗です。",
        rows: [
          ["おすすめ", "ビーチ撮影 / 白砂 / サンセット"],
          ["撮影時間", "午前中 / 夕方"],
          ["ポイント", "白砂と海のグラデーションを広く入れる"],
        ],
        hashtags: ["#前浜ビーチ", "#ビーチ撮影", "#宮古島絶景"],
      },
      {
        number: "03",
        title: "砂山ビーチ",
        area: "宮古島北部",
        instagramUrl:
          "https://www.instagram.com/p/C63h3XmNdlv/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
        mapUrl: map("砂山ビーチ 宮古島"),
        text: "砂の丘を越えた先に広がる海と、岩のアーチが印象的なビーチ。駐車場から少し歩きますが、自然感のある写真を撮りたい人におすすめです。",
        rows: [
          ["おすすめ", "自然感 / 岩場 / ビーチ撮影"],
          ["撮影時間", "午前中 / 日差しが強すぎない時間"],
          ["ポイント", "岩のアーチと海を一緒に入れる"],
        ],
        hashtags: ["#砂山ビーチ", "#宮古島写真", "#自然スポット"],
      },
      {
        number: "04",
        title: "17END",
        area: "下地島",
        instagramUrl:
          "https://www.instagram.com/p/CwHkRa4r-hh/?utm_source=ig_web_copy_link&igsh=NTc4MTIwNjQ2YQ==",
        mapUrl: map("17END 下地島 宮古島"),
        text: "下地島空港の先にある、透明度の高い海が美しいスポット。遠浅の海のグラデーションが綺麗に出やすく、ドライブで行きたい絶景のひとつです。",
        rows: [
          ["おすすめ", "海のグラデーション / ドライブ / 写真撮影"],
          ["撮影時間", "午前中〜昼過ぎ"],
          ["ポイント", "遠浅の海を広く入れて撮る"],
        ],
        hashtags: ["#17END", "#下地島", "#宮古島絶景"],
      },
      {
        number: "05",
        title: "東平安名崎",
        area: "宮古島東部",
        instagramUrl:
          "https://www.instagram.com/p/Dac9tAkynSG/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
        mapUrl: map("東平安名崎 宮古島"),
        text: "海に突き出した岬と灯台が印象的な絶景スポット。車で行きやすく、宮古島の海と自然のスケール感を感じられる場所です。",
        rows: [
          ["おすすめ", "ドライブ / 灯台 / 絶景撮影"],
          ["撮影時間", "午前中 / 晴れた日"],
          ["ポイント", "灯台・道・海を一緒に入れると奥行きが出る"],
        ],
        hashtags: ["#東平安名崎", "#宮古島ドライブ", "#絶景スポット"],
      },
      {
        number: "06",
        title: "パイナガマビーチ",
        area: "平良市街地近く",
        instagramUrl: "",
        mapUrl: map("パイナガマビーチ 宮古島"),
        text: "市街地からアクセスしやすく、夕方の雰囲気も綺麗なビーチ。サンセットや散歩中の自然な写真を撮りたい時におすすめです。",
        rows: [
          ["おすすめ", "サンセット / 散歩 / カジュアル撮影"],
          ["撮影時間", "夕方 / 日没前後"],
          ["ポイント", "夕日と人物をシルエット気味に撮る"],
        ],
        hashtags: ["#パイナガマビーチ", "#宮古島サンセット", "#夕日"],
      },
      {
        number: "07",
        title: "牧山展望台",
        area: "伊良部島",
        instagramUrl: "",
        mapUrl: map("牧山展望台 宮古島 伊良部島"),
        text: "伊良部島から宮古島方面を見渡せる展望台。伊良部大橋や海の広がりを上から眺められるので、ドライブ途中に立ち寄りやすい絶景スポットです。",
        rows: [
          ["おすすめ", "展望台 / 伊良部大橋 / 高台からの景色"],
          ["撮影時間", "午前中〜夕方"],
          ["ポイント", "橋と海を広く入れると宮古島らしい写真になる"],
        ],
        hashtags: ["#牧山展望台", "#伊良部島", "#宮古島ドライブ"],
      },
      {
        number: "08",
        title: "佐和田の浜",
        area: "伊良部島",
        instagramUrl: "",
        mapUrl: map("佐和田の浜 宮古島 伊良部島"),
        text: "海に点在する岩と夕日のシルエットが美しい、伊良部島のサンセットスポット。日中の海も綺麗ですが、夕方に行くと雰囲気が一気に変わります。",
        rows: [
          ["おすすめ", "サンセット / 岩のシルエット / 静かな海"],
          ["撮影時間", "夕方 / 日没前後"],
          ["ポイント", "水面と岩のシルエットを広く入れる"],
        ],
        hashtags: ["#佐和田の浜", "#伊良部島", "#宮古島サンセット"],
      },
      {
        number: "09",
        title: "トゥリバーサンセットビーチ",
        area: "平良市街地近く",
        instagramUrl: "",
        mapUrl: map("トゥリバーサンセットビーチ 宮古島"),
        text: "市街地から車で行きやすいサンセットスポット。夕方の海辺散歩や、旅の最後に夕日を見たい時にも立ち寄りやすい場所です。",
        rows: [
          ["おすすめ", "サンセット / 海辺散歩 / 市街地から近い"],
          ["撮影時間", "日没前後"],
          ["ポイント", "夕日と人物をシルエット気味に撮ると雰囲気が出る"],
        ],
        hashtags: ["#トゥリバー", "#サンセットビーチ", "#宮古島夕日"],
      },
    ],
  },

  "miyakojima-superb-view-spots": {
    id: 25,
    slug: "miyakojima-superb-view-spots",
    template: "normal",
    categoryKey: "shooting",
    category: "Shooting",
    title: "宮古島旅行で絶対に行きたい絶景スポット",
    description:
      "宮古島旅行で絶対に行きたい絶景スポットを紹介。与那覇前浜、砂山ビーチ、伊良部島、青の洞窟、東平安名崎など、写真や映像に残したい場所と、究極の非日常体験を味わえる秘境フォトツアーについてまとめました。",
    date: "2026.07.31",
    readTime: "6分",
    mainImage: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
    leadText:
      "宮古島には、ただ眺めるだけで息をのむような絶景がたくさんあります。白い砂浜、透明度の高い宮古ブルー、橋から見える海のグラデーション、観光客が少ない秘境スポットまで、旅の思い出を写真や映像に残したくなる場所ばかりです。宮古島旅行で究極の非日常体験を味わいたい方は、絶景スポットを巡るだけでなく、撮影付きの秘境フォトツアーで特別な1日を残すのもおすすめです。",
    tocImage: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
    toc: [
      "宮古島の王道絶景スポット",
      "秘境感を味わえるスポット",
      "秘境フォトツアーで非日常体験を残す",
    ],
    cta: {
      title: "宮古島の絶景をもっと特別に",
      text: "秘境スポットや撮影スポットを巡りながら、写真・動画・ドローン撮影まで楽しめる1組限定の秘境フォトツアーです。",
      buttonText: "秘境フォトツアーを見る",
      path: "/tours/one-day-photogenic-tour",
    },
    points: [
      {
        number: "01",
        title: "宮古島の王道絶景スポット",
        area: "Beach / Bridge / Miyako Blue",
        image: img("v1785005393/DJI_20260722152001_0021_D_small_odgfk0.jpg"),
        text: "初めての宮古島旅行なら、与那覇前浜ビーチ、砂山ビーチ、伊良部大橋、来間島周辺は外しにくい絶景スポットです。白い砂浜と青い海、橋から見える海のグラデーションは、宮古島らしい写真を残しやすい場所です。",
        rows: [
          ["おすすめ", "与那覇前浜 / 砂山ビーチ / 伊良部大橋 / 来間島"],
          ["撮影", "晴れた日の午前〜昼過ぎが海の色が出やすい"],
          ["ポイント", "海だけでなく人物を入れると旅の思い出感が出る"],
        ],
        hashtags: ["#宮古島", "#絶景スポット", "#宮古ブルー"],
      },
      {
        number: "02",
        title: "秘境感を味わえるスポット",
        area: "Hidden Spot / Secret Beach",
        image: img("v1784949980/DJI_20260724131535_0015_D_robale.webp"),
        text: "観光地だけでなく、人が少ないビーチや海況によって表情が変わる場所も宮古島の魅力です。ただし、リーフや潮の流れ、立ち入りルールなど注意が必要な場所もあるため、無理に行かず安全に楽しむことが大切です。",
        rows: [
          ["おすすめ", "伊良部島周辺 / 池間島周辺 / シークレットビーチ"],
          ["注意", "海況・潮位・立ち入りルールを必ず確認"],
          ["体験", "観光客が少ない場所ほど非日常感を味わいやすい"],
        ],
        hashtags: ["#秘境", "#シークレットビーチ", "#宮古島旅行"],
      },
      {
        number: "03",
        title: "秘境フォトツアーで非日常体験を残す",
        area: "Photo Tour / Drone Shooting",
        image: img("v1784944008/DJI_20260724142728_0046_D_fjvofb.webp"),
        text: "宮古島旅行で究極の非日常体験を味わいたい方には、秘境フォトツアーがおすすめです。秘境スポットや撮影スポットを巡りながら、ドローン撮影や一眼カメラ撮影で、普通の観光では残せない写真・映像を残せます。",
        rows: [
          ["ツアー", "約3時間 / 1組限定"],
          ["料金", "¥25,000 / グループ"],
          ["含まれるもの", "ドローン撮影 / 一眼カメラ撮影 / 絶景スポット案内"],
        ],
        hashtags: ["#秘境フォトツアー", "#ドローン", "#撮影"],
      },
    ],
  },

  "miyakojima-cheap-local-rentacar": {
    id: 26,
    slug: "miyakojima-cheap-local-rentacar",
    template: "shops",
    mediaLayout: "split",
    hideBaeScore: true,
    categoryKey: "drive",
    category: "Drive",
    title: "宮古島 激安ローカルレンタカーまとめ",
    description:
      "宮古島旅行で安くレンタカーを借りたい方向けに、ローカル系・格安系レンタカーをまとめました。料金目安、送迎、補償、車両状態のチェックポイントも紹介します。",
    date: "2026.07.31",
    readTime: "6分",
    mainImage: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
    leadText:
      "宮古島旅行はレンタカーがあると、ビーチ、カフェ、絶景スポットをかなり回りやすくなります。ただし、ハイシーズンは料金が上がりやすく、大手レンタカーは早めに埋まることも。少しでも費用を抑えたい方は、地元のローカルレンタカーや格安プランも候補に入れてみるのがおすすめです。この記事では、料金目安と選ぶ時の注意点をまとめます。",
    tocImage: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
    toc: [
      "安く借りたい人向けローカルレンタカー",
      "空港送迎や補償込みで選びたい人向け",
      "激安レンタカーを選ぶ時の注意点",
    ],
    points: [
      {
        number: "01",
        title: "安く借りたい人向けローカルレンタカー",
        area: "Local Rentacar / Budget",
        text: "価格重視なら、軽自動車や中古車プランを扱うローカルレンタカーが候補になります。通常期は1日あたり3,000円〜4,000円台のプランも見つかることがあります。",
        shops: [
          {
            name: "宮古島観光レンタカー",
            area: "宮古島",
            genre: "格安レンタカー / 軽自動車",
            mapUrl: map("宮古島観光レンタカー"),
            recommendedMenu: "軽自動車 / コンパクトカー",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "軽自動車を安く借りたい人に候補に入れたいレンタカー。公式料金では軽自動車の当日利用・1泊2日が税込3,000円から案内されています。",
            rows: [
              ["価格帯", "軽自動車 目安 ¥3,000〜 / 1日"],
              ["おすすめ", "とにかく安く借りたい / 少人数旅行"],
              ["注意", "在庫・ハイシーズン料金・補償内容は事前確認"],
            ],
            hashtags: ["#宮古島レンタカー", "#格安レンタカー", "#ドライブ"],
          },
          {
            name: "サーウエスト宮古島",
            area: "宮古島",
            genre: "格安レンタカー / 送迎あり",
            mapUrl: map("サーウエスト宮古島 レンタカー"),
            recommendedMenu: "軽自動車 / 長期利用",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "免責補償込みの料金や送迎に対応しているローカル系レンタカー。2日間利用で軽自動車が合計6,000円の例も案内されています。",
            rows: [
              ["価格帯", "軽自動車 目安 ¥3,000〜 / 1日"],
              ["おすすめ", "長めの滞在 / 補償込みで安く借りたい"],
              ["注意", "空港・ホテル送迎の範囲は事前確認"],
            ],
            hashtags: ["#サーウエスト", "#格安レンタカー", "#宮古島ドライブ"],
          },
        ],
        hashtags: ["#レンタカー", "#格安レンタカー", "#宮古島ドライブ"],
      },
      {
        number: "02",
        title: "空港送迎や補償込みで選びたい人向け",
        area: "Airport Transfer / Insurance",
        text: "安さだけでなく、空港送迎、免責補償、NOC込みかどうかも大事です。表示料金が安くても、補償や送迎を追加すると総額が変わることがあります。",
        shops: [
          {
            name: "宮古島レンタカー碧",
            area: "宮古島",
            genre: "レンタカー / 軽自動車",
            mapUrl: map("宮古島レンタカー碧"),
            recommendedMenu: "軽自動車 / スモールクラス",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "軽自動車からスモール、ミドルまで料金表が見やすいレンタカー。軽自動車は通常期で当日3,500円、2泊3日7,000円の料金例があります。",
            rows: [
              ["価格帯", "軽自動車 目安 ¥3,500〜 / 当日利用"],
              ["おすすめ", "料金表を見て比較したい / 少人数旅行"],
              ["注意", "ハイシーズンは料金が上がるため要確認"],
            ],
            hashtags: ["#宮古島レンタカー", "#レンタカー", "#ドライブ"],
          },
          {
            name: "アンドレンタカー 宮古島店",
            area: "宮古島",
            genre: "レンタカー / 軽自動車",
            mapUrl: map("アンドレンタカー 宮古島店"),
            recommendedMenu: "軽自動車 / コンパクトカー",
            businessHours: "営業時間は来店前に要確認",
            closedDays: "不定休",
            text: "短時間利用から24時間利用まで料金が分かりやすいレンタカー。軽自動車は通常料金で24時間まで4,400円の案内があります。",
            rows: [
              ["価格帯", "軽自動車 目安 ¥4,400〜 / 24時間"],
              ["おすすめ", "短時間利用 / 予定に合わせて借りたい"],
              ["注意", "超過料金・ハイシーズン料金を確認"],
            ],
            hashtags: ["#アンドレンタカー", "#レンタカー", "#宮古島旅行"],
          },
        ],
        hashtags: ["#レンタカー", "#宮古島旅行", "#空港送迎"],
      },
      {
        number: "03",
        title: "激安レンタカーを選ぶ時の注意点",
        area: "Check Point",
        text: "激安レンタカーは旅費を抑えられる一方で、車両年式、傷、エアコン、補償、送迎範囲、支払い方法の確認が大切です。特に夏の宮古島は暑いので、エアコンの効きやトラブル時の対応は予約前に確認しておくと安心です。",
        shops: [
          {
            name: "予約前に確認したいこと",
            area: "チェックリスト",
            genre: "レンタカー選び",
            mapUrl: map("宮古島 レンタカー"),
            recommendedMenu: "補償 / 送迎 / 車両状態",
            businessHours: "予約前に確認",
            closedDays: "なし",
            text: "安いプランほど、総額と条件を確認してから予約するのがおすすめです。免責補償込みか、NOCが別料金か、空港送迎があるか、車両トラブル時の対応まで見ておきましょう。",
            rows: [
              ["補償", "免責補償 / NOC / 自損補償の有無"],
              ["車両", "年式 / 傷 / エアコン / 禁煙車かどうか"],
              ["送迎", "宮古空港・下地島空港・ホテル対応の有無"],
            ],
            hashtags: ["#レンタカー", "#宮古島旅行", "#旅行準備"],
          },
        ],
        hashtags: ["#格安レンタカー", "#旅行準備", "#宮古島"],
      },
    ],
  },

  "model-course-2n3d": {
    id: 8,
    slug: "model-course-2n3d",
    template: "normal",
    categoryKey: "drive",
    category: "Drive",
    title: "宮古島2泊3日モデルプラン",
    description:
      "秘境フォトツアーや秘境SUP、八重干瀬ツアー、サンセット鑑賞、夜ご飯、ビーチ・カフェを組み合わせた宮古島2泊3日モデルプラン。",
    date: "2026.07.31",
    readTime: "6分",
    mainImage: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
    leadText:
      "2泊3日の宮古島旅行は、到着日から海や撮影を楽しみつつ、2日目に八重干瀬とサンセット、夜ご飯まで入れると満足感が高くなります。最終日は予定を詰め込みすぎず、ビーチやカフェでゆっくり過ごして空港へ向かう流れがおすすめです。",
    tocImage: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
    toc: [
      "1日目：秘境フォトツアーで撮影 or 秘境SUP",
      "2日目：八重干瀬ツアー・サンセット鑑賞・夜ご飯",
      "3日目：ビーチやカフェでゆっくり・空港へ",
    ],
    points: [
      {
        number: "01",
        title: "1日目：秘境フォトツアーで撮影 or 秘境SUP",
        area: "Photo Tour / Hidden SUP",
        image: img("v1784466423/DJI_20260718160638_0015_D_gh8w0n.webp"),
        text: "到着日または初日は、宮古島らしい写真を残せる秘境フォトツアーか、人が少ない海で楽しめる秘境SUPがおすすめです。初日から旅の思い出をしっかり残せるので、旅行全体の満足感も上がります。",
        rows: [
          ["午前〜昼", "秘境フォトツアーで撮影 or 秘境SUP"],
          ["夕方", "ホテルチェックイン後に少し休憩"],
          ["夜", "市街地で宮古島グルメ"],
        ],
        hashtags: ["#宮古島", "#モデルコース", "#撮影", "#SUP"],
      },
      {
        number: "02",
        title: "2日目：八重干瀬ツアー・サンセット鑑賞・夜ご飯",
        area: "Yabiji / Sunset / Dinner",
        image: img("v1784682749/DJI_20260721085951_0005_D-2_mb4lnk.webp"),
        text: "2日目は朝から八重干瀬ツアーへ。宮古島らしい透明度の高い海を楽しんだあとは、夕方にサンセットを見て、夜は島おでん・居酒屋・焼肉などで宮古島の夜ご飯を楽しむ流れがちょうど良いです。",
        rows: [
          ["9:30", "八重干瀬ツアー"],
          ["夕方", "サンセット鑑賞"],
          ["夜", "おすすめの夜ご飯へ"],
        ],
        hashtags: ["#八重干瀬", "#サンセット", "#夜ご飯"],
      },
      {
        number: "03",
        title: "3日目：ビーチやカフェでゆっくり・空港へ",
        area: "Last Day",
        image: img(
          "v1783352339/AD_4nXf2yA3puqm63h-XEHfk_ltPQ-m0Sy4IQCU-m0yCaojShxZt7-CDQQ1B8UUjJ5iQC-szsuwzS9Vq4ScPOBElN52vu_oxEkcKu2UbdK-gsQe_WVuQKT9E9iGjaVqKC7vIMduz6M-_ylvli6.png",
        ),
        text: "最終日は移動時間を考えて、ビーチやカフェでゆっくり過ごすのがおすすめです。空港までの時間を逆算しながら、最後に宮古島らしい写真を残して旅を締めくくれます。",
        rows: [
          ["午前", "ビーチやカフェでゆっくり"],
          ["昼", "ランチ・お土産探し"],
          ["注意", "レンタカー返却時間に余裕を持つ"],
        ],
        hashtags: ["#カフェ巡り", "#宮古島旅行", "#モデルコース"],
      },
    ],
  },

  "model-course-3n4d": {
    id: 24,
    slug: "model-course-3n4d",
    template: "normal",
    categoryKey: "drive",
    category: "Drive",
    title: "宮古島3泊4日モデルプラン",
    description:
      "秘境フォトツアー、秘境SUP、八重干瀬ツアー、サンセット、夜ご飯、星空撮影、カフェ朝ごはんまで楽しむ宮古島3泊4日モデルプラン。",
    date: "2026.07.31",
    readTime: "7分",
    mainImage: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
    leadText:
      "3泊4日なら、海・撮影・グルメ・星空まで無理なく楽しめます。1日で全部詰め込むより、日ごとに体験を分けることで疲れにくく、写真や動画に残したくなる時間も増やせます。",
    tocImage: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
    toc: [
      "1日目：秘境フォトツアーで撮影 or 秘境SUP",
      "2日目：八重干瀬ツアー・サンセット鑑賞・夜ご飯",
      "3日目：ビーチやカフェでゆっくり・夜は星空撮影",
      "4日目：カフェで朝ごはん・空港へ",
    ],
    points: [
      {
        number: "01",
        title: "1日目：秘境フォトツアーで撮影 or 秘境SUP",
        area: "Photo Tour / Hidden SUP",
        image: img("v1784944008/DJI_20260724142728_0046_D_fjvofb.webp"),
        text: "旅の始まりは、宮古島らしい写真や映像を残せる体験から。秘境フォトツアーなら撮影スポット巡り、秘境SUPなら人が少ない海での非日常体験を楽しめます。",
        rows: [
          ["午前〜昼", "秘境フォトツアーで撮影 or 秘境SUP"],
          ["夕方", "ホテルで休憩"],
          ["夜", "市街地で軽めの夜ご飯"],
        ],
        hashtags: ["#宮古島", "#撮影", "#SUP", "#モデルコース"],
      },
      {
        number: "02",
        title: "2日目：八重干瀬ツアー・サンセット鑑賞・夜ご飯",
        area: "Yabiji / Sunset / Dinner",
        image: img("v1785003708/DJI_20260707132223_0047_D_small_no9d5s.jpg"),
        text: "2日目は朝から八重干瀬ツアーへ。昼間は宮古ブルーを満喫し、夕方はサンセット、夜は島おでんや焼肉など宮古島の夜ご飯を楽しむ流れがおすすめです。",
        rows: [
          ["9:30", "八重干瀬ツアー"],
          ["夕方", "サンセット鑑賞"],
          ["夜", "夜ご飯・夜遊び"],
        ],
        hashtags: ["#八重干瀬", "#サンセット", "#夜ご飯"],
      },
      {
        number: "03",
        title: "3日目：ビーチやカフェでゆっくり・夜は星空撮影",
        area: "Beach / Cafe / Star Photo",
        image: img("v1785311449/DSC00588-2_x2m1d1.webp"),
        text: "3日目は少しペースを落として、ビーチやカフェでゆっくり過ごす日。夜は街明かりの少ない場所で星空撮影を入れると、昼の海とは違う宮古島の思い出が残せます。",
        rows: [
          ["日中", "ビーチやカフェでゆっくり"],
          ["夜", "星空撮影"],
          ["ポイント", "夜の予定に備えて昼は詰め込みすぎない"],
        ],
        hashtags: ["#星空撮影", "#カフェ巡り", "#モデルコース"],
      },
      {
        number: "04",
        title: "4日目：カフェで朝ごはん・空港へ",
        area: "Morning Cafe / Airport",
        image: img(
          "v1783352339/AD_4nXf2yA3puqm63h-XEHfk_ltPQ-m0Sy4IQCU-m0yCaojShxZt7-CDQQ1B8UUjJ5iQC-szsuwzS9Vq4ScPOBElN52vu_oxEkcKu2UbdK-gsQe_WVuQKT9E9iGjaVqKC7vIMduz6M-_ylvli6.png",
        ),
        text: "最終日はカフェで朝ごはんを食べて、空港へ向かうゆったりした流れに。お土産やレンタカー返却の時間もあるので、遠出しすぎないのが安心です。",
        rows: [
          ["朝", "カフェで朝ごはん"],
          ["昼", "お土産・レンタカー返却"],
          ["移動", "空港へ"],
        ],
        hashtags: ["#朝カフェ", "#宮古島旅行", "#モデルコース"],
      },
    ],
  },

  "one-day-photogenic-tour-experience": {
    id: 27,
    slug: "one-day-photogenic-tour-experience",
    template: "normal",
    categoryKey: "tour",
    category: "Tour",
    title: "秘境フォトツアーの様子を紹介",
    description:
      "宮古島の秘境フォトツアーではどんな体験ができるのか、秘境スポット巡り、撮影、ドローン撮影、写真データのお渡しまで流れを紹介します。",
    date: "2026.07.31",
    readTime: "5分",
    mainImage: img("v1784944008/DJI_20260724142728_0046_D_fjvofb.webp"),
    leadText:
      "秘境フォトツアーは、ただ観光地を回るだけのツアーではありません。宮古島らしい海、橋、秘境スポットを巡りながら、写真・動画・ドローン撮影まで残せる1組限定の体験です。人が少ない場所で、周りを気にせず自分たちだけの宮古島を楽しめます。",
    tocImage: img("v1784944008/DJI_20260724142728_0046_D_fjvofb.webp"),
    toc: [
      "秘境スポットや絶景スポットを巡る",
      "撮影しながら宮古島を楽しめる",
      "写真・映像を旅の思い出として残せる",
    ],
    cta: {
      title: "1組限定の秘境フォトツアー",
      text: "約3時間で秘境スポットや撮影スポットを巡り、ドローン撮影・一眼カメラ撮影まで楽しめます。",
      buttonText: "秘境フォトツアーを見る",
      path: "/tours/one-day-photogenic-tour",
    },
    points: [
      {
        number: "01",
        title: "秘境スポットや絶景スポットを巡る",
        area: "Scenic Tour",
        image: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
        text: "その日の天気や海の色を見ながら、写真に残しやすいスポットへご案内します。観光だけでは見つけにくい場所も組み合わせることで、宮古島らしい非日常感を味わえます。",
        rows: [
          ["時間", "約3時間"],
          ["料金", "¥25,000 / グループ"],
          ["体験", "絶景スポット巡り / 撮影 / ドローン撮影"],
        ],
        hashtags: ["#秘境フォトツアー", "#宮古島", "#撮影"],
      },
      {
        number: "02",
        title: "撮影しながら宮古島を楽しめる",
        area: "Photo & Movie",
        image: img("v1785006837/DJI_20260723115724_0009_D_small_mtcpab.jpg"),
        text: "ポーズを決めすぎる撮影ではなく、歩く、海を見る、笑う、旅を楽しむ自然な瞬間を残します。スマホでは残しにくい広い海や空のスケールも、ドローンでしっかり撮影できます。",
        rows: [
          ["撮影", "一眼カメラ / ドローン"],
          ["おすすめ", "女子旅 / カップル / 家族旅行"],
          ["雰囲気", "自然体 / 貸切 / 非日常"],
        ],
        hashtags: ["#ドローン", "#旅動画", "#宮古ブルー"],
      },
    ],
  },

  "hidden-sup-tour-experience": {
    id: 28,
    slug: "hidden-sup-tour-experience",
    template: "normal",
    categoryKey: "tour",
    category: "Tour",
    title: "秘境SUPツアーの様子を紹介",
    description:
      "秘境SUPツアーの雰囲気、当日の流れ、撮影できる写真や動画、人が少ない海で味わえる非日常体験を紹介します。",
    date: "2026.07.31",
    readTime: "5分",
    mainImage: img("v1784734130/DJI_20260722152642_0033_D_tb9qki.webp"),
    leadText:
      "秘境SUPツアーは、観光客が多いビーチではなく、人が少ない海でゆっくり過ごしたい方におすすめの体験です。透明度の高い宮古ブルーに浮かびながら、写真や映像に残したくなる静かな時間を楽しめます。",
    tocImage: img("v1784734130/DJI_20260722152642_0033_D_tb9qki.webp"),
    toc: [
      "人が少ない海でSUPを楽しむ",
      "涙が出るほど綺麗な海を独り占め",
      "写真・動画で空気感まで残せる",
    ],
    cta: {
      title: "秘境SUPツアー",
      text: "他に誰もいない秘境で、全てを忘れる非日常体験に癒されてください。写真・動画・ドローン撮影まで楽しめる特別なツアーです。",
      buttonText: "秘境SUPを見る",
      path: "/tours/hidden-sup",
    },
    points: [
      {
        number: "01",
        title: "人が少ない海でSUPを楽しむ",
        area: "Hidden SUP",
        image: img("v1785005393/DSC00178_small_hexny7.jpg"),
        text: "周りを気にせず、ゆっくり宮古島の海を感じられるのが秘境SUPの魅力です。初めての方でも、ガイドが海況を見ながら案内します。",
        rows: [
          ["体験", "SUP / 秘境ビーチ / 撮影"],
          ["料金", "¥12,000 / 1名 ※1名参加は¥15,000"],
          ["おすすめ", "非日常体験 / 写真好き / 女子旅"],
        ],
        hashtags: ["#秘境SUP", "#SUP", "#宮古島"],
      },
      {
        number: "02",
        title: "写真・動画で空気感まで残せる",
        area: "Memory",
        image: img("v1785005393/DJI_20260722152001_0021_D_small_odgfk0.jpg"),
        text: "海の透明感、SUPに乗っている姿、誰もいない静かな雰囲気まで撮影できます。体験後に見返した時、宮古島の空気まで思い出せるような映像を残します。",
        rows: [
          ["撮影", "写真 / 動画 / ドローン"],
          ["雰囲気", "静か / 癒し / 究極の非日常"],
          ["ポイント", "海況に合わせて安全にご案内"],
        ],
        hashtags: ["#ドローン", "#撮影", "#宮古ブルー"],
      },
    ],
  },

  "jet-private-secret-tour-experience": {
    id: 29,
    slug: "jet-private-secret-tour-experience",
    template: "normal",
    categoryKey: "tour",
    category: "Tour",
    title: "ジェットツアーの様子を紹介",
    description:
      "ジェットで巡るユニの浜・秘境ビーチツアーの流れ、現地集合、秘境スポット、ドローン撮影、写真・映像データのお渡しまで紹介します。",
    date: "2026.07.31",
    readTime: "5分",
    mainImage: img("v1784949980/DJI_20260724131535_0015_D_robale.webp"),
    leadText:
      "ジェットツアーは、車や徒歩では行けない海の先へ向かう特別な体験です。幻の浜「ユニの浜」に加え、当日の海況に合わせてジェットでしか行けない秘境・シークレットビーチへご案内します。",
    tocImage: img("v1784949980/DJI_20260724131535_0015_D_robale.webp"),
    toc: [
      "現地集合して海況に合わせたポイントへ",
      "ユニの浜とシークレットビーチへ",
      "ドローン撮影付きで思い出を残す",
    ],
    cta: {
      title: "JETで巡るユニの浜・秘境ビーチツアー",
      text: "ジェットでしか行けない秘境へ。完全プライベートで、ドローン撮影付きの特別な宮古島体験です。",
      buttonText: "ジェットツアーを見る",
      path: "/tours/jet-private-secret-tour",
    },
    points: [
      {
        number: "01",
        title: "現地集合して海況に合わせたポイントへ",
        area: "Meeting",
        image: img(
          "v1784950297/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-07-25_12.30.45_x4brgv.png",
        ),
        text: "集合場所は天気や海況に合わせて事前にご連絡します。基本的には宮古島市街地から車で10分以内の場所を予定しています。",
        rows: [
          ["集合", "現地集合 / 事前に集合場所をご連絡"],
          ["時間", "約2.5時間(集合・移動時間を除く)"],
          ["料金", "¥35,000 / 1名"],
        ],
        hashtags: ["#ジェット", "#マリンアクティビティ", "#宮古島"],
      },
      {
        number: "02",
        title: "ユニの浜とシークレットビーチへ",
        area: "Secret Beach",
        image: img(
          "v1784950296/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-07-25_12.31.09_s41ws9.png",
        ),
        text: "ユニの浜だけでなく、ジェットでしか行けない秘境・シークレットビーチへ。透明度の高いエリアと静かな浜で、自分たちだけの宮古島を体験できます。",
        rows: [
          ["行き先", "ユニの浜 / 秘境・シークレットビーチ"],
          ["撮影", "ドローン撮影付き"],
          ["解散", "体験終了後、現地にて解散"],
        ],
        hashtags: ["#ユニの浜", "#シークレットビーチ", "#ドローン"],
      },
    ],
  },

  "ultimate-extraordinary-miyakojima": {
    id: 30,
    slug: "ultimate-extraordinary-miyakojima",
    template: "normal",
    categoryKey: "drive",
    category: "Drive",
    title: "全てを忘れ究極の非日常体験を求める方へ",
    description:
      "宮古島で全てを忘れるような究極の非日常体験をしたい方へ。秘境の海、絶景撮影、SUP、ジェット、星空まで、宮古島の究極の過ごし方をこっそり紹介します。",
    date: "2026.07.31",
    readTime: "6分",
    mainImage: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
    leadText:
      "せっかく宮古島に来るなら、普通の観光だけで終わらせるのはもったいない。人が少ない海で何も考えずに過ごす時間、ドローンで残す絶景、ジェットでしか行けない秘境、夜の星空。全てを忘れて癒されたい方へ、宮古島の究極の過ごし方をこっそり紹介します。",
    tocImage: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
    toc: [
      "朝は人が少ない海へ",
      "昼は絶景や秘境を巡る",
      "夜は島ごはんと星空で締める",
    ],
    cta: {
      title: "究極の非日常を写真と映像に",
      text: "秘境フォトツアー、秘境SUP、ジェットツアーなど、宮古島らしい特別な体験を1組限定でご案内します。",
      buttonText: "ツアー一覧を見る",
      path: "/tours",
    },
    points: [
      {
        number: "01",
        title: "朝は人が少ない海へ",
        area: "Morning Blue",
        image: img("v1784734130/DJI_20260722152642_0033_D_tb9qki.webp"),
        text: "朝の海は人が少なく、静かで透明感も出やすい時間帯。秘境SUPやサーフィンなど、体を動かしながら宮古島の海を感じる体験がおすすめです。",
        rows: [
          ["おすすめ", "秘境SUP / サーフィン"],
          ["雰囲気", "静か / 癒し / 宮古ブルー"],
          ["ポイント", "午前中は写真も綺麗に残しやすい"],
        ],
        hashtags: ["#非日常体験", "#SUP", "#宮古ブルー"],
      },
      {
        number: "02",
        title: "昼は絶景や秘境を巡る",
        area: "Scenic Day",
        image: img("v1784949980/DJI_20260724131535_0015_D_robale.webp"),
        text: "昼は海の色が出やすい時間。秘境フォトツアーで撮影スポットを巡ったり、ジェットでしか行けない秘境へ向かったり、普通の観光では味わえない宮古島を楽しめます。",
        rows: [
          ["おすすめ", "秘境フォトツアー / ジェットツアー"],
          ["撮影", "写真 / 動画 / ドローン"],
          ["体験", "秘境スポット / シークレットビーチ"],
        ],
        hashtags: ["#秘境フォトツアー", "#ジェット", "#秘境"],
      },
      {
        number: "03",
        title: "夜は島ごはんと星空で締める",
        area: "Night Miyako",
        image: img("v1785311449/DSC00588-2_x2m1d1.webp"),
        text: "夜は宮古島のごはんを楽しんだあと、天気が良ければ星空を見に行くのもおすすめです。昼の海とは違う静けさがあり、旅の最後に深く残る時間になります。",
        rows: [
          ["おすすめ", "夜ご飯 / 星空撮影"],
          ["雰囲気", "静か / ロマンチック / 非日常"],
          ["注意", "夜の運転と暗い道には注意"],
        ],
        hashtags: ["#夜ご飯", "#星空撮影", "#宮古島旅行"],
      },
    ],
  },

  "yabiji-hidden-paradise": {
    id: 31,
    slug: "yabiji-hidden-paradise",
    template: "normal",
    categoryKey: "tour",
    category: "Tour",
    title: "人生で一度は行きたい秘境・八重干瀬",
    description:
      "宮古島から行ける日本最大級のサンゴ礁群、八重干瀬。透明度の高い海、サンゴ、シュノーケル体験、行く前に知っておきたい注意点を紹介します。",
    date: "2026.07.31",
    readTime: "5分",
    mainImage: img("v1785003708/DJI_20260707132223_0047_D_small_no9d5s.jpg"),
    leadText:
      "八重干瀬は、宮古島旅行で一度は見てほしい特別な海です。どこまでも続く宮古ブルー、サンゴ礁、船で向かう非日常感。写真では伝わりきらない透明感があり、人生で一度は行きたい秘境としておすすめしたい場所です。",
    tocImage: img("v1785003708/DJI_20260707132223_0047_D_small_no9d5s.jpg"),
    toc: [
      "八重干瀬は船で行く特別な海",
      "透明度とサンゴ礁が圧倒的",
      "ツアーで安全に楽しむのがおすすめ",
    ],
    points: [
      {
        number: "01",
        title: "八重干瀬は船で行く特別な海",
        area: "Yabiji",
        image: img("v1785003708/DJI_20260707132223_0047_D_small_no9d5s.jpg"),
        text: "八重干瀬は宮古島の北側に広がるサンゴ礁エリア。船で向かうため、島内のビーチとは違う特別感があります。海況によって行けるポイントが変わるため、ツアーで参加するのが基本です。",
        rows: [
          ["行き方", "ツアー船でアクセス"],
          ["体験", "シュノーケル / 海上散策 / 撮影"],
          ["注意", "海況によって催行やポイントが変わる"],
        ],
        hashtags: ["#八重干瀬", "#宮古ブルー", "#秘境"],
      },
      {
        number: "02",
        title: "透明度とサンゴ礁が圧倒的",
        area: "Coral Reef",
        image: img("v1785005393/DJI_20260722152001_0021_D_small_odgfk0.jpg"),
        text: "晴れた日の八重干瀬は、海の色が何層にも重なって見えます。サンゴ礁の上を泳ぐ時間は、宮古島の中でもかなり特別な体験です。",
        rows: [
          ["おすすめ", "晴れた日 / 風が弱い日"],
          ["撮影", "水面の色と広さを入れる"],
          ["持ち物", "日焼け対策 / 酔い止め / タオル"],
        ],
        hashtags: ["#サンゴ礁", "#シュノーケル", "#宮古島旅行"],
      },
    ],
  },

  "how-to-visit-secret-beaches": {
    id: 32,
    slug: "how-to-visit-secret-beaches",
    template: "normal",
    categoryKey: "tour",
    category: "Tour",
    title: "まだ誰も行ったことがない秘境に行く方法",
    description:
      "宮古島で観光客が少ない秘境やシークレットビーチに行く方法を紹介。安全面、潮位、リーフ、ジェットツアーやローカルガイドを使うメリットをまとめました。",
    date: "2026.07.31",
    readTime: "5分",
    mainImage: img("v1784949980/DJI_20260724131535_0015_D_robale.webp"),
    leadText:
      "宮古島には、ガイドブックに大きく載っていない静かな海や、海況が合う時だけ行ける場所があります。ただし、本当に人が少ない場所ほど、潮位・リーフ・風・立ち入りルールなど注意が必要です。安全に秘境を楽しむなら、ローカルガイドやジェットツアーを使うのがおすすめです。",
    tocImage: img("v1784949980/DJI_20260724131535_0015_D_robale.webp"),
    toc: [
      "秘境は場所よりも条件が大切",
      "ローカルガイドと行くメリット",
      "ジェットでしか行けない海へ",
    ],
    cta: {
      title: "秘境へ行くなら安全に",
      text: "当日の海況に合わせて、ジェットでしか行けない秘境・シークレットビーチへ完全プライベートでご案内します。",
      buttonText: "ジェットツアーを見る",
      path: "/tours/jet-private-secret-tour",
    },
    points: [
      {
        number: "01",
        title: "秘境は場所よりも条件が大切",
        area: "Safety",
        image: img("v1785006839/DJI_20260723120636_0026_D_small_bgbdwa.jpg"),
        text: "同じ場所でも、潮位や風向きによって安全性も美しさも変わります。SNSで見た場所へ自己判断で向かうより、その日の条件に合った場所を選ぶことが大切です。",
        rows: [
          ["確認", "潮位 / 風 / 波 / 立ち入りルール"],
          ["注意", "リーフや流れがある場所は自己判断で入らない"],
          ["おすすめ", "ローカルガイドに相談"],
        ],
        hashtags: ["#秘境", "#シークレットビーチ", "#宮古島"],
      },
      {
        number: "02",
        title: "ジェットでしか行けない海へ",
        area: "Jet Tour",
        image: img(
          "v1784950297/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-07-25_12.30.55_nbbdaq.png",
        ),
        text: "船や車では行きにくい場所でも、ジェットなら当日の海況に合わせて秘境へ向かえます。完全プライベートで、他に人がいない宮古島を体験できるのが魅力です。",
        rows: [
          ["体験", "ユニの浜 / 秘境・シークレットビーチ"],
          ["撮影", "ドローン撮影付き"],
          ["おすすめ", "究極の非日常体験を求める方"],
        ],
        hashtags: ["#ジェット", "#マリンアクティビティ", "#非日常体験"],
      },
    ],
  },

  "miyakojima-starry-sky-spots": {
    id: 33,
    slug: "miyakojima-starry-sky-spots",
    template: "normal",
    categoryKey: "star",
    category: "Star",
    title: "宮古島で満天の星空を見るには？おすすめ星空スポット",
    description:
      "宮古島で満天の星空を見るための条件と、おすすめ星空スポットを紹介。東平安名崎、池間島、来間島、街灯の少ない海沿いなど、星空観賞に向いた場所をまとめました。",
    date: "2026.07.31",
    readTime: "5分",
    mainImage: img("v1785311449/DSC00588-2_x2m1d1.webp"),
    leadText:
      "宮古島は街灯が少ない場所へ少し移動するだけで、星の見え方が大きく変わります。満天の星空を見たいなら、新月前後、月が出ていない時間、晴天、日没から1時間半後くらい、街灯の少ない場所を意識するのがポイントです。",
    tocImage: img("v1785311449/DSC00588-2_x2m1d1.webp"),
    toc: [
      "満天の星空を見るための条件",
      "おすすめ星空スポット",
      "星空ツアーは旅行前半がおすすめ",
    ],
    points: [
      {
        number: "01",
        title: "満天の星空を見るための条件",
        area: "Star Condition",
        image: img("v1785311449/DSC00588-2_x2m1d1.webp"),
        text: "宮古島で星空を見るなら、新月前後、月が出ていない時間帯、晴天、日没から1時間半後くらい、街灯の少ない場所が大切です。特に月明かりはかなり明るいため、星を目的にするなら新月付近がおすすめです。",
        rows: [
          ["条件", "新月前後 / 月が出ていない時間 / 晴天"],
          ["時間", "日没から1時間半後くらい"],
          ["場所", "街灯の少ない海沿いや離島側"],
        ],
        hashtags: ["#星空", "#新月", "#宮古島"],
      },
      {
        number: "02",
        title: "おすすめ星空スポット",
        area: "Star Spot",
        image: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
        text: "東平安名崎、池間島や来間島方面、街灯の少ない海沿いは星が見えやすい候補です。同じ宮古島でも、雲や風向き、街明かりの入り方で見え方が変わります。",
        rows: [
          ["東平安名崎", "開けていて街灯が少ない定番スポット"],
          ["橋を渡った離島", "池間島・来間島方面は暗い場所を探しやすい"],
          ["海沿い", "街灯が少ない場所ほど星の数が増えやすい"],
        ],
        hashtags: ["#星空スポット", "#東平安名崎", "#宮古島旅行"],
      },
      {
        number: "03",
        title: "星空ツアーは旅行前半がおすすめ",
        area: "Schedule",
        image: img("v1785311449/DSC00588-2_x2m1d1.webp"),
        text: "星空は海以上に天候に左右されます。旅行最終日に入れてしまうと曇った時に変更しづらいので、旅行前半に予定しておくと別日に調整しやすくなります。",
        rows: [
          ["おすすめ", "旅行前半に予約"],
          ["理由", "曇った時に別日へ変更しやすい"],
          ["注意", "夜は暗い道が多いので運転に注意"],
        ],
        hashtags: ["#星空撮影", "#星空ツアー", "#宮古島"],
      },
    ],
  },

  "miyakojima-today-travel-dashboard": {
    id: 34,
    slug: "miyakojima-today-travel-dashboard",
    template: "normal",
    categoryKey: "drive",
    category: "Drive",
    title: "宮古島を120%楽しむために！今日チェックしたい旅情報",
    description:
      "宮古島旅行を120%楽しむために、今日の天気予報、日の出・日の入り、月の出・月入り、満潮・干潮・潮位、星空指数をまとめてチェックする方法を紹介します。",
    date: "2026.07.31",
    readTime: "5分",
    mainImage: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
    leadText:
      "宮古島は、天気、風、潮位、月明かりでその日の楽しみ方が大きく変わります。海に入る日、星空を見る日、サンセットを狙う日で見るべき情報は違うので、出発前にまとめて確認しておくのがおすすめです。",
    tocImage: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
    toc: [
      "今日の天気予報",
      "日の出・日の入りと月の出・月入り",
      "満潮・干潮・潮位と星空指数",
    ],
    points: [
      {
        number: "01",
        title: "今日の天気予報",
        area: "Weather",
        image: img("v1784466423/DJI_20260718160638_0015_D_gh8w0n.webp"),
        text: "宮古島は晴れ予報でも急に雲が出たり、場所によって天気が変わることがあります。海や撮影の予定がある日は、天気だけでなく風速と風向きもチェックしておくと安心です。",
        rows: [
          ["見るもの", "天気 / 降水確率 / 風速 / 風向き"],
          ["海遊び", "風が強い日は波が立ちやすい"],
          ["撮影", "晴れ間と雲の動きを見る"],
        ],
        hashtags: ["#宮古島旅行", "#天気", "#旅行準備"],
      },
      {
        number: "02",
        title: "今日の日の出・日の入り、月の出・月入り時刻",
        area: "Sun & Moon",
        image: img("v1785311449/DSC00588-2_x2m1d1.webp"),
        text: "朝日、夕日、星空を狙うなら、日の出・日の入りと月の出・月入り時刻は必ず見ておきたい情報です。特に星空は月明かりの影響が大きいので、月が出ていない時間帯を狙うのがおすすめです。",
        rows: [
          ["日の出", "朝活・朝の撮影に重要"],
          ["日の入り", "サンセット鑑賞の目安"],
          ["月の出・月入り", "星空・天の川の見え方に影響"],
        ],
        hashtags: ["#日の入り", "#月の出", "#星空"],
      },
      {
        number: "03",
        title: "今日の満潮・干潮・潮位、星空指数",
        area: "Tide & Star",
        image: img("v1785003708/DJI_20260707132223_0047_D_small_no9d5s.jpg"),
        text: "海の透明感、リーフの出方、SUPやシュノーケルの安全性は潮位で変わります。星空を見るなら、雲量や月明かりに加えて星空指数も参考にすると予定が立てやすくなります。",
        rows: [
          ["潮位", "満潮・干潮・潮位で海の見え方が変わる"],
          ["海遊び", "リーフや流れに注意"],
          ["星空指数", "雲量・月明かりと一緒に確認"],
        ],
        hashtags: ["#潮位", "#星空指数", "#宮古島"],
      },
    ],
  },

  "miyakojima-starry-season-2026": {
    id: 35,
    slug: "miyakojima-starry-season-2026",
    template: "normal",
    categoryKey: "star",
    category: "Star",
    title:
      "宮古島の星空が綺麗に見える時期は？おすすめ日程・天の川情報【2026年版】",
    description:
      "宮古島で星空や天の川が綺麗に見える時期、条件、2026年のおすすめ日程を紹介。新月前後、月が出ていない時間、晴天、街灯の少ない場所がポイントです。",
    date: "2026.07.31",
    readTime: "8分",
    mainImage: img("v1785311449/DSC00588-2_x2m1d1.webp"),
    leadText:
      "宮古島で綺麗な星空を見るために大事なのは、新月前後、月が出ていない時間帯、晴天、日没から1時間半後くらい、街灯の少ない場所です。特に重要なのが月明かり。満月の日は月自体は綺麗ですが、その分星は見えづらくなります。",
    tocImage: img("v1785311449/DSC00588-2_x2m1d1.webp"),
    toc: [
      "宮古島で星空が綺麗に見える条件",
      "星空が綺麗に見える時期と天の川シーズン",
      "2026年 宮古島 星空フォトおすすめ日程",
      "よくある質問",
    ],
    points: [
      {
        number: "01",
        title: "宮古島で星空が綺麗に見える条件",
        area: "Best Condition",
        image: img("v1785311449/DSC00588-2_x2m1d1.webp"),
        text: "まず結論からいうと、宮古島で綺麗な星空を見るために大事なのは、新月前後、月が出ていない時間帯、晴天、日没から1時間半後くらい、街灯の少ない場所です。特に月明かりはかなり明るく、星の見え方に大きく影響します。",
        rows: [
          ["新月前後", "月明かりが少なく、天の川も見えやすい"],
          ["月が出ていない時間帯", "満月の日は星がかなり見えづらい"],
          ["晴天", "雲が多い日は星が隠れやすい"],
          ["時間", "夏は20時〜21時頃の方が綺麗に見える日も多い"],
          ["場所", "街灯の少ない海沿いや離島側がおすすめ"],
        ],
        hashtags: ["#星空", "#新月", "#天の川"],
      },
      {
        number: "02",
        title: "宮古島の星空はなぜ綺麗なの？",
        area: "Miyako Night Sky",
        image: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
        text: "宮古島の星空が綺麗と言われる理由は、街灯が少ない場所が多いこと、海に囲まれていて空が広いこと、南国ならではの星空が見えること、天の川シーズンが綺麗なことです。少し街から離れるだけで、驚くくらい星の数が変わる日があります。",
        rows: [
          ["理由", "街灯が少ない場所が多い"],
          ["空", "海に囲まれていて広く見える"],
          ["季節", "夏の天の川が綺麗"],
        ],
        hashtags: ["#宮古島", "#星空スポット", "#天の川"],
      },
      {
        number: "03",
        title: "宮古島で星空を見るならおすすめの時期",
        area: "Best Season",
        image: img("v1785311449/DSC00588-2_x2m1d1.webp"),
        text: "個人的には、梅雨明け後の6月〜10月頃がおすすめです。空気が安定しやすく、夏の天の川が見え、暖かく過ごしやすい時期です。7月〜9月は、天の川を目的に来る方もかなり増えます。",
        rows: [
          ["おすすめ時期", "梅雨明け後の6月〜10月"],
          ["天の川", "7月〜9月は狙う方が多い"],
          ["注意", "自然相手なので毎回完璧ではない"],
        ],
        hashtags: ["#天の川", "#星空フォト", "#宮古島旅行"],
      },
      {
        number: "04",
        title: "2026年 宮古島 星空フォトおすすめ日程",
        area: "2026 Schedule",
        image: img("v1785311449/DSC00588-2_x2m1d1.webp"),
        text: "星空フォトや天の川を狙うなら、月明かりが少ない時期を中心に旅行日程を考えるのがおすすめです。天候によって見え方は変わりますが、2026年は以下の日程を目安にしてください。",
        rows: [
          ["6月", "2日〜21日頃"],
          ["7月", "2日〜22日頃"],
          ["8月", "1日〜21日頃・31日"],
          ["9月", "1日〜19日頃・30日"],
          ["10月", "1日〜18日頃・29日〜31日"],
          ["11月", "1日〜16日頃・27日〜30日"],
          ["12月", "1日〜16日頃・26日〜31日"],
        ],
        hashtags: ["#2026年", "#星空撮影", "#新月"],
      },
      {
        number: "05",
        title: "Q&A｜宮古島の星空についてよくある質問",
        area: "FAQ",
        image: img("v1785311449/DSC00588-2_x2m1d1.webp"),
        text: "星空は条件によって見え方が大きく変わります。日程を決める時は、時期だけでなく月齢、月の出入り、天気、場所まで合わせて考えるのがおすすめです。",
        rows: [
          ["一番綺麗な時期", "梅雨明け後の6月〜10月頃。特に新月前後がおすすめ"],
          ["満月の日", "星は少なくなるが、月自体はとても綺麗"],
          ["天の川", "条件が良ければ肉眼でも見える"],
          ["予約タイミング", "旅行前半に入れると別日へ調整しやすい"],
          ["一人参加", "一人旅でも参加しやすい"],
        ],
        hashtags: ["#星空", "#Q&A", "#宮古島"],
      },
    ],
  },

  "full-moon-party-japan-miyakojima": {
    id: 36,
    slug: "full-moon-party-japan-miyakojima",
    template: "normal",
    categoryKey: "night",
    category: "Night",
    title: "日本に存在するフルムーンパーティとは？",
    description:
      "日本でも楽しめるフルムーンパーティとして、宮古島で開催されているFULL MOON PARTYを紹介。ドレスコード、雰囲気、参加前の注意点、星空や夜遊びと合わせた楽しみ方をまとめました。",
    date: "2026.07.31",
    readTime: "5分",
    mainImage: img("v1785311449/DSC00588-2_x2m1d1.webp"),
    leadText:
      "フルムーンパーティと聞くと、タイのパンガン島を思い浮かべる方も多いかもしれません。実は日本でも、宮古島で満月をテーマにしたフルムーンパーティが開催されています。白い服をまとい、音楽、火、島の空気、満月の夜を楽しむ、宮古島らしい非日常のナイトイベントです。",
    tocImage: img("v1785311449/DSC00588-2_x2m1d1.webp"),
    toc: [
      "日本のフルムーンパーティは宮古島にある？",
      "どんな雰囲気で楽しめるイベント？",
      "参加前に知っておきたい注意点",
    ],
    points: [
      {
        number: "01",
        title: "日本のフルムーンパーティは宮古島にある？",
        area: "Full Moon Party",
        image: img("v1785311449/DSC00588-2_x2m1d1.webp"),
        text: "宮古島では、満月の夜に合わせたFULL MOON PARTYやMini Moon Partyが開催されることがあります。タイのフルムーンパーティから着想を得つつ、宮古島らしい音楽、食、炎、星空、島の人との距離感を楽しめるイベントです。",
        rows: [
          ["場所", "宮古島 / レーベの村周辺など"],
          ["雰囲気", "音楽 / 火 / 島の夜 / 満月"],
          ["ポイント", "開催日は毎回変わるため公式情報を確認"],
        ],
        hashtags: ["#フルムーンパーティ", "#宮古島", "#夜遊び"],
      },
      {
        number: "02",
        title: "白をまとって楽しむ特別な夜",
        area: "White Dress Code",
        image: img("v1784466423/DJI_20260718160638_0015_D_gh8w0n.webp"),
        text: "宮古島のFULL MOON PARTYでは、ドレスコードが白に設定されることがあります。白い服で集まり、音楽に身をゆだねながら、満月の夜をみんなで楽しむ雰囲気が特徴です。",
        rows: [
          ["ドレスコード", "WHITE（白）の開催例あり"],
          ["楽しみ方", "音楽 / DJ / ライブ / フード / ドリンク"],
          ["相性", "女子旅 / カップル / 友達旅行"],
        ],
        hashtags: ["#宮古島ナイト", "#フルムーン", "#非日常体験"],
      },
      {
        number: "03",
        title: "参加前に知っておきたい注意点",
        area: "Before You Go",
        image: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
        text: "イベントは開催日、会場、料金、駐車場、年齢制限などが毎回変わる可能性があります。特に夜の移動はタクシーや送迎の確保が大切です。お酒を飲む場合は絶対に運転せず、帰り方まで決めてから楽しみましょう。",
        rows: [
          ["確認", "開催日 / 会場 / 料金 / 年齢制限"],
          ["移動", "駐車場や帰りのタクシーを事前確認"],
          ["注意", "飲酒運転は絶対にしない"],
        ],
        hashtags: ["#宮古島旅行", "#夜遊び", "#旅行準備"],
      },
    ],
  },

  "without-car-plan": {
    id: 9,
    slug: "without-car-plan",
    template: "normal",
    categoryKey: "drive",
    category: "Drive",
    title: "宮古島で車なしでも楽しむ1日プラン",
    description:
      "レンタカーなしでも宮古島を楽しみたい方向けに、市街地、近場ビーチ、カフェ、夕日を中心にした1日プランを紹介します。",
    date: "2026.07.22",
    readTime: "5分",
    mainImage: img("v1784191325/image9_vwojco.webp"),
    leadText:
      "宮古島は車移動が便利ですが、車なしでもエリアを絞れば十分楽しめます。市街地周辺、パイナガマ方面、カフェやグルメを組み合わせると、移動の負担を抑えながら島時間を味わえます。",
    tocImage: img("v1784191325/image9_vwojco.webp"),
    toc: [
      "午前：市街地周辺で朝食と散策",
      "昼：近場カフェやランチへ",
      "夕方：パイナガマ周辺で夕日",
    ],
    points: [
      {
        number: "01",
        title: "午前：市街地周辺で朝食と散策",
        area: "Morning",
        image: img("v1784191325/image9_vwojco.webp"),
        text: "まずはホテル周辺や市街地で朝食を取り、徒歩圏内のカフェやショップをゆっくり巡るのがおすすめです。暑い日は無理に歩きすぎず、タクシーも組み合わせると快適です。",
        rows: [
          ["おすすめ", "市街地 / 朝カフェ / 散策"],
          ["移動", "徒歩、タクシー、バスを組み合わせる"],
        ],
        hashtags: ["#車なし宮古島", "#カフェ巡り", "#宮古島"],
      },
      {
        number: "02",
        title: "昼：近場カフェやランチへ",
        area: "Lunch",
        image: img("v1784292789/DSC00325_htmozu.jpg"),
        text: "昼は市街地のランチやカフェを中心に選ぶと移動が楽です。天気が良ければ海が見える場所、雨なら店内で過ごしやすいお店を選ぶと満足度が上がります。",
        rows: [
          ["おすすめ", "宮古そば / カフェごはん / 島グルメ"],
          ["ポイント", "Google Mapで現在地から近い店を選ぶ"],
        ],
        hashtags: ["#宮古島ランチ", "#グルメ", "#モデルコース"],
      },
      {
        number: "03",
        title: "夕方：パイナガマ周辺で夕日",
        area: "Sunset",
        image: img("v1784466423/DJI_20260718160638_0015_D_gh8w0n.webp"),
        text: "夕方はパイナガマやトゥリバー方面へ。市街地から比較的アクセスしやすく、海辺で夕日を眺めながら写真を残しやすいエリアです。",
        rows: [
          ["おすすめ", "夕日 / 海辺散歩 / 写真撮影"],
          ["撮影", "日没前後の空色を広めに入れる"],
        ],
        hashtags: ["#サンセット", "#宮古島写真", "#撮影"],
      },
    ],
  },

  "sunset-spots-best5": {
    id: 12,
    slug: "sunset-spots-best5",
    template: "normal",
    categoryKey: "sunset",
    category: "Sunset",
    title: "宮古島のおすすめサンセットスポット5選",
    description:
      "宮古島旅行で夕日を見たい方へ。17END、佐和田の浜、トゥリバー、パイナガマ、長間浜など、サンセットが綺麗に見えるおすすめスポットを紹介します。",
    date: "2026.07.31",
    readTime: "6分",
    mainImage: img("v1784466423/DJI_20260718160638_0015_D_gh8w0n.webp"),
    leadText:
      "宮古島の夕日は、場所によって見え方が大きく変わります。海に沈む夕日、岩のシルエット、橋と空のグラデーションなど、旅の最後にゆっくり眺めたいサンセットスポットを5つ紹介します。",
    tocImage: img("v1784466423/DJI_20260718160638_0015_D_gh8w0n.webp"),
    toc: [
      "17END",
      "佐和田の浜",
      "トゥリバーサンセットビーチ",
      "パイナガマビーチ",
      "長間浜",
    ],
    points: [
      {
        number: "01",
        title: "17END",
        area: "下地島 / 宮古ブルー",
        image: img("v1784682749/DJI_20260721090156_0009_D_al9eb0.webp"),
        mapUrl: map("17END 下地島 宮古島"),
        text: "下地島らしい宮古ブルーを見に行く絶景スポット。干潮時に絶景が見れます。夕方は海の色と空の色がゆっくり変わっていくので、日没前から少し早めに着いておくのがおすすめです。",
        rows: [
          ["おすすめ", "干潮 / 宮古ブルー / 空のグラデーション"],
          ["撮影ポイント", "海と空を広く入れて、日没前の色の変化を残す"],
        ],
        hashtags: ["#17END", "#下地島", "#サンセット", "#宮古ブルー"],
      },
      {
        number: "02",
        title: "佐和田の浜",
        area: "伊良部島 / 岩のシルエット",
        image: img("v1784466423/DJI_20260718160638_0015_D_gh8w0n.webp"),
        mapUrl: map("佐和田の浜 宮古島"),
        text: "海に点在する岩と夕日が重なる、伊良部島らしいサンセットスポット。日中の穏やかな雰囲気とは違い、夕方はシルエットがきれいに出ます。",
        rows: [
          ["おすすめ", "岩のシルエット / 静かな海 / 伊良部島"],
          ["撮影ポイント", "人物を小さく入れると、空の広さが伝わりやすい"],
        ],
        hashtags: ["#佐和田の浜", "#伊良部島", "#宮古島サンセット"],
      },
      {
        number: "03",
        title: "トゥリバーサンセットビーチ",
        area: "市街地近く / 夕方散歩",
        image: img("v1784191325/image9_vwojco.webp"),
        mapUrl: map("トゥリバーサンセットビーチ 宮古島"),
        text: "市街地からアクセスしやすく、夕方の散歩にも使いやすいビーチ。旅行最終日や夜ご飯前に、無理なくサンセットを見たい時にもおすすめです。",
        rows: [
          ["おすすめ", "市街地から近い / 海辺散歩 / 夕日"],
          ["撮影ポイント", "日没後の淡い空色まで少し待つ"],
        ],
        hashtags: ["#トゥリバー", "#サンセットビーチ", "#夕日"],
      },
      {
        number: "04",
        title: "パイナガマビーチ",
        area: "平良 / 気軽に行ける",
        image: img("v1783928240/DJI_20260707115904_0007_D_cui3oa.webp"),
        mapUrl: map("パイナガマビーチ 宮古島"),
        text: "ホテルや市街地から行きやすく、旅の合間に立ち寄りやすいサンセットスポット。大きく移動せずに、海辺でゆっくり夕方を過ごせます。",
        rows: [
          ["おすすめ", "市街地 / 気軽 / 海辺でゆっくり"],
          ["撮影ポイント", "砂浜や波打ち際を手前に入れる"],
        ],
        hashtags: ["#パイナガマビーチ", "#宮古島夕日", "#海辺散歩"],
      },
      {
        number: "05",
        title: "長間浜",
        area: "来間島 / 静かな夕日",
        image: img("v1783928437/DJI_20260707115907_0008_D_xag4ot.webp"),
        mapUrl: map("長間浜 宮古島"),
        text: "来間島にある、静かに夕日を眺めたい人におすすめのビーチ。人が少ないタイミングを狙うと、宮古島らしいゆったりした夕方を感じられます。",
        rows: [
          ["おすすめ", "来間島 / 静かなビーチ / サンセット"],
          ["注意", "足元や帰り道が暗くなる前に移動する"],
        ],
        hashtags: ["#長間浜", "#来間島", "#サンセット"],
      },
    ],
  },

  "beach-best5": {
    id: 10,
    slug: "beach-best5",
    template: "normal",
    categoryKey: "drive",
    category: "Drive",
    title: "初めての宮古島で行きたいビーチ5選",
    description:
      "初めての宮古島旅行で行きたい、与那覇前浜、砂山、17ENDなどの定番ビーチを5つに絞って紹介します。",
    date: "2026.07.22",
    readTime: "6分",
    mainImage: img("v1783928437/DJI_20260707115907_0008_D_xag4ot.webp"),
    leadText:
      "宮古島の魅力を一番感じやすいのは、やっぱり美しいビーチ。初めての旅行でも行きやすく、写真や動画に残しやすい場所を5つに絞りました。",
    tocImage: img("v1783928437/DJI_20260707115907_0008_D_xag4ot.webp"),
    toc: ["与那覇前浜", "砂山ビーチ", "17END", "佐和田の浜", "新城海岸"],
    points: [
      {
        number: "01",
        title: "与那覇前浜ビーチ",
        area: "白砂 / 王道",
        image: img("v1783928437/DJI_20260707115907_0008_D_xag4ot.webp"),
        text: "白い砂浜と透明度の高い海が広がる、宮古島を代表するビーチ。初めての宮古島なら一度は見ておきたい場所です。",
        rows: [["おすすめ", "白砂 / 広いビーチ / 写真撮影"]],
        hashtags: ["#与那覇前浜", "#ビーチ", "#宮古島"],
      },
      {
        number: "02",
        title: "砂山ビーチ",
        area: "自然感 / 岩場",
        image: img("v1782544346/DJI_20260619092553_0013_D_mggybx.jpg"),
        text: "砂の坂を越えた先に海が広がる人気スポット。自然感のある写真を残したい人におすすめです。",
        rows: [["注意", "足元が砂で歩きにくいので歩きやすい靴がおすすめ"]],
        hashtags: ["#砂山ビーチ", "#映えスポット", "#撮影"],
      },
      {
        number: "03",
        title: "17END",
        area: "下地島 / 透明度",
        image: img("v1784682749/DJI_20260721090156_0009_D_al9eb0.webp"),
        text: "遠浅の海のグラデーションが美しい下地島の人気スポット。干潮や晴れた時間帯は特に海色が出やすいです。",
        rows: [["おすすめ", "ドライブ / 海のグラデーション / 写真"]],
        hashtags: ["#17END", "#下地島", "#宮古ブルー"],
      },
      {
        number: "04",
        title: "佐和田の浜",
        area: "伊良部島 / サンセット",
        image: img("v1784466423/DJI_20260718160638_0015_D_gh8w0n.webp"),
        text: "海に点在する岩が印象的なビーチ。日中だけでなく、夕方のサンセット時間にも雰囲気が出ます。",
        rows: [["撮影", "夕方は岩のシルエットを広く入れる"]],
        hashtags: ["#佐和田の浜", "#サンセット", "#伊良部島"],
      },
      {
        number: "05",
        title: "新城海岸",
        area: "シュノーケル / 東海岸",
        image: img("v1784350646/DJI_20260706065434_0044_D_kd2pm5.webp"),
        text: "海遊びやシュノーケルのイメージが強いビーチ。海に入る場合はルールや海況を確認して、安全第一で楽しみましょう。",
        rows: [["注意", "潮位や風、現地ルールを必ず確認"]],
        hashtags: ["#新城海岸", "#ビーチ", "#宮古島旅行"],
      },
    ],
  },

  "rainy-day-plan": {
    id: 11,
    slug: "rainy-day-plan",
    template: "shops",
    mediaLayout: "split",
    categoryKey: "rainy",
    category: "Rainy Day",
    title: "雨の日でも楽しめる宮古島の室内体験",
    description:
      "雨の日の宮古島旅行でも楽しめる、レジンアート、シーサー作り、パーマネントジュエリー、カスタムアクセサリー作り体験を紹介します。",
    date: "2026.07.22",
    readTime: "6分",
    mainImage: img("v1788261035/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-09-01_20.09.37_a4hlqg.png"),
    leadText:
      "宮古島旅行で一日雨の日は、室内でゆっくり楽しめる手作り体験に切り替えるのもおすすめです。旅の思い出を形に残せるレジンアートやシーサー作り、パーマネントジュエリー作り、カスタムアクセサリー作り体験をまとめました。",
    tocImage: img("v1788261035/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-09-01_20.09.37_a4hlqg.png"),
    toc: [
      "筋トレで解決",
      "レジンアート体験",
      "シーサー作り",
      "アクセサリー作り",
    ],
    points: [
      {
        number: "01",
        title: "筋トレで解決",
        area: "Gym",
        text: "実は宮古島にもエニタイムフィットネスがあります。雨でやることがない時こそ筋トレに集中でき逆にチャンスです。宮古島どうだったと聞かれたら最高のトレーニングができたと答えておきましょう。",
        shops: [
          {
            name: "エニタイムフィットネス 宮古島店",
            area: "宮古島",
            instagramPostUrl:
              "https://www.instagram.com/p/DcvCMsfvxZw/?utm_source=ig_web_copy_link&igsi=MzRlODBiNWFlZA==",
            genre: "ジム / 24時間営業",
            text: "全国・世界に展開するフィットネスジム。雨で予定が崩れた日でも、筋トレに切り替えれば旅の時間を有意義に使えます。",
            hashtags: ["#エニタイムフィットネス", "#雨の日", "#宮古島体験"],
          },
        ],
        hashtags: ["#筋トレ", "#雨の日", "#宮古島体験"],
      },
      {
        number: "02",
        title: "レジンアート体験",
        area: "Resin Art",
        text: "宮古島は海に入れない日でも、旅の思い出を形に残せます。宮古ブルーをイメージした作品作りは、雨の日の過ごし方にもぴったりです。",
        shops: [
          {
            name: "blue_385_resinart",
            area: "伊良部仲地",
            instagramPostUrl:
              "https://www.instagram.com/reel/DcbBdbuzP2B/?utm_source=ig_web_copy_link&igsi=MzRlODBiNWFlZA==",
            images: [],
            mapUrl: "https://maps.app.goo.gl/wybWZRhvhdA9h4bq9",
            mapEmbedUrl:
              "https://www.google.com/maps?q=%E6%B2%96%E7%B8%84%E7%9C%8C%E5%AE%AE%E5%8F%A4%E5%B3%B6%E5%B8%82%E4%BC%8A%E8%89%AF%E9%83%A8%E4%BB%B2%E5%9C%B096-2&output=embed",
            instagramUrl: "",
            instagramLabel: "@blue_385_resinart",
            websiteUrl:
              "https://resin-atelierblue.com/?utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAcGRvZgJleHRuA2FlbQIxMQBzcnRjBmFwcF9pZA85MzY2MTk3NDMzOTI0NTkAAaciFCEQSmYJshYkzDQMd3ZvDe__YlQzi_XUHvlxL7-m9T8G71fr9H2j7FVhEA_aem_XhFjU8ftthS6PrNudtjqcg",
            websiteLabel: "予約サイトを見る",
            genre: "レジンアート / 室内体験",
            recommendedMenu: "宮古島 海レジン体験",
            businessHours: "9:00〜21:00",
            closedDays: "要確認",
            text: "空間ごと楽しめる小さな南国アトリエ。宮古島の海をイメージしたレジン作品を作れる体験で、雨の日でも旅の思い出を形に残せます。",
            rows: [
              ["住所", "沖縄県宮古島市伊良部仲地96-2"],
              ["電話", "080-4200-2195"],
              ["所要時間", "約60分〜120分"],
              ["対象", "お子様OK"],
              ["予約", "当日予約OK"],
              ["営業時間", "9:00〜21:00"],
            ],
            hashtags: ["#レジンアート", "#雨の日", "#宮古島体験"],
          },
        ],
        hashtags: ["#レジンアート", "#雨の日", "#宮古島体験"],
      },
      {
        number: "03",
        title: "シーサー作り",
        area: "Shisa Craft",
        text: "宮古島らしい旅の記念を作りたい方には、シーサー作りもおすすめ。家族旅行やカップル、友達同士でも楽しみやすい室内体験です。",
        shops: [
          {
            name: "シーサーモノガタリ Gallery",
            area: "平良松原",
            instagramPostUrl:
              "https://www.instagram.com/p/DHSqLEKRYVY/?utm_source=ig_web_copy_link&igsi=MzRlODBiNWFlZA==",
            mapUrl: map("シーサーモノガタリ 沖縄県宮古島市平良字松原1135-6"),
            instagramUrl: "",
            instagramLabel: "@seasahstory",
            genre: "シーサー作り / 室内体験",
            recommendedMenu: "シーサー作り体験",
            businessHours: "10:00〜18:00",
            closedDays: "なし",
            text: "宮古空港から車で約5分の場所にある、雨の日でも楽しみやすい室内体験スポット。宮古島旅行の記念になるシーサー作りにおすすめです。",
            rows: [
              ["住所", "沖縄県宮古島市平良字松原1135-6"],
              ["アクセス", "宮古空港から車で約5分"],
              ["電話", "0980-75-0660"],
              ["営業時間", "月〜日 10:00〜18:00"],
            ],
            hashtags: ["#シーサー作り", "#雨の日", "#宮古島体験"],
          },
        ],
        hashtags: ["#シーサー作り", "#雨の日", "#宮古島体験"],
      },
      {
        number: "04",
        title: "アクセサリー作り",
        area: "Accessory",
        text: "身につけて持ち帰れるアクセサリー作りは、雨の日でも旅の余韻を残せる体験。宮古島旅行の記念やプレゼントにもおすすめです。",
        shops: [
          {
            name: "宮古島元祖パーマネントジュエリー専門店 ちゅらリング",
            area: "伊良部",
            mapUrl: map("ちゅらリング宮古島 沖縄県宮古島市伊良部前里添588-73"),
            instagramPostUrl:
              "https://www.instagram.com/reel/DaQE_AvpM58/?utm_source=ig_web_copy_link&igsi=MzRlODBiNWFlZA==",
            instagramUrl: "",
            instagramLabel: "@churaring.permanentjewelry",
            genre: "パーマネントジュエリー / アクセサリー",
            recommendedMenu: "セミオーダーのパーマネントジュエリー",
            businessHours: "10:00〜18:00",
            closedDays: "水曜日",
            text: "セミオーダーで作る、旅の記念。宮古島の思い出をアクセサリーとして身につけたい方におすすめです。",
            rows: [
              ["住所", "沖縄県宮古島市伊良部前里添588-73"],
              ["電話", "070-1832-4247"],
              ["営業時間", "月・火・木・金・土・日 10:00〜18:00"],
            ],
            hashtags: ["#パーマネントジュエリー", "#雨の日", "#宮古島体験"],
          },
          {
            name: "chura accessory 385",
            area: "伊良部",
            instagramPostUrl:
              "https://www.instagram.com/reel/Dau5AdnpZTI/?utm_source=ig_web_copy_link&igsi=MzRlODBiNWFlZA==",
            mapUrl: "https://maps.app.goo.gl/FDZJrbHbefxMaH9t5",
            mapEmbedUrl:
              "https://www.google.com/maps?q=%E6%B2%96%E7%B8%84%E7%9C%8C%E5%AE%AE%E5%8F%A4%E5%B3%B6%E5%B8%82%E4%BC%8A%E8%89%AF%E9%83%A8%E5%AD%97%E5%89%8D%E9%87%8C%E6%B7%BB588-73&output=embed",
            instagramUrl: "",
            instagramLabel: "@chura_accessory385",
            genre: "カスタムアクセサリー / 室内体験",
            recommendedMenu: "南国カスタムアクセサリー作り",
            businessHours: "10:00〜18:00（最終受付17:00）",
            closedDays: "水曜日",
            text: "宮古島で作る南国カスタムアクセサリー。U15 kids専用チェーンもあり、雨の日の家族旅行にも選びやすい体験です。",
            rows: [
              ["住所", "沖縄県宮古島市伊良部字前里添588-73"],
              ["予約", "予約不可。来店順に案内"],
              ["営業時間", "10:00〜18:00（最終受付17:00）"],
            ],
            hashtags: ["#カスタムアクセサリー", "#雨の日", "#宮古島体験"],
          },
        ],
        hashtags: ["#アクセサリー作り", "#雨の日", "#宮古島体験"],
      },
    ],
  },

  "drone-photo-spots": {
    id: 12,
    slug: "drone-photo-spots",
    template: "normal",
    categoryKey: "tour",
    category: "Tour",
    title: "宮古島でドローン撮影したい絶景スポット5選",
    description:
      "宮古島でドローン撮影すると映える、橋、ビーチ、サンセット、宮古ブルーの絶景スポットを5つ紹介します。",
    date: "2026.07.22",
    readTime: "6分",
    mainImage: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
    leadText:
      "宮古島の海は、地上から見るだけでも美しいですが、ドローンで上から見ると海のグラデーションや地形の魅力がより伝わります。撮影ルールや安全に配慮しながら、空撮で残したいスポットをまとめました。",
    tocImage: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
    toc: ["伊良部大橋", "17END", "与那覇前浜", "佐和田の浜", "来間大橋"],
    cta: {
      title: "秘境フォトツアーでドローン撮影",
      text: "宮古島の絶景スポットを巡りながら、ドローン撮影と一眼カメラ撮影で旅の思い出を残します。",
      buttonText: "秘境フォトツアーを予約する",
      path: "/tours/one-day-photogenic-tour",
    },
    points: [
      {
        number: "01",
        title: "伊良部大橋",
        area: "Bridge",
        image: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
        text: "宮古島らしい橋と海のスケールを残しやすいスポット。橋の上や周辺は安全とルール確認が大切なので、撮影可能な場所から無理なく狙いましょう。",
        rows: [["撮影", "橋と海のラインを斜めに入れると奥行きが出る"]],
        hashtags: ["#伊良部大橋", "#ドローン", "#宮古ブルー"],
      },
      {
        number: "02",
        title: "17END",
        area: "Blue Gradation",
        image: img("v1784682749/DJI_20260721090156_0009_D_al9eb0.webp"),
        text: "遠浅の海の色が出やすい下地島の人気スポット。干潮や晴天の時間帯は、宮古ブルーのグラデーションが特にきれいに見えます。",
        rows: [["撮影", "真上だけでなく斜めから海の奥行きを出す"]],
        hashtags: ["#17END", "#ドローン撮影", "#下地島"],
      },
      {
        number: "03",
        title: "与那覇前浜",
        area: "White Sand",
        image: img("v1783928437/DJI_20260707115907_0008_D_xag4ot.webp"),
        text: "白砂と海のコントラストが美しいビーチ。人が多い時間帯は周囲に配慮しながら、広い砂浜と海を大きく入れる構図がおすすめです。",
        rows: [["撮影", "白砂、波打ち際、海の色を三層で見せる"]],
        hashtags: ["#与那覇前浜", "#ドローン", "#撮影"],
      },
      {
        number: "04",
        title: "佐和田の浜",
        area: "Sunset",
        image: img("v1784466423/DJI_20260718160638_0015_D_gh8w0n.webp"),
        text: "点在する岩と夕日の雰囲気が印象的な場所。夕方の空色と水面を広く入れると、静かな宮古島らしい映像になります。",
        rows: [["撮影", "夕方は暗くなりすぎる前に撮る"]],
        hashtags: ["#佐和田の浜", "#サンセット", "#ドローン"],
      },
      {
        number: "05",
        title: "来間大橋",
        area: "Kurima Island",
        image: img("v1784682749/DJI_20260721085951_0005_D-2_mb4lnk.webp"),
        text: "来間島へ向かう橋と海の色が美しいエリア。ドライブの流れで立ち寄りやすく、橋・島・海をまとめて残しやすいスポットです。",
        rows: [["撮影", "橋を中心に、海の広がりを大きく入れる"]],
        hashtags: ["#来間大橋", "#ドローン", "#宮古島ドライブ"],
      },
    ],
  },

  "jet-secret-beach-tour": {
    id: 7,
    slug: "jet-secret-beach-tour",
    template: "normal",
    categoryKey: "tour",
    category: "Tour",
    title: "ジェットでしか辿り着けない本当の宮古島に出会えるツアー",
    description:
      "宮古島にはジェットでしか行けない秘境があります。ユニの浜やシークレットビーチを巡り、ドローン撮影付きで本当の宮古島を残せるプライベートジェットツアーを紹介します。",
    date: "2026.07.25",
    readTime: "5分",
    mainImage: img("v1784949980/DJI_20260724131535_0015_D_robale.webp"),
    leadText:
      "宮古島には、ツアーでしか行けない特別な絶景が隠れています。ジェットで誰もいない海を走り、幻の浜「ユニの浜」や秘境・シークレットビーチへ。透明度の高い宮古ブルーを完全プライベートで楽しみながら、ドローン撮影で旅の思い出を残せるツアーです。本当の宮古島の絶景を一緒に見ましょう。",
    tocImage: img(
      "v1784950297/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-07-25_12.30.45_x4brgv.png",
    ),
    youtubeUrl: "https://youtu.be/6tKIyGyJn_k",
    youtubeTitle: "ジェットで巡るユニの浜・秘境ビーチツアー",
    galleryImages: [
      img(
        "v1784950297/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-07-25_12.30.45_x4brgv.png",
      ),
      img("v1784949980/DJI_20260724131535_0015_D_robale.webp"),
      img("v1784944008/DJI_20260724142728_0046_D_fjvofb.webp"),
      img(
        "v1784950296/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-07-25_12.31.09_s41ws9.png",
      ),
      img(
        "v1784950297/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-07-25_12.30.55_nbbdaq.png",
      ),
    ],
    toc: [
      "理由1：ジェットでしか行けない秘境へ行ける",
      "理由2：ユニの浜とシークレットビーチを巡れる",
      "理由3：ドローン撮影付きで絶景を残せる",
    ],
    cta: {
      title: "ジェットで巡るユニの浜・秘境ビーチツアー",
      text: "1組限定の完全プライベートツアー。宮古島の透明度の高い海と、ジェットでしか行けない秘境へご案内します。",
      buttonText: "ジェットツアーを見る",
      path: "/tours/jet-private-secret-tour",
    },
    points: [
      {
        number: "01",
        title: "理由1：ジェットでしか行けない秘境へ行ける",
        area: "Secret Beach",
        media: {
          videoUrl:
            "https://res.cloudinary.com/drxijtp8g/video/upload/v1785168449/Timeline_1_xsdcck.mp4",
        },
        text: "宮古島には、車や徒歩では辿り着けない秘境があります。ジェットなら海からしか入れないエリアへ向かえるため、観光地とは違う見たことのない宮古島を体験できます。",
        rows: [
          ["体験", "ジェットで秘境・シークレットビーチへ"],
          ["雰囲気", "観光客の少ない静かな浜"],
          ["おすすめ", "人の少ない海で特別な時間を過ごしたい方"],
        ],
        hashtags: [
          "#宮古島",
          "#ジェットツアー",
          "#秘境",
          "#シークレットビーチ",
          "#マリンアクティビティ",
        ],
      },
      {
        number: "02",
        title: "理由2：ユニの浜とシークレットビーチを巡れる",
        area: "Yuni Beach",
        image: img("v1784944008/DJI_20260724142728_0046_D_fjvofb.webp"),
        text: "幻の浜として知られるユニの浜に加え、当日の海況に合わせてジェットでしか行けないシークレットビーチへご案内します。複数スポットを巡れるので、短時間でも満足感のある体験になります。",
        rows: [
          ["行き先", "ユニの浜 / 秘境・シークレットビーチ"],
          ["所要時間", "約2.5時間(お迎え・送迎時間を除く)"],
          ["料金", "¥35,000 / 1名"],
        ],
        hashtags: ["#ユニの浜", "#宮古ブルー", "#秘境", "#シークレットビーチ"],
      },
      {
        number: "03",
        title: "理由3：ドローン撮影付きで絶景を残せる",
        area: "Drone Shooting",
        image: img(
          "v1784950297/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-07-25_12.30.55_nbbdaq.png",
        ),
        text: "誰もいない貸切の秘境での撮影はSNS映え間違いなし。プロカメラマンが撮るこのツアーでしか撮れない写真・映像を残せます。ツアー終了後に、iPhoneで撮影したデータとドローンデータをお渡しします。",
        rows: [
          ["撮影", "ドローン撮影付き"],
          ["データ", "iPhone撮影データ / ドローンデータ"],
          ["おすすめ", "旅行の思い出 / SNS投稿 / ショート動画"],
        ],
        hashtags: ["#ドローン", "#撮影", "#旅動画", "#マリンアクティビティ"],
      },
    ],
  },

  "girls-trip-photo-movie-miyakojima": {
    id: 37,
    slug: "girls-trip-photo-movie-miyakojima",
    template: "memory",
    categoryKey: "shooting",
    category: "Shooting",
    title: "宮古島女子旅で絶対に残したい写真と映像",
    description:
      "宮古島 女子旅 写真で探している方へ。透明な海、SUP、ドローン、シークレットビーチ、自然体の笑顔まで、実際にどんな写真や映像が撮れるのかを紹介します。",
    date: "2026.08.08",
    readTime: "5分",
    tags: [
      "#宮古島",
      "#宮古島女子旅",
      "#女子旅",
      "#撮影",
      "#秘境SUP",
      "#秘境",
      "#SUP",
      "#シークレットビーチ",
      "#完全プライベート",
      "#観光マップに載ってない",
      "#非日常体験",
      "#映え",
      "#秘境フォトツアー",
    ],
    mainImage: img("v1786120675/DSC00888_tk8uhe.webp"),
    leadText:
      "宮古島女子旅で一番残したいのは、ただ景色を写した写真ではなく、その時の空気や楽しさまで思い出せる写真と映像。ここでは、秘境フォトツアーや秘境SUPで実際に撮れるカットを、写真・動画・ドローン映像に分けて紹介します。",
    memoryIntro: {
      eyebrow: {
        JP: "Photo & Movie",
        EN: "Photo & Movie",
        中文: "照片与影片",
        한국어: "사진과 영상",
      },
      title: {
        JP: "このツアーで撮れる写真・映像",
        EN: "Photos and Videos You Can Capture",
        中文: "这个行程可以拍到的照片与影片",
        한국어: "이 투어에서 남길 수 있는 사진과 영상",
      },
      text: {
        JP: "宮古島の海、空、SUP、ドローン映像まで。あとから見返した時に旅の空気まで思い出せるように、場所や時間帯に合わせて撮影します。",
        EN: "From the ocean and sky to SUP scenes and drone footage, we shoot according to the location and timing so you can remember the whole feeling of the trip.",
        中文: "从宫古岛的大海、天空到SUP和无人机影像，我们会根据地点和时间拍摄，让你之后回看时也能想起旅行的氛围。",
        한국어:
          "미야코지마의 바다와 하늘, SUP 장면, 드론 영상까지 장소와 시간대에 맞춰 촬영해 여행의 분위기까지 다시 떠올릴 수 있게 남깁니다.",
      },
    },
    tocImage: img("v1786120675/DSC00888_tk8uhe.webp"),
    toc: [
      "宮古ブルーの海で撮る写真",
      "ドローンで残す空からの映像",
      "SUPでしか来れない秘境カット",
      "シークレットビーチの自然体フォト",
      "ショートムービーに残す旅の空気",
      "星空や夕方に撮る特別な1枚",
    ],
    cta: {
      title: "映える写真と映像を残す秘境フォトツアー",
      text: "宮古ブルーの海、シークレットビーチ、ドローン映像まで。写真に残したい雰囲気に合わせて、1組限定でご案内します。",
      buttonText: "秘境フォトツアーを見る",
      path: "/tours/one-day-photogenic-tour",
    },
    points: [
      {
        number: "01",
        title: "宮古ブルーの海で撮る写真",
        area: "Blue Ocean Photo",
        image: img("v1785776522/DJI_20260802131800_0033_D_drlb1i.webp"),
        text: "透明度の高い海を背景に、自然に歩いている姿、振り返った瞬間、友達同士で笑っている瞬間を撮影します。作り込みすぎないのに、宮古島らしさが伝わる写真が残せます。",
        rows: [
          ["撮れるもの", "海を背景にしたポートレート / 女子旅の集合写真"],
          ["雰囲気", "透明感 / 爽やか / 自然体"],
          ["おすすめ", "プロフィール写真 / Instagram投稿 / 旅の記念"],
        ],
        hashtags: ["#宮古ブルー", "#女子旅", "#映え", "#撮影"],
      },
      {
        number: "02",
        title: "ドローンで残す空からの映像",
        area: "Drone Movie",
        image: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
        text: "海のグラデーション、白い砂浜、宮古島らしい地形を上から撮影します。人が小さく映ることで、海の広さや貸切感が伝わる映像になります。",
        rows: [
          ["撮れるもの", "空撮写真 / ドローン動画 / 旅のオープニング映像"],
          ["雰囲気", "スケール感 / 非日常 / 映画っぽい"],
          ["おすすめ", "リール動画 / ショートムービー / カップル・女子旅"],
        ],
        hashtags: ["#ドローン", "#旅動画", "#非日常体験", "#宮古島"],
      },
      {
        number: "03",
        title: "SUPでしか来れない秘境カット",
        area: "Hidden SUP",
        image: img("v1785005393/DSC00191_small_lhfvnk.jpg"),
        text: "SUPで海の上を進むからこそ行ける静かな場所で撮影します。ボードに座っている姿、海に浮かぶ後ろ姿、透明な水面を入れた写真など、普通のビーチ写真とは違う雰囲気になります。",
        rows: [
          ["撮れるもの", "SUP写真 / 水面カット / 秘境感のある動画"],
          ["雰囲気", "癒し / 静か / 完全プライベート"],
          ["おすすめ", "人が少ない海で撮りたい方"],
        ],
        hashtags: ["#秘境SUP", "#SUP", "#完全プライベート", "#癒し"],
      },
      {
        number: "04",
        title: "シークレットビーチの自然体フォト",
        area: "Secret Beach",
        image: img("v1784945639/DSC00440-2_syxyio.webp"),
        text: "観光マップに載っていないような、人が少ないビーチで撮影します。ポーズを決めすぎず、歩く・笑う・海を見るだけでも、旅らしい自然な写真になります。",
        rows: [
          ["撮れるもの", "後ろ姿 / 横顔 / 友達同士の自然な笑顔"],
          ["雰囲気", "大人っぽい / 静か / プライベート感"],
          ["おすすめ", "定番スポット以外で撮りたい方"],
        ],
        hashtags: ["#シークレットビーチ", "#観光マップに載ってない", "#映え"],
      },
      {
        number: "05",
        title: "ショートムービーに残す旅の空気",
        area: "Short Movie",
        image: img("v1785311757/IMG_8564_jkfm7r.webp"),
        text: "写真だけでは伝わりにくい、移動中の空気感や海で遊んでいる雰囲気を短い映像で残します。あとで見返した時に、宮古島の風や笑い声まで思い出せるような映像を目指します。",
        rows: [
          ["撮れるもの", "リール風動画 / 海遊びの様子 / 旅のダイジェスト"],
          ["雰囲気", "映画っぽい / 楽しい / 余韻が残る"],
          ["おすすめ", "写真だけでなく動画も残したい方"],
        ],
        hashtags: ["#旅動画", "#ショート動画", "#女子旅", "#映え"],
      },
      {
        number: "06",
        title: "星空や夕方に撮る特別な1枚",
        area: "Special Scene",
        image: img("v1786120675/DSC00888_tk8uhe.webp"),
        text: "タイミングが合えば、夕方の柔らかい光や星空を使った撮影もできます。昼の海とは違う、少し大人っぽくて記憶に残る雰囲気の写真になります。",
        rows: [
          ["撮れるもの", "星空写真 / 夕方のシルエット / 雰囲気のある1枚"],
          ["雰囲気", "ロマンチック / 大人っぽい / 特別感"],
          ["おすすめ", "女子旅 / カップル / 記念日"],
        ],
        hashtags: ["#星空撮影", "#サンセット", "#非日常体験", "#宮古島"],
      },
    ],
  },

  "girls-trip-model-course-2n3d": {
    id: 38,
    slug: "girls-trip-model-course-2n3d",
    template: "normal",
    categoryKey: "drive",
    category: "Drive",
    title: "宮古島で映え女子旅！ 2泊3日のモデルコース",
    description:
      "宮古島女子旅で写真・カフェ・ビーチ・サンセット・夜ご飯まで楽しむ2泊3日のモデルコース。詰め込みすぎず、SNSに残したくなる旅の流れを紹介します。",
    date: "2026.08.08",
    readTime: "6分",
    tags: ["#宮古島", "#女子旅", "#モデルコース", "#映えスポット", "#撮影"],
    mainImage: img("v1785776523/DSC00815_yry3re.webp"),
    leadText:
      "宮古島の女子旅は、海もカフェも夜ご飯も楽しみたいけれど、予定を詰め込みすぎると移動だけで疲れてしまいます。2泊3日なら、エリアごとに分けて巡るのがおすすめ。写真に残したい時間をしっかり取りながら、宮古島らしい非日常感を味わえるモデルコースをまとめました。",
    tocImage: img("v1785776523/DSC00815_yry3re.webp"),
    toc: [
      "1日目：伊良部島とサンセットで旅を始める",
      "2日目：秘境フォトツアー or 秘境SUPで映える1日",
      "3日目：カフェとビーチでゆっくり帰る",
    ],
    cta: {
      title: "女子旅の思い出を写真と映像で残す",
      text: "観光客が行かない秘境スポットやプライベートビーチへご案内し、SNSに載せたくなる写真・動画を残します。",
      buttonText: "秘境フォトツアーを見る",
      path: "/tours/one-day-photogenic-tour",
    },
    points: [
      {
        number: "01",
        title: "1日目：伊良部島とサンセットで旅を始める",
        area: "Day 1",
        image: img("v1784466423/DJI_20260718160638_0015_D_gh8w0n.webp"),
        text: "到着日は無理に遠くまで行かず、伊良部大橋を渡って海の色を楽しむ流れがおすすめです。カフェで休憩しながら、夕方は17ENDや佐和田の浜などサンセットが綺麗な場所へ。初日から写真に残したくなる宮古島らしい景色を楽しめます。",
        rows: [
          ["午前〜昼", "宮古空港到着 / レンタカー / 伊良部大橋"],
          ["午後", "伊良部島カフェ / 17END / 佐和田の浜"],
          ["夜", "宮古島の夜ご飯 / 夜カフェ"],
        ],
        hashtags: ["#宮古島女子旅", "#伊良部島", "#サンセット"],
      },
      {
        number: "02",
        title: "2日目：秘境フォトツアー or 秘境SUPで映える1日",
        area: "Day 2",
        image: img("v1786120675/DSC00888_tk8uhe.webp"),
        text: "2日目は旅のメインに、写真や動画を残せる体験を入れるのがおすすめです。秘境フォトツアーなら観光客が行かない撮影スポットへ、秘境SUPならSUPでしか行けない静かな海へ。女子旅らしい自然体の写真や、ドローン映像まで残せます。",
        rows: [
          ["午前", "秘境フォトツアー or 秘境SUP"],
          ["午後", "ビーチでゆっくり / カフェ巡り"],
          ["夜", "夜ご飯 / 星空が見える日は星空撮影もおすすめ"],
        ],
        hashtags: ["#秘境フォトツアー", "#SUP", "#撮影", "#非日常体験"],
      },
      {
        number: "03",
        title: "3日目：カフェとビーチでゆっくり帰る",
        area: "Day 3",
        image: img(
          "v1783352339/AD_4nXf2yA3puqm63h-XEHfk_ltPQ-m0Sy4IQCU-m0yCaojShxZt7-CDQQ1B8UUjJ5iQC-szsuwzS9Vq4ScPOBElN52vu_oxEkcKu2UbdK-gsQe_WVuQKT9E9iGjaVqKC7vIMduz6M-_ylvli6.png",
        ),
        text: "最終日は予定を詰め込みすぎず、空港へ向かいやすいエリアで過ごすのが安心です。ブルーシール、マンゴーカフェ、海が見えるカフェなどでゆっくりして、最後に近場のビーチへ。帰る直前まで宮古島らしい写真を残せます。",
        rows: [
          ["朝", "ホテルで朝食 / チェックアウト"],
          ["昼", "カフェ巡り / お土産 / 近場ビーチ"],
          ["午後", "レンタカー返却 / 空港へ"],
        ],
        hashtags: ["#カフェ巡り", "#宮古島カフェ", "#女子旅"],
      },
    ],
  },

  "miyakojima-girls-trip-hotels": {
    id: 39,
    slug: "miyakojima-girls-trip-hotels",
    template: "normal",
    categoryKey: "spot",
    category: "Spot",
    title: "宮古島で女子旅におすすめのホテル6選",
    description:
      "宮古島女子旅でホテルを選ぶ時に見たいポイントと、おすすめしやすいホテルタイプ6選。写真映え、プール、オーシャンビュー、アクセスのバランスで紹介します。",
    date: "2026.08.08",
    readTime: "6分",
    tags: ["#宮古島", "#女子旅", "#ホテル", "#非日常体験"],
    mainImage: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
    leadText:
      "女子旅のホテル選びは、価格だけでなく、写真を撮りたくなる雰囲気、海への行きやすさ、夜ご飯へのアクセス、朝の過ごしやすさまで見るのがおすすめです。ここでは、宮古島女子旅で候補に入れやすいホテルタイプを6つに分けて紹介します。",
    tocImage: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
    toc: [
      "リゾート感重視のホテル",
      "プール付きヴィラ",
      "伊良部島ステイ",
      "市街地アクセス重視",
      "オーシャンビュー重視",
      "コスパ重視の女子旅ホテル",
    ],
    points: [
      {
        number: "01",
        title: "リゾート感重視のホテル",
        area: "Resort Stay",
        image: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
        text: "ホテル時間も旅のメインにしたい女子旅なら、プールやラウンジ、広い客室があるリゾート系がおすすめです。朝も夜も写真を撮りたくなる空間だと、ホテルに戻ってからの時間まで楽しくなります。",
        rows: [
          ["おすすめ", "ホテル時間をゆっくり楽しみたい方"],
          ["見るポイント", "プール / 朝食 / 客室の広さ / 写真映え"],
          ["候補例", "シギラエリア / 高級リゾート系"],
        ],
        hashtags: ["#女子旅", "#宮古島ホテル", "#リゾート"],
      },
      {
        number: "02",
        title: "プール付きヴィラ",
        area: "Villa",
        image: img("v1785776522/DSC00843_co2jqa.webp"),
        text: "周りを気にせず過ごしたいなら、ヴィラタイプも相性抜群です。部屋やプールで写真を撮れるので、天気が不安定な日でも女子旅らしい時間を作りやすいのが魅力です。",
        rows: [
          ["おすすめ", "友達同士 / 記念日 / 特別感を出したい旅行"],
          ["見るポイント", "プライベートプール / キッチン / 駐車場"],
          ["注意", "市街地から距離がある場合はレンタカー推奨"],
        ],
        hashtags: ["#ヴィラ", "#非日常体験", "#ホテル"],
      },
      {
        number: "03",
        title: "伊良部島ステイ",
        area: "Irabu Island",
        image: img("v1784466423/DJI_20260718160638_0015_D_gh8w0n.webp"),
        text: "伊良部島や下地島方面を中心に巡りたい女子旅なら、伊良部島ステイもおすすめです。17END、佐和田の浜、渡口の浜などに行きやすく、サンセットや宮古ブルーを楽しみやすいエリアです。",
        rows: [
          ["おすすめ", "伊良部島 / 下地島を中心に巡りたい方"],
          ["近いスポット", "17END / 渡口の浜 / 佐和田の浜"],
          ["相性", "サンセット / ドライブ / カフェ巡り"],
        ],
        hashtags: ["#伊良部島", "#17END", "#女子旅"],
      },
      {
        number: "04",
        title: "市街地アクセス重視",
        area: "City Area",
        image: img("v1784292789/DSC00325_htmozu.jpg"),
        text: "夜ご飯や夜カフェ、バーも楽しみたい場合は、市街地に近いホテルが便利です。運転を長くしたくない日や、夜まで宮古島を楽しみたい女子旅にはアクセスの良さが大切です。",
        rows: [
          ["おすすめ", "夜ご飯 / 夜カフェ / バーも楽しみたい方"],
          ["見るポイント", "市街地までの距離 / 駐車場 / タクシーの使いやすさ"],
          ["相性", "短期旅行 / 初めての宮古島"],
        ],
        hashtags: ["#夜ご飯", "#夜遊び", "#宮古島旅行"],
      },
    ],
  },

  "miyako-hotel-guide-by-area": {
    id: 41,
    slug: "miyako-hotel-guide-by-area",
    template: "shops",
    mediaLayout: "split",
    categoryKey: "hotel",
    category: "Hotel",
    title: "【エリア別】宮古島のおすすめホテル・リゾート",
    description:
      "伊良部島、シギラ・上野、平良・北部、来間島、与那覇前浜周辺など、宮古島のホテル・リゾートをエリア別に紹介。プライベートプール付きヴィラから大型リゾートまで幅広くまとめました。",
    date: "2026.09.08",
    readTime: "10分",
    tags: ["#宮古島", "#宮古島ホテル", "#リゾート", "#ヴィラ"],
    mainImage: img("v1788839327/images_fzmtmq.jpg"),
    leadText:
      "宮古島は伊良部島・下地島、シギラ・上野、平良・北部、来間島など、エリアによってホテルの雰囲気がかなり異なります。どこに泊まるかで観光のしやすさや過ごし方も変わってくるので、エリアごとの特徴とあわせておすすめのホテル・リゾートをまとめました。一泊あたりの料金は2名1室利用時の目安で、シーズンやプランによって変動するため、最新の料金は予約サイトでご確認ください。宿選びの参考にしてください。",
    tocImage: img("v1788839327/images_fzmtmq.jpg"),
    toc: [
      "伊良部島・下地島エリア",
      "シギラ・上野エリア",
      "平良・北エリア",
      "来間島エリア",
      "与那覇前浜・池間方面エリア",
    ],
    points: [
      {
        number: "01",
        title: "伊良部島・下地島エリア",
        area: "Irabu / Shimoji",
        text: "伊良部大橋で本島とつながる伊良部島・下地島エリアは、プライベートプール付きのヴィラや高級リゾートが集中するエリア。17ENDや佐和田の浜など人気の絶景スポットも近く、宮古島の中でもハイクラスな滞在を求める人に人気です。",
        shops: [
          {
            name: "サントリーニ ホテル&ヴィラズ 宮古島",
            area: "伊良部島",
            genre: "リゾートホテル",
            text: "2024年3月に伊良部島で誕生した、青と白のコントラストが目を引くリゾート。段々畑のように連なる建築は本場サントリーニ島を思わせ、伊良部大橋と海を望むロケーションも魅力です。ジャグジー付きの上位客室や、著名シェフ監修の食事も楽しめます。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "1泊1室 約¥35,000〜140,000（1名利用：約¥35,000〜70,000 / 2名利用：約¥50,000〜140,000）"],
              ["オーシャンビュー", "全室オーシャンビュー"],
            ],
            nearestAirport: "下地島空港（車で約12分）",
            facilities: [
              "駐車場",
              "屋外プール",
              "ダイビング",
              "シュノーケリング",
              "スパ",
              "手荷物預かり",
              "レストラン",
              "レンタカー",
            ],
            languages: ["日本語", "英語", "中国語（標準中国語）"],
            instagramPostUrl:
              "https://www.instagram.com/p/DaOw2ZnD1cA/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            mapUrl: "https://www.google.com/maps/search/?api=1&query=%E3%82%B5%E3%83%B3%E3%83%88%E3%83%AA%E3%83%8B+%E3%83%9B%E3%83%86%E3%83%AB%EF%BC%86%E3%83%B4%E3%82%A3%E3%83%A9%E3%82%BA+%E5%AE%AE%E5%8F%A4%E5%B3%B6",
            websiteUrl:
              "https://jp.trip.com/hotels/detail/?cityEnName=Miyakojima&cityId=50334&hotelId=117339707&checkIn=2026-09-15&checkOut=2026-09-16&adult=2&children=0&crn=1&ages=&curr=JPY&barcurr=JPY&masterhotelid_tracelogid=100051355-0a9c7e32-496898-536974456-metaRoom&detailFilters=17%7C1%7E17%7E1*80%7C2%7C1%7E80%7E2*29%7C1%7E29%7E1%7C2&hotelType=meta&display=incavg&subStamp=663&isCT=true&isFlexible=F&roomkey=1624952718_2_0_1624952718_021_2_&roomToken=QU728I-1-Z-1-BQBYPB&msr=%5B%7B%22roomId%22%3A1624952718%2C%22ratePlanId%22%3A%222%22%2C%22shadowId%22%3A0%2C%22rateID%22%3A%22021%22%2C%22adult%22%3A2%2C%22childAgeList%22%3A%5B%5D%2C%22xPkgToken%22%3A%22%22%2C%22productCode%22%3A%22%22%7D%5D&hasAidInUrl=true&locale=ja-JP",
            websiteLabel: "Trip.comで空室・料金を見る",
            hashtags: ["#サントリーニホテル", "#伊良部島"],
          },
          {
            name: "ブルーオーシャン ホテル&リゾート宮古島",
            area: "伊良部島",
            genre: "リゾートホテル",
            text: "伊良部大橋を渡った先に建つ、サントリーニ島を思わせる白亜の外観とブルードームが目印のリゾート。ヴィラタイプの客室は全室プライベートプールとジャグジー付きで、宮古島・伊良部島ならではの青い海と自然を満喫できます。レストラン「エーゲ海」では地産地消の料理を、宮古ブルーの海を眺めながら味わえます。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "2名1泊 約¥38,000〜90,000以上（時期やプランにより変動）"],
              ["オーシャンビュー", "全室オーシャンビュー"],
            ],
            facilities: ["屋外プール", "スパ", "駐車場", "Wi-Fi"],
            instagramPostUrl:
              "https://www.instagram.com/reel/DDyrT3YvtnX/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            websiteUrl: "https://travel.rakuten.co.jp/HOTEL/183102/183102.html",
            websiteLabel: "楽天トラベルで空室・料金を見る",
            mapUrl: "https://www.google.com/maps/search/?api=1&query=%E3%83%96%E3%83%AB%E3%83%BC%E3%82%AA%E3%83%BC%E3%82%B7%E3%83%A3%E3%83%B3+%E3%83%9B%E3%83%86%E3%83%AB%EF%BC%86%E3%83%AA%E3%82%BE%E3%83%BC%E3%83%88%E5%AE%AE%E5%8F%A4%E5%B3%B6",
            hashtags: ["#ブルーオーシャンホテル", "#伊良部島"],
          },
          {
            name: "ジバナ宮古島",
            area: "伊良部島",
            genre: "オーベルジュリゾート",
            text: "伊良部島にたたずむ、わずか7室だけのオールスイートヴィラ。各室にオーシャンビューのプライベートプールとキッチンを備え、暮らすような滞在ができます。沖縄食材を使ったフレンチ懐石風の食事や、プールに浮かびながら味わう朝食も人気です。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "リニューアル準備中のため要確認"],
              ["オーシャンビュー", "全室オーシャンビュー"],
            ],
            nearestAirport: "下地島空港（7.5km）",
            facilities: [
              "屋外プール",
              "スパ",
              "手荷物預かり",
              "Wi-Fi",
              "禁煙（共用エリア）",
              "衣類乾燥機",
            ],
            instagramPostUrl:
              "https://www.instagram.com/p/DavE-Ztj4dw/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            websiteUrl:
              "https://jp.trip.com/hotels/miyakojima-hotel-detail-122086808/jivana-miyakojima/?allianceid=14886&sid=1625375&ppcid=ckid-_akid-_adgid-6442660850&utm_source=google&utm_medium=cpc&utm_campaign=14458300792&gad_source=1&gad_campaignid=14458300990&gbraid=0AAAAABn2eFK4nNUwkBAYsWcXzEl-Yr5wa&gclid=Cj0KCQjwh4TVBhCWARIsAG0czmpqYPksUsG9RlKIcsKUvwfmJEEQ1n6H_WRHG2EkN0lGoJDC6AhxzC0aApEdEALw_wcB",
            websiteLabel: "Trip.comで空室・料金を見る",
            mapUrl: "https://maps.app.goo.gl/oSbx9pfANQgf4aJa6",
            hashtags: ["#ジバナ宮古島", "#伊良部島"],
          },
          {
            name: "Ronsard Resort IRABU（ロンサール リゾート イラブ）",
            area: "伊良部島",
            genre: "ラグジュアリーヴィラ",
            text: "伊良部島の紺碧の海を望む、全5室・全室オーシャンビューのラグジュアリーヴィラ。専用ガーデン付きの客室にはホットタブを完備し、共用キッチンやルームサービスも利用できます。地元・佐良浜のイタリアンバルが手がけるBBQセットを庭先で楽しむこともでき、あぐー豚や宮古の鮮魚など島の味覚も堪能できる一軒です。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "¥100,000〜150,000（2名1室・朝食付き目安）"],
              ["オーシャンビュー", "全室オーシャンビュー"],
              ["客室数", "5室"],
            ],
            nearestAirport: "下地島空港（7.2km）",
            facilities: ["駐車場", "屋外プール", "マッサージルーム", "レンタカー", "Wi-Fi"],
            languages: ["日本語", "英語"],
            instagramPostUrl:
              "https://www.instagram.com/p/DQdveC0j0Ci/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            websiteUrl:
              "https://jp.trip.com/hotels/miyakojima-hotel-detail-101910486/ronsard-resort-irabu?allianceid=14886&sid=1625375&ppcid=ckid-_akid-_adgid-6442660850&utm_source=google&utm_medium=cpc&utm_campaign=14458300792&gad_source=1&gad_campaignid=14458300990&gbraid=0AAAAABn2eFK4nNUwkBAYsWcXzEl-Yr5wa&gclid=Cj0KCQjwh4TVBhCWARIsAG0czmpF3vEUgidFj8uRl-u2HCEDaI9PEbEYmVFFPYhIwaXu1aGbtoTmY9saAt-FEALw_wcB",
            websiteLabel: "Trip.comで空室・料金を見る",
            mapUrl: "https://www.google.com/maps/search/?api=1&query=Ronsard+Resort+IRABU",
            hashtags: ["#ロンサールリゾート", "#伊良部島"],
          },
          {
            name: "ヴィラブリゾート",
            area: "伊良部島",
            genre: "オールヴィラリゾート",
            text: "伊良部島のオーシャンフロントに建つ、全棟独立タイプのオールヴィラホテル。琉球古民家を思わせる赤瓦とバリ風のしつらえが特徴で、広々としたテラスからは伊良部ブルーの水平線を一望できます。各室専用のプライベートプールと赤瓦のガゼボを備え、琉球石灰岩や南国の植物に囲まれたテラスで、波音とともにゆったり過ごせます。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "¥62,000〜120,000（2名1室）"],
              ["オーシャンビュー", "全室オーシャンビュー"],
            ],
            nearestAirport: "下地島空港（車で約7分）",
            facilities: [
              "駐車場",
              "屋外プール",
              "プライベートビーチエリア",
              "ダイビング",
              "シュノーケリング",
              "サーフィン",
              "マッサージルーム",
              "手荷物預かり",
            ],
            languages: ["日本語", "英語"],
            instagramPostUrl:
              "https://www.instagram.com/reel/DTl99e5iv6h/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            websiteUrl:
              "https://jp.trip.com/hotels/miyakojima-hotel-detail-7614705/villabu-resort/?allianceid=14886&sid=1625375&ppcid=ckid-_akid-_adgid-6442660850&utm_source=google&utm_medium=cpc&utm_campaign=14458300792&gad_source=1&gad_campaignid=14458300990&gbraid=0AAAAABn2eFK4nNUwkBAYsWcXzEl-Yr5wa&gclid=Cj0KCQjwh4TVBhCWARIsAG0czmoWraNJH8nkmELndKMBg2kXr4rqAjj21PjlP2oD6YheFzOlWFQOv1gaAo06EALw_wcB",
            websiteLabel: "Trip.comで空室・料金を見る",
            mapUrl: "https://www.google.com/maps/search/?api=1&query=%E3%83%B4%E3%82%A3%E3%83%A9%E3%83%96%E3%83%AA%E3%82%BE%E3%83%BC%E3%83%88+%E4%BC%8A%E8%89%AF%E9%83%A8%E5%B3%B6",
            hashtags: ["#ヴィラブリゾート", "#伊良部島"],
          },
          {
            name: "フェリスヴィラスイート伊良部島・佐和田",
            area: "伊良部島 佐和田",
            genre: "一棟貸しヴィラ",
            text: "日本の渚百選「佐和田の浜」を望むビーチフロントに建つ、別荘スタイルの一棟貸しヴィラ。全8棟のヴィラと別邸「〜離れ〜」があり、どの棟にもプライベート感の高い温水プールを完備しています。美しいサンセットを眺めながら、ホテルとは一味違う別荘感覚の滞在が楽しめます。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "¥48,000〜90,000（2名1室）"],
              ["オーシャンビュー", "全室オーシャンビュー"],
            ],
            nearestAirport: "下地島空港（2.7km）",
            facilities: [
              "屋外プール",
              "Wi-Fi",
              "駐車場",
              "ビーチフロント",
              "禁煙ルーム",
              "ファミリールーム",
            ],
            instagramPostUrl:
              "https://www.instagram.com/p/DdDe--xPUKv/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            websiteUrl:
              "https://www.booking.com/searchresults.ja.html?aid=356980&label=gog235jc-10CAsodUIsaHVlcmlzdXZ1aXJhc3VpdG95aS1saWFuZy1idS1kYW8tenVvLWhlLXRpYW5IFVgDaHWIAQGYATO4AQfIAQzYAQPoAQH4AQGIAgGoAgG4Apr1iNUGwAIB0gIkMzJjZjA0ZGEtMDBjZS00NjljLWI2OGYtM2VhNTFhNDRlMTAz2AIB4AIB&sid=22f221f94f9f6b458244171000bc91ee&dest_id=900050296&dest_type=city&srpvid=764023cd96060019",
            websiteLabel: "Booking.comで空室・料金を見る",
            mapUrl: "https://maps.app.goo.gl/AVbspLRJY6P4KqEJ9",
            hashtags: ["#フェリスヴィラスイート", "#佐和田の浜"],
          },
          {
            name: "イラフ SUI ラグジュアリーコレクションホテル 沖縄宮古",
            area: "伊良部島 渡口の浜周辺",
            genre: "ラグジュアリーホテル",
            text: "伊良部島の海岸沿いに立つ、マリオット・ラグジュアリーコレクション加盟の全58室リゾート。伊良部大橋まで車で約3分、佐和田の浜まで約5分とアクセスも良好です。白を基調とした開放的な客室、海に溶け込むようなインフィニティプール、マッサージやフェイシャルが受けられるスパ、フィットネスセンターなど、静けさの中で非日常を味わえる滞在が叶います。バルコニーからオーシャンビューを望める客室と、1階のプライベートプール付きガーデンビュー客室があります。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "¥54,000〜150,000（2名1室）"],
              ["オーシャンビュー", "一部客室がオーシャンビュー"],
            ],
            nearestAirport: "下地島空港（4.9km）",
            facilities: [
              "駐車場",
              "屋外プール",
              "ダイビング",
              "シュノーケリング",
              "スパ",
              "マッサージルーム",
              "ジム",
              "レンタカー",
            ],
            languages: ["日本語", "中国語（標準中国語）"],
            instagramPostUrl:
              "https://www.instagram.com/p/DZ7GZlbEXr-/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            websiteUrl:
              "https://jp.trip.com/hotels/miyakojima-hotel-detail-23217500/iraph-sui-a-luxury-collection-hotel-miyako-okinawa?allianceid=14886&sid=4137928&ppcid=adid-708113078104_akid-dsa-391528399628_adgid-171313430531&utm_source=google&utm_medium=cpc&utm_campaign=21532852713&gad_source=1&gad_campaignid=21532852713&gbraid=0AAAAABn2eFLIN3fNHP211mzk1O1HhCHFI&gclid=Cj0KCQjwh4TVBhCWARIsAG0czmohD9-GLRrgSsVZ1gkILtAykgigtkeII88A0F8nXAbbRE7IFD94hJIaAsLREALw_wcB",
            websiteLabel: "Trip.comで空室・料金を見る",
            mapUrl: "https://www.google.com/maps/search/?api=1&query=%E3%82%A4%E3%83%A9%E3%83%95+SUI+%E3%83%A9%E3%82%B0%E3%82%B8%E3%83%A5%E3%82%A2%E3%83%AA%E3%83%BC%E3%82%B3%E3%83%AC%E3%82%AF%E3%82%B7%E3%83%A7%E3%83%B3%E3%83%9B%E3%83%86%E3%83%AB+%E6%B2%96%E7%B8%84%E5%AE%AE%E5%8F%A4",
            hashtags: ["#イラフSUI", "#伊良部島", "#ラグジュアリーコレクション"],
          },
          {
            name: "アルカディアリゾート宮古島",
            area: "伊良部島",
            genre: "オールスイートリゾート",
            text: "伊良部大橋を渡った先の伊良部島に立つ、全室スイートルームのラグジュアリーリゾート。全室にプライベートプールと屋外ジャグジー、宿泊者専用の無料レンタカーを完備し、宮古ブルーの海を望む極上のプライベート空間で過ごせます。少室数ならではの静けさで、大切な人との記念日旅行にもおすすめです。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "¥109,000〜200,000（2名1室）"],
              ["オーシャンビュー", "全室オーシャンビュー"],
            ],
            nearestAirport: "下地島空港（車で約10分）",
            facilities: ["屋外プール", "サウナ", "送迎", "レンタカー", "ルームサービス"],
            instagramPostUrl:
              "https://www.instagram.com/reel/C0dBvFqBuTj/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            websiteUrl: "https://travel.yahoo.co.jp/00003072/",
            websiteLabel: "Yahoo!トラベルで空室・料金を見る",
            mapUrl: "https://www.google.com/maps/search/?api=1&query=%E3%82%A2%E3%83%AB%E3%82%AB%E3%83%87%E3%82%A3%E3%82%A2%E3%83%AA%E3%82%BE%E3%83%BC%E3%83%88%E5%AE%AE%E5%8F%A4%E5%B3%B6",
            hashtags: ["#アルカディアリゾート", "#伊良部島"],
          },
        ],
        hashtags: ["#伊良部島", "#下地島", "#宮古島ホテル"],
      },
      {
        number: "02",
        title: "シギラ・上野エリア",
        area: "Shigira / Ueno",
        text: "宮古島南部に広がる「シギラセブンマイルズリゾート」から上野エリアにかけての一帯。レストランやアクティビティ施設が集まる大型リゾートと、隠れ家的な一棟貸しヴィラの両方が揃い、新城海岸などの人気ビーチにもアクセスしやすいエリアです。",
        shops: [
          {
            name: "ホテル シギラミラージュ",
            area: "シギラ",
            genre: "ラグジュアリーホテル",
            text: "宮古島南岸、約130万坪にわたるリゾートシティ「シギラセブンマイルズリゾート」内に佇むハイクラスリゾート。海に近い「ベイサイド」棟と、小高い丘に建つ「プールヴィラプレミア」棟の2タイプから選べます。ホテル前のプールのほか、敷地内のシギラガーデンプールやビーチサイドプール、プライベートカバナも利用でき、源泉かけ流しの温泉やエステ施設も完備。ペットと泊まれる客室も用意されています。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "¥41,000〜140,000（2名1室・朝食付き目安）"],
              ["オーシャンビュー", "全室オーシャンビュー"],
            ],
            facilities: ["温泉", "露天風呂", "屋外プール", "エステ施設", "送迎", "ペット可"],
            images: [img("v1789017689/スクリーンショット_2026-09-10_14.20.10_lk2x2v.png")],
            websiteUrl: "https://travel.yahoo.co.jp/00002622/",
            websiteLabel: "Yahoo!トラベルで空室・料金を見る",
            mapUrl: "https://www.google.com/maps/search/?api=1&query=%E3%83%9B%E3%83%86%E3%83%AB%E3%82%B7%E3%82%AE%E3%83%A9%E3%83%9F%E3%83%A9%E3%83%BC%E3%82%B8%E3%83%A5",
            hashtags: ["#シギラミラージュ", "#シギラ"],
          },
          {
            name: "シギラベイサイドスイート アラマンダ",
            area: "シギラ",
            genre: "オールスイートホテル",
            text: "シギラセブンマイルズリゾート内にある、全174室オールスイートのホテル。花々が咲き誇る南国ムード満点の館内が魅力で、プライベートプール付きの「プールヴィララグーンスイート」も選べます。ペットと宿泊できる客室が用意されているのもポイントです。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "¥24,000〜90,000（2名1室）"],
              ["オーシャンビュー", "一部客室がオーシャンビュー（シギラオーシャンスイート等）"],
            ],
            nearestAirport: "宮古空港（9.9km）",
            facilities: [
              "駐車場",
              "温泉",
              "ゴルフ場",
              "屋外プール",
              "ダイビング",
              "シュノーケリング",
              "サウナ",
              "マッサージルーム",
              "衣類乾燥機",
            ],
            images: ["https://res.cloudinary.com/drxijtp8g/image/upload/v1789018125/img-slider-02-01-pc_wfwbbc.jpg"],
            websiteUrl:
              "https://jp.trip.com/hotels/detail/?cityEnName=Miyakojima&cityId=50334&hotelId=5528050&checkIn=2026-09-15&checkOut=2026-09-16&adult=2&children=0&crn=1&ages=&curr=JPY&barcurr=JPY&masterhotelid_tracelogid=100051355-0a8e29a4-496949-98020-metaRoom&detailFilters=17%7C1%7E17%7E1*80%7C2%7C1%7E80%7E2*29%7C1%7E29%7E1%7C2&hotelType=meta&display=incavg&subStamp=931&isCT=true&isFlexible=F&roomkey=1547755608__0_0_021_2_&roomToken=OZGRU0-Z-1&msr=%5B%7B%22roomId%22%3A1547755608%2C%22ratePlanId%22%3A%22%22%2C%22shadowId%22%3A0%2C%22rateID%22%3A%22021%22%2C%22adult%22%3A2%2C%22childAgeList%22%3A%5B%5D%2C%22xPkgToken%22%3A%22%22%2C%22productCode%22%3A%22%22%7D%5D&hasAidInUrl=true&locale=ja-JP",
            websiteLabel: "Trip.comで空室・料金を見る",
            mapUrl: "https://www.google.com/maps/search/?api=1&query=%E3%82%B7%E3%82%AE%E3%83%A9%E3%83%99%E3%82%A4%E3%82%B5%E3%82%A4%E3%83%89%E3%82%B9%E3%82%A4%E3%83%BC%E3%83%88+%E3%82%A2%E3%83%A9%E3%83%9E%E3%83%B3%E3%83%80",
            hashtags: ["#シギラベイサイドスイート", "#アラマンダ"],
          },
          {
            name: "アラマンダ インギャーコーラルヴィレッジ",
            area: "シギラ / インギャー",
            genre: "ヴィラリゾート",
            text: "宮古の青い海を前に並ぶ、赤瓦のプライベートコテージ。すべての客室のテラスにジャグジーバスがあり、ロフトも備えたコテージで暮らすように滞在できます。ヴィレッジ内のレストランでは島の食材を使った宮古スタイルのビュッフェが楽しめ、東シナ海を一望するプールからの景色はまさに楽園。別荘を訪れたような開放的な滞在ができます。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "¥30,000〜45,000（2名1室）"],
              ["オーシャンビュー", "オーシャンビューなし"],
            ],
            facilities: ["露天風呂", "温泉", "屋外プール", "送迎"],
            images: [
              "https://res.cloudinary.com/drxijtp8g/image/upload/v1789021254/img-01-03-pc_vwqz9q.jpg",
            ],
            websiteUrl:
              "https://jp.trip.com/hotels/detail/?cityEnName=Miyakojima&cityId=50334&hotelId=7043225&checkIn=2026-09-15&checkOut=2026-09-16&adult=2&children=0&crn=1&ages=&curr=JPY&barcurr=JPY&masterhotelid_tracelogid=100051355-0a8f935e-496950-102486-metaRoom&detailFilters=17%7C1%7E17%7E1*80%7C2%7C1%7E80%7E2*29%7C1%7E29%7E1%7C2&hotelType=meta&display=incavg&subStamp=676&isCT=true&isFlexible=F&roomkey=1563327434__0_0_021_2_&roomToken=OTR8E1-Z-1&msr=%5B%7B%22roomId%22%3A1563327434%2C%22ratePlanId%22%3A%22%22%2C%22shadowId%22%3A0%2C%22rateID%22%3A%22021%22%2C%22adult%22%3A2%2C%22childAgeList%22%3A%5B%5D%2C%22xPkgToken%22%3A%22%22%2C%22productCode%22%3A%22%22%7D%5D&hasAidInUrl=true&locale=ja-JP",
            websiteLabel: "Trip.comで空室・料金を見る",
            mapUrl: "https://www.google.com/maps/search/?api=1&query=%E3%82%A2%E3%83%A9%E3%83%9E%E3%83%B3%E3%83%80+%E3%82%A4%E3%83%B3%E3%82%AE%E3%83%A3%E3%83%BC%E3%82%B3%E3%83%BC%E3%83%A9%E3%83%AB%E3%83%B4%E3%82%A3%E3%83%AC%E3%83%83%E3%82%B8",
            hashtags: ["#アラマンダ", "#インギャー"],
          },
          {
            name: "琉球李邸インギャー",
            area: "インギャー",
            genre: "一棟貸しヴィラ",
            text: "宮古島の緑豊かな高台に立つ、本館・別館の2棟からなる一棟貸しヴィラ。本館は最大7名、別館は最大5名まで宿泊でき、どの部屋からもオーシャンビューを楽しめます。おだやかな「インギャーマリンガーデン」まで徒歩約5分で、家族やグループの長期滞在にも向いています。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "¥40,000〜70,000（2名1室）"],
              ["オーシャンビュー", "全室オーシャンビュー"],
            ],
            nearestAirport: "宮古空港（車で約16分）",
            facilities: ["屋外プール"],
            instagramPostUrl:
              "https://www.instagram.com/p/DKyoIYxSjzd/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            websiteUrl: "https://travel.yahoo.co.jp/00051124/",
            websiteLabel: "Yahoo!トラベルで空室・料金を見る",
            mapUrl: "https://www.google.com/maps/search/?api=1&query=%E7%90%89%E7%90%83%E6%9D%8E%E9%82%B8%E3%82%A4%E3%83%B3%E3%82%AE%E3%83%A3%E3%83%BC",
            hashtags: ["#琉球李邸", "#インギャー"],
          },
          {
            name: "フェリスヴィラスイート宮古島・上野",
            area: "上野",
            genre: "一棟貸しヴィラ",
            text: "宮古島空港から車で約15分、上野エリアの海沿いに立つ一棟貸しのプライベートヴィラ。全室に温水のプライベートプールを備え、季節を問わず楽しめます。テラスや庭園からの眺めも良く、BBQグリルや現地ツアー・チケットの案内サービスも利用可能。街灯の少ない立地で、夜は満天の星空も楽しめます。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "¥47,000〜90,000（2名1室）"],
              ["オーシャンビュー", "一部客室がオーシャンビュー"],
            ],
            nearestAirport: "宮古空港（車で約15分）",
            facilities: [
              "駐車場",
              "ゴルフ場",
              "屋外プール",
              "シュノーケリング",
              "レストラン",
              "Wi-Fi",
              "衣類乾燥機",
              "現地ツアー予約サービス",
            ],
            languages: ["日本語"],
            instagramPostUrl:
              "https://www.instagram.com/p/C3ZF_MOvPGV/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            websiteUrl:
              "https://jp.trip.com/hotels/detail/?cityEnName=Miyakojima&cityId=50334&hotelId=2802883&checkIn=2026-09-15&checkOut=2026-09-16&adult=2&children=0&crn=1&ages=&curr=JPY&barcurr=JPY&masterhotelid_tracelogid=100051355-0a8ee5e3-496950-23564-metaRoom&detailFilters=17%7C1%7E17%7E1*80%7C2%7C1%7E80%7E2*29%7C1%7E29%7E1%7C2&hotelType=meta&display=incavg&subStamp=1638&isCT=true&isFlexible=F&roomkey=1415089717_2_0_1415089717__0_&roomToken=A4IKFO-1&msr=%5B%7B%22roomId%22%3A1415089717%2C%22ratePlanId%22%3A%222%22%2C%22shadowId%22%3A0%2C%22rateID%22%3A%22%22%2C%22adult%22%3A0%2C%22childAgeList%22%3A%5B%5D%2C%22xPkgToken%22%3A%22%22%2C%22productCode%22%3A%22%22%7D%5D&hasAidInUrl=true&locale=ja-JP",
            websiteLabel: "Trip.comで空室・料金を見る",
            mapUrl: "https://www.google.com/maps/search/?api=1&query=%E3%83%95%E3%82%A7%E3%83%AA%E3%82%B9%E3%83%B4%E3%82%A3%E3%83%A9%E3%82%B9%E3%82%A4%E3%83%BC%E3%83%88+%E5%AE%AE%E5%8F%A4%E5%B3%B6+%E4%B8%8A%E9%87%8E",
            hashtags: ["#フェリスヴィラスイート", "#上野"],
          },
        ],
        hashtags: ["#シギラリゾート", "#インギャー", "#上野", "#宮古島ホテル"],
      },
      {
        number: "03",
        title: "平良・北エリア",
        area: "Hirara / North Miyako",
        text: "宮古島の市街地がある平良から、サンセットビーチや大浦湾にかけての宮古島北部エリア。空港からのアクセスが良く、大型リゾートから話題の新規ラグジュアリーホテルまで揃っています。",
        shops: [
          {
            name: "ローズウッド宮古島",
            area: "宮古島北部（大浦湾）",
            genre: "ラグジュアリーリゾート",
            text: "2025年3月、宮古島北部・大浦湾を望む岬に誕生した「ロズウッド ホテル＆リゾーツ」日本第1号。約9万5,000平米の敷地に、全55棟すべてがオーシャンビュー＆プライベートプール付きの独立ヴィラという贅沢な造りです。琉球石灰岩を取り入れた建築も見どころで、国際的なラグジュアリーブランドならではの非日常体験ができます。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "¥200,000〜400,000（2名1室・超高級帯目安）"],
              ["オーシャンビュー", "全室オーシャンビュー（全55棟・プライベートプール付き）"],
            ],
            facilities: [
              "駐車場",
              "屋外プール",
              "スパ",
              "マッサージルーム",
              "ジム",
              "送迎",
              "バー",
              "レストラン",
            ],
            instagramPostUrl:
              "https://www.instagram.com/p/DcawmynFNkp/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            websiteUrl:
              "https://jp.trip.com/hotels/detail/?cityEnName=Miyakojima&cityId=50334&hotelId=122192515&checkIn=2026-09-15&checkOut=2026-09-16&adult=2&children=0&crn=1&ages=&curr=JPY&barcurr=JPY&masterhotelid_tracelogid=100051355-0a9c74e9-496950-110634-metaRoom&detailFilters=17%7C1%7E17%7E1*80%7C2%7C1%7E80%7E2*29%7C1%7E29%7E1%7C2&hotelType=meta&display=incavg&subStamp=780&isCT=true&isFlexible=F&roomkey=1578681819_2_0_1578681819_021_2_&roomToken=QCVHNR-1-Z-1&msr=%5B%7B%22roomId%22%3A1578681819%2C%22ratePlanId%22%3A%222%22%2C%22shadowId%22%3A0%2C%22rateID%22%3A%22021%22%2C%22adult%22%3A2%2C%22childAgeList%22%3A%5B%5D%2C%22xPkgToken%22%3A%22%22%2C%22productCode%22%3A%22%22%7D%5D&hasAidInUrl=true&locale=ja-JP",
            websiteLabel: "Trip.comで空室・料金を見る",
            mapUrl: "https://www.google.com/maps/search/?api=1&query=Rosewood+Miyakojima",
            hashtags: ["#ローズウッド宮古島", "#宮古島ホテル", "#ラグジュアリー"],
          },
          {
            name: "ヒルトン沖縄宮古島リゾート",
            area: "平良（サンセットビーチ隣接）",
            genre: "大型リゾートホテル",
            text: "宮古島市平良、みやこサンセットビーチに隣接する大型リゾートホテル。伊良部大橋と宮古ブルーの海を望む立地で、屋内外あわせて5つのプールやスパ、キッズクラブまで館内設備が充実しています。宮古空港から車で約15分と、初めての宮古島旅行にも便利な立地です。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "¥33,000〜120,000（2名1室）"],
              ["オーシャンビュー", "一部客室がオーシャンビュー"],
            ],
            nearestAirport: "宮古空港（7.8km）",
            facilities: [
              "駐車場",
              "屋外プール",
              "バー",
              "スパ",
              "ジム",
              "レンタカー",
            ],
            languages: ["日本語", "英語"],
            instagramPostUrl:
              "https://www.instagram.com/p/DcVpeoSHQUQ/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            websiteUrl:
              "https://jp.trip.com/hotels/detail/?cityEnName=Miyakojima&cityId=50334&hotelId=94035477&checkIn=2026-09-15&checkOut=2026-09-16&adult=2&children=0&crn=1&ages=&curr=JPY&barcurr=JPY&masterhotelid_tracelogid=100051355-0a8f85b6-496950-116182-metaRoom&detailFilters=17%7C1%7E17%7E1*80%7C2%7C1%7E80%7E2*29%7C1%7E29%7E1%7C2&hotelType=meta&display=incavg&subStamp=456&isCT=true&isFlexible=F&roomkey=1365835741_2_0_1365835741_021_2_&roomToken=HZEZZO-1-Z-1&msr=%5B%7B%22roomId%22%3A1365835741%2C%22ratePlanId%22%3A%222%22%2C%22shadowId%22%3A0%2C%22rateID%22%3A%22021%22%2C%22adult%22%3A2%2C%22childAgeList%22%3A%5B%5D%2C%22xPkgToken%22%3A%22%22%2C%22productCode%22%3A%22%22%7D%5D&hasAidInUrl=true&locale=ja-JP",
            websiteLabel: "Trip.comで空室・料金を見る",
            mapUrl: "https://www.google.com/maps/search/?api=1&query=Hilton+Okinawa+Miyako+Island+Resort",
            hashtags: ["#ヒルトン宮古島", "#宮古島ホテル"],
          },
          {
            name: "キャノピー・バイ・ヒルトン宮古島",
            area: "平良（サンセットビーチ隣接）",
            genre: "デザイナーズホテル",
            text: "ヒルトンと同じくサンセットビーチに隣接する、デザイナーズブランド「Canopy」のホテル。地域の雰囲気を取り入れたインテリアが特徴で、1日の締めくくりには12階のルーフトッププール＆バーから伊良部大橋と宮古ブルーの絶景を楽しめます。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "開業間もなく要確認"],
              ["オーシャンビュー", "一部客室がオーシャンビュー"],
            ],
            nearestAirport: "宮古空港（7.5km）",
            facilities: [
              "駐車場",
              "屋外プール",
              "スパ",
              "マッサージルーム",
              "ジム",
              "送迎",
              "バー",
              "レストラン",
              "衣類乾燥機",
              "衣類スチーマー",
            ],
            languages: ["日本語", "英語"],
            instagramPostUrl:
              "https://www.instagram.com/reel/DcuKeusPxdt/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            websiteUrl:
              "https://jp.trip.com/hotels/detail/?cityEnName=Miyakojima&cityId=50334&hotelId=133079681&checkIn=2026-09-15&checkOut=2026-09-16&adult=2&children=0&crn=1&ages=&curr=JPY&barcurr=JPY&hoteluniquekey=H4sIAAAAAAAA_-P6x8zFJMEk9Z2ZY9axfefZhBiNDFgtPgs69h_6qnHn_BIHT67riwv2Bq9yCOCZwdh4dJf9CkbGjYxvAnfItfK3OexgZDrB-PYWywKmw2tfmp9iYeZYWneJpZk5ulopO7VSycpER6kksyQnVclK6XHT1sfNex43T37ctPPZtJlKOkopqcXJQAkgKzE3vzSvBMi2NDQ10DMwAAqVJFZ4pihZmesoJSfmJJfmJJakhlQWAA0y01HKLHYuKcosCErNzSwpSQWqSkvMKU4FiQelFgNlksGCSn5AY4qgApn5eRDtBihiYYk5pakQNwAtdEuF2mFcq4PpgSe7ZzztWvBk38KnDUuer-jD7gFzA0NTFA-YDIgHDGtjH7EwRcd-YmH4xcLQxMrQxcowiZWFAxhVu1h5gk1MA1wCdQ11o3QNpRQMDQwMTA2NTU11DRItUo1SLc10TSzNLE0NdA2NTA3MDTU-HWy80GFiJHuKUcrQ3NzUwsLIwASox0gvxcTczCjDxDfMx6LCgzGIzdXS2c3CJMqGi9krIFJQzmziTO6YZfZSIJ4ijKcF4hnCeIFrbBo3BK-pso-sdeTmlIhdZp_EmpWo6xWQ8U-0gLGBkamLkVuA0YMxgrECyGNcxcjOxWxgZCjAtIGRcQfjfxhgfMUIMhYA1kFT180CAAA&masterhotelid_tracelogid=100051355-0a8e2e96-496950-125071&detailFilters=17%7C1%7E17%7E1*80%7C2%7C1%7E80%7E2*29%7C1%7E29%7E1%7C2&hotelType=normal&display=incavg&subStamp=990&isCT=true&isFlexible=F&locale=ja-JP",
            websiteLabel: "Trip.comで空室・料金を見る",
            mapUrl: "https://maps.app.goo.gl/tcGnf82Ao9owsMqQ7",
            hashtags: ["#キャノピーバイヒルトン", "#宮古島ホテル"],
          },
          {
            name: "Grand Bleu Gamin（グラン ブルー ギャマン）",
            area: "宮古島北部（荷川取）",
            genre: "美食リゾート",
            text: "東京でレストランやパティスリーを手がけるギャマングループがプロデュースする、宮古島北部のプライベートヴィラ。「美食と上質な睡眠」をコンセプトに、3タイプある客室すべてにプライベートプールを完備しています。宮古空港から車で約15分とアクセスも良好です。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "¥132,000〜200,000（2名・夕朝食付き目安）"],
              ["オーシャンビュー", "一部客室がオーシャンビュー"],
            ],
            facilities: [
              "駐車場",
              "屋外プール",
              "プライベートビーチエリア",
              "マッサージルーム",
              "レストラン",
              "レンタカー",
              "Wi-Fi",
            ],
            languages: ["日本語", "英語", "中国語（標準中国語）"],
            instagramPostUrl:
              "https://www.instagram.com/p/DdENl_HEmke/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            websiteUrl:
              "https://jp.trip.com/hotels/miyakojima-hotel-detail-46301491/grand-bleu-gamin/?allianceid=14886&sid=1625375&ppcid=ckid-_akid-_adgid-6442660850&utm_source=google&utm_medium=cpc&utm_campaign=14458300792&gad_source=1&gad_campaignid=14458300990&gbraid=0AAAAABn2eFK4nNUwkBAYsWcXzEl-Yr5wa&gclid=Cj0KCQjwh4TVBhCWARIsAG0czmo8VdhHtKM3MG_GVTgb-66yVNv7Ntxy5xj1CqlpNqnDDlMpVkPB4gQaAgBNEALw_wcB",
            websiteLabel: "Trip.comで空室・料金を見る",
            mapUrl: "https://www.google.com/maps/search/?api=1&query=Grand+Bleu+Gamin+%E5%AE%AE%E5%8F%A4%E5%B3%B6",
            hashtags: ["#グランブルーギャマン", "#美食リゾート"],
          },
        ],
        hashtags: ["#平良", "#サンセットビーチ", "#宮古島ホテル"],
      },
      {
        number: "04",
        title: "来間島エリア",
        area: "Kurima Island",
        text: "来間大橋で本島とつながる来間島は、与那覇前浜を一望できる高台やのどかな景色が魅力のエリア。喧騒から離れて静かに過ごしたい旅におすすめです。",
        shops: [
          {
            name: "宮古島来間リゾート シーウッドホテル",
            area: "来間島",
            genre: "リゾートホテル",
            text: "来間大橋を渡った先、来間島の北岸に広がるリゾートホテル。沖縄の民家をイメージした全169邸で、プライベートプールやジャグジー付きの「ビラハウス」と、琉球様式を取り入れた「首里ハウス」の2タイプから選べます。館内にはフレンチをはじめ2つのレストランがあり、夕日の名所としても知られる理想的なロケーションで、澄んだ宮古ブルーの海とトロピカルな雰囲気の中でサンセットも楽しめます。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "¥22,400〜60,000（2名1室）"],
              ["オーシャンビュー", "一部客室がオーシャンビュー（首里ハウス棟）"],
            ],
            nearestAirport: "宮古空港（11.2km）",
            facilities: [
              "駐車場",
              "屋外プール",
              "スパ",
              "マッサージルーム",
              "ジム",
              "送迎",
              "手荷物預かり",
              "レストラン",
            ],
            languages: ["日本語", "英語"],
            instagramPostUrl:
              "https://www.instagram.com/reel/DSHz4p9khQl/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            websiteUrl:
              "https://jp.trip.com/hotels/detail/?cityEnName=Miyakojima&cityId=50334&hotelId=54940587&checkIn=2026-09-15&checkOut=2026-09-16&adult=2&children=0&crn=1&ages=&curr=JPY&barcurr=JPY&masterhotelid_tracelogid=100051355-0a8ee5e3-496950-141892-metaRoom&detailFilters=17%7C1%7E17%7E1*80%7C2%7C1%7E80%7E2*29%7C1%7E29%7E1%7C2&hotelType=meta&display=incavg&subStamp=689&isCT=true&isFlexible=F&roomkey=2255654051__0_0_021_2_&roomToken=BBKXGYP-Z-1&msr=%5B%7B%22roomId%22%3A2255654051%2C%22ratePlanId%22%3A%22%22%2C%22shadowId%22%3A0%2C%22rateID%22%3A%22021%22%2C%22adult%22%3A2%2C%22childAgeList%22%3A%5B%5D%2C%22xPkgToken%22%3A%22%22%2C%22productCode%22%3A%22%22%7D%5D&hasAidInUrl=true&locale=ja-JP",
            websiteLabel: "Trip.comで空室・料金を見る",
            mapUrl: "https://www.google.com/maps/search/?api=1&query=%E5%AE%AE%E5%8F%A4%E5%B3%B6%E6%9D%A5%E9%96%93%E3%83%AA%E3%82%BE%E3%83%BC%E3%83%88+%E3%82%B7%E3%83%BC%E3%82%A6%E3%83%83%E3%83%89%E3%83%9B%E3%83%86%E3%83%AB",
            hashtags: ["#シーウッドホテル", "#来間島"],
          },
        ],
        hashtags: ["#来間島", "#来間大橋", "#宮古島ホテル"],
      },
      {
        number: "05",
        title: "与那覇前浜・池間方面エリア",
        area: "Yonaha Maehama Area",
        text: "東洋一とも言われる白い砂浜「与那覇前浜」周辺から池間島方面にかけてのエリア。一棟貸しのプライベートヴィラが多く、周りを気にせず過ごしたい旅行に向いています。",
        shops: [
          {
            name: "the 478 pool&spa 宮古島Luxury Villa",
            area: "与那覇湾周辺",
            genre: "一棟貸しヴィラ",
            text: "与那覇湾を望む、宮古島でここだけの完全独立型一棟ヴィラ。2024年5月にリブランドオープンし、1日1組・最大6名様限定で、隣とはつながらない独立した1棟2部屋だけを貸し切ります。ミルキーブルーの海に包まれるような開放感の中、通年利用できるプールでゆったりと過ごせます。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "¥94,000〜150,000（2名1室）"],
              ["オーシャンビュー", "全室オーシャンビュー"],
            ],
            nearestAirport: "宮古空港（車で約10分）",
            facilities: ["屋外プール", "駐車場"],
            images: [
              "https://res.cloudinary.com/drxijtp8g/image/upload/v1789022584/13857806_swcrel.avif",
            ],
            websiteUrl: "https://travel.yahoo.co.jp/00051897/?adc=1&discsort=1&lc=1&ppc=2&rc=1&si=1&st=1",
            websiteLabel: "Yahoo!トラベルで空室・料金を見る",
            mapUrl: "https://www.google.com/maps/search/?api=1&query=the+478+pool%26spa+%E5%AE%AE%E5%8F%A4%E5%B3%B6",
            hashtags: ["#the478", "#与那覇湾"],
          },
          {
            name: "～Villa Rikyu～離宮・別館",
            area: "宮古島南部",
            genre: "一棟貸しヴィラ",
            text: "1日3組限定、全棟が独立したプライベートヴィラ。室内約76平米、テラスを含めると100平米を超える広さで、24時間利用できる温水プールとシステムキッチンを完備しています。1室につき1台無料の「カーサービス」が付くのも魅力で、レンタカーの手配なしに宮古島観光を楽しめます。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "¥49,000〜100,000（2名1室）"],
              ["オーシャンビュー", "全室オーシャンビュー"],
            ],
            nearestAirport: "宮古空港（7km）",
            facilities: ["屋外プール", "Wi-Fi", "駐車場", "禁煙ルーム", "ファミリールーム"],
            instagramPostUrl:
              "https://www.instagram.com/reel/DKV1ambCoEU/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            websiteUrl:
              "https://www.booking.com/hotel/jp/villa-rikyu-li-gong-bie-guan.ja.html?aid=311100&label=villa-rikyu-li-gong-bie-guan-Zs2GhQskeJ%2ANytlnb9pCIwS754647712023%3Apl%3Ata%3Ap1%3Ap2%3Aac%3Aap%3Aneg%3Afi%3Atiaud-2382347442848%3Akwd-2476877747169%3Alp9174342%3Ali%3Adec%3Adm%3Appccp%3DUmFuZG9tSVYkc2RlIyh9Ybu3g3JQEN-yGShcLON2_Wc&sid=22f221f94f9f6b458244171000bc91ee&dest_id=900050296&dest_type=city&dist=0&group_adults=2&group_children=0&hapos=1&hpos=1&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=popularity&srepoch=1789022813&srpvid=a4cd2fae7d0c064f&type=total&ucfs=1&",
            websiteLabel: "Booking.comで空室・料金を見る",
            mapUrl: "https://www.google.com/maps/search/?api=1&query=Villa+Rikyu+%E9%9B%A2%E5%AE%AE+%E5%88%A5%E9%A4%A8",
            hashtags: ["#VillaRikyu", "#宮古島ヴィラ"],
          },
          {
            name: "Castello di mare カステロディマーレ 宮古島",
            area: "宮古島南部",
            genre: "貸別荘",
            text: "宮古島の高台に広がる、壮大なオーシャンビューを望む1日1組限定の貸切別荘。屋外プールや露天風呂、ジャグジーなど水回りの設備が充実しているほか、ゲームルームやカラオケも備え、誰の目も気にせず極上のプライベートな時間を過ごせます。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "¥49,000〜90,000（2名1室）"],
              ["オーシャンビュー", "全室オーシャンビュー"],
            ],
            nearestAirport: "宮古空港（17km）",
            facilities: [
              "屋外プール",
              "Wi-Fi",
              "駐車場",
              "露天風呂",
              "ゲームルーム",
              "カラオケ",
              "ジャグジー",
            ],
            instagramPostUrl:
              "https://www.instagram.com/reel/C-RcIy-h2GZ/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            websiteUrl:
              "https://www.booking.com/hotel/jp/castello-di-mare-kasuterodeimare-gong-gu-dao.ja.html?aid=356980&label=gog235jc-10CAsodUIsY2FzdGVsbG8tZGktbWFyZS1rYXN1dGVyb2RlaW1hcmUtZ29uZy1ndS1kYW9IFVgDaHWIAQGYATO4AQfIAQzYAQPoAQH4AQGIAgGoAgG4AoumidUGwAIB0gIkNzFlMzYxNmUtYzdjOC00MDcxLWE4MmYtN2Y1MDAxYTk2YTFl2AIB4AIB&sid=22f221f94f9f6b458244171000bc91ee&dest_id=900050296&dest_type=city&dist=0&group_adults=2&group_children=0&hapos=1&hpos=1&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=popularity&srepoch=1789022990&srpvid=6f0c300619b100e2&type=total&ucfs=1&",
            websiteLabel: "Booking.comで空室・料金を見る",
            mapUrl: "https://www.google.com/maps/search/?api=1&query=Castello+di+mare+%E5%AE%AE%E5%8F%A4%E5%B3%B6",
            hashtags: ["#カステロディマーレ", "#貸別荘"],
          },
          {
            name: "Villa Conte",
            area: "宮古島南部",
            genre: "テーマ別ヴィラ",
            text: "プール棟とサウナ棟、2棟だけの一棟貸しヴィラ。プール棟には宮古島最大級という全長9mの温水プライベートプールがあり、夜24時までライトアップされた幻想的な雰囲気も楽しめます。サウナ棟は0.5度単位で温度調整できる本格仕様で、チラー付きの水風呂もあり、サウナ好きも満足できる設備です。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "¥48,000〜90,000（2名1室）"],
              ["オーシャンビュー", "オーシャンビューなし"],
            ],
            nearestAirport: "宮古空港（車で約10分）",
            facilities: ["サウナ", "駐車場", "屋外プール", "コインランドリー"],
            instagramPostUrl:
              "https://www.instagram.com/p/CLf-v-5DzSw/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            websiteUrl: "https://travel.rakuten.co.jp/HOTEL/178499/178499.html",
            websiteLabel: "楽天トラベルで空室・料金を見る",
            mapUrl: "https://www.google.com/maps/search/?api=1&query=Villa+Conte+%E5%AE%AE%E5%8F%A4%E5%B3%B6",
            hashtags: ["#VillaConte", "#サウナ"],
          },
          {
            name: "the rescape（ザ・リスケープ）",
            area: "宮古島南部",
            genre: "隠れ家リゾート",
            text: "宮古島の静かな東海岸に佇む、大人の隠れ家リゾート。客室はすべて独立したヴィラ・コテージで、テラスにはプライベートプールを完備しています。岩塩やハーブを自分好みにブレンドできるバスソルトや、テラスで過ごすマシュマロナイトなど滞在を彩るアクティビティも用意されていて、ふたり旅から家族でのビーチステイまで、宮古の自然に寄り添うような時間を過ごせます。",
            rows: [
              ["一泊あたりの目安（時期により変動）", "¥39,000〜60,000（2名1室）"],
              ["オーシャンビュー", "一部客室がオーシャンビュー"],
            ],
            facilities: ["屋外プール", "エステ施設", "ルームサービス"],
            instagramPostUrl:
              "https://www.instagram.com/p/DZcXJZfD2mO/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            websiteUrl: "https://travel.yahoo.co.jp/00002618/",
            websiteLabel: "Yahoo!トラベルで空室・料金を見る",
            mapUrl: "https://www.google.com/maps/search/?api=1&query=the+rescape+%E5%AE%AE%E5%8F%A4%E5%B3%B6",
            hashtags: ["#therescape", "#隠れ家リゾート"],
          },
        ],
        hashtags: ["#与那覇前浜", "#池間島", "#宮古島ホテル"],
      },
    ],
  },

  "miyakojima-night-dinner-guide": {
    id: 42,
    slug: "miyakojima-night-dinner-guide",
    template: "shops",
    mediaLayout: "split",
    hideBaeScore: true,
    categoryKey: "gourmet",
    category: "Gourmet",
    title: "宮古島のおすすめ夜ご飯｜雰囲気別ガイド",
    description:
      "宮古島の夜ご飯におすすめのお店を紹介。島おでんや民謡居酒屋、海鮮、宮古牛、しゃぶしゃぶまで、過ごし方に合わせて選べます。営業時間・定休日・価格帯・電話番号つき。",
    date: "2026.09.10",
    readTime: "8分",
    tags: ["#宮古島", "#宮古島グルメ", "#夜ご飯", "#居酒屋"],
    mainImage: img("v1789053600/IMG_6917-edited_u83koj.jpg"),
    leadText:
      "宮古島の夜は、島唄が響く民謡居酒屋から、しっかり食べたい海鮮・焼肉、静かに過ごせるしゃぶしゃぶ店まで、過ごし方によって選べるお店が揃っています。この記事ではOcean Guideアプリでも案内している夜ご飯のお店を、雰囲気別にまとめました。人気店は混み合いやすいので、行きたいお店が決まったら早めの予約がおすすめです。",
    tocImage: img("v1789053600/IMG_6917-edited_u83koj.jpg"),
    toc: [
      "島料理・沖縄料理をゆっくり味わう夜",
      "三線とにぎやかな雰囲気を楽しむ夜",
      "海鮮・宮古牛でしっかり食べる夜",
      "落ち着いてゆっくり食事したい夜",
    ],
    points: [
      {
        number: "01",
        title: "島料理・沖縄料理をゆっくり味わう夜",
        area: "島料理 / 沖縄料理",
        text: "初日の夜や、宮古島らしさをまず味わいたい時におすすめのグループ。島おでんやてびちなど、沖縄ならではの料理を泡盛と一緒にゆっくり楽しめます。",
        shops: [
          {
            name: "島おでん たから",
            area: "平良",
            genre: "島おでん / 沖縄料理",
            images: [img("v1789053910/unnamed_kk4eon.webp")],
            text: "宮古島の夜ご飯といえばまず名前が挙がる老舗。じっくり煮込んだ島おでんやてびちを、泡盛と一緒にゆっくり味わえます。地元客にも人気の一軒なので、行きたい日は早めの予約がおすすめです。",
            rows: [["価格帯", "¥2,000〜3,000"], ["電話", "0980-72-0671"]],
            recommendedMenu: "島おでん / てびち / 沖縄料理",
            businessHours: "18:00〜23:00",
            closedDays: "日・月",
            mapUrl: map("島おでんたから 宮古島 平良"),
            hashtags: ["#島おでんたから", "#宮古島グルメ", "#夜ご飯"],
          },
          {
            name: "居酒家 でいりぐち",
            area: "平良",
            genre: "居酒屋 / 島ごはん",
            images: [img("v1789053999/kiji1Img_ytpyzu.jpg")],
            text: "地元感のある雰囲気で、気取らずに宮古島の夜ご飯を楽しみたい時にちょうどいい一軒。島ごはんと居酒屋メニューを組み合わせて、旅の夜をのんびり過ごせます。",
            rows: [["価格帯", "¥3,000〜4,000"], ["電話", "0980-79-0197"]],
            recommendedMenu: "島ごはん / 居酒屋メニュー",
            businessHours: "18:00〜23:00",
            closedDays: "火",
            mapUrl: map("居酒家でいりぐち 宮古島 平良"),
            hashtags: ["#でいりぐち", "#宮古島居酒屋", "#夜ご飯"],
          },
          {
            name: "宮古創作料理 風まかせ",
            area: "平良",
            genre: "居酒屋",
            text: "釣り好きのご夫婦が営む、あたたかい雰囲気のお店。自分で釣った魚を持ち込んで調理してもらえるユニークなサービスもあり、地元の海の幸を身近に感じられる夜ご飯になります。",
            rows: [
              ["価格帯", "¥4,000〜5,000"],
              ["電話", "0980-79-7798"],
              ["駐車場", "なし"],
            ],
            businessHours: "17:00〜0:00",
            closedDays: "火・水",
            instagramPostUrl:
              "https://www.instagram.com/p/DbSdILFGh-S/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            mapUrl: map("宮古創作料理 風まかせ 宮古島 平良"),
            hashtags: ["#風まかせ", "#宮古島グルメ", "#夜ご飯"],
          },
          {
            name: "地鶏と島野菜 粋蓮",
            area: "平良",
            genre: "地鶏 / 島野菜 / 居酒屋",
            text: "新鮮な地鶏と島野菜を活かした料理が自慢の、宮古島の地元居酒屋。地鶏の旨みと島の食材を一緒に楽しみたい夜におすすめです。",
            rows: [["価格帯", "1人あたり ¥4,000〜5,000"], ["電話", "050-5448-6603"]],
            recommendedMenu: "地鶏料理 / 島野菜料理",
            businessHours: "毎日 16:00〜1:00",
            closedDays: "なし",
            instagramPostUrl:
              "https://www.instagram.com/p/DZMO9PrxuzL/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            mapUrl: "https://maps.app.goo.gl/h4zTgY7ctKNmkkvS7",
            hashtags: ["#粋蓮", "#地鶏", "#島野菜", "#宮古島グルメ"],
          },
          {
            name: "居酒屋 南樂",
            area: "平良",
            genre: "老舗居酒屋 / 島料理",
            images: [img("v1789054621/unnamed_1_rdzvdp.webp")],
            text: "長く親しまれている宮古島の老舗居酒屋。宮古島産カツオの旨みをシンプルに味わえる塩タタキがおすすめです。",
            rows: [["価格帯", "1人あたり ¥2,000〜5,000"], ["電話", "0980-73-1855"]],
            recommendedMenu: "宮古島産カツオの塩タタキ",
            businessHours: "毎日 18:00〜23:30",
            closedDays: "なし",
            mapUrl: "https://maps.app.goo.gl/Uah2pL4xb5WyRsoFA",
            hashtags: ["#居酒屋南樂", "#カツオの塩タタキ", "#宮古島グルメ"],
          },
          {
            name: "ツマンデ呑める みやこパーラー ハイサイ!",
            area: "平良",
            genre: "沖縄料理 / 居酒屋 / 海鮮",
            text: "「半歩進んだOKINAWA FOOD」をテーマに、宮古島の食の魅力を発信する人気店。島の食材を現代風にアレンジした料理を楽しめます。",
            rows: [["価格帯", "1人あたり ¥3,000〜5,000"], ["電話", "0980-79-6633"], ["住所", "〒906-0013 沖縄県宮古島市平良下里601 ちゅらハウス1F"], ["駐車場", "なし"]],
            recommendedMenu: "島の前菜盛り合わせ / カツオヲ漁師だれデ / 土鍋ジューシー",
            businessHours: "毎日 17:00〜0:00",
            closedDays: "なし",
            instagramPostUrl:
              "https://www.instagram.com/p/Cwndy-WPUrK/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            mapUrl: map("ツマンデ呑める みやこパーラー ハイサイ 宮古島"),
            hashtags: ["#みやこパーラーハイサイ", "#沖縄料理", "#宮古島グルメ"],
          },
          {
            name: "宮古酒場イツモノトコ。",
            area: "平良",
            genre: "昭和レトロ酒場 / 居酒屋",
            text: "昭和レトロな雰囲気の中で、深夜から朝方まで楽しめる宮古酒場。毎日朝4時まで営業しているため、遅い時間の食事や二軒目にも利用できます。",
            rows: [["価格帯", "1人あたり ¥3,000〜4,000"], ["予約電話", "080-4270-8708"], ["住所", "〒906-0013 沖縄県宮古島市平良下里646-2 バロック・ビル3-B"]],
            recommendedMenu: "居酒屋料理 / お酒",
            businessHours: "毎日 19:00〜4:00",
            closedDays: "なし",
            instagramPostUrl: "https://www.instagram.com/reel/DXRh0uQE4iX/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            mapUrl: map("宮古酒場イツモノトコ 宮古島"),
            hashtags: ["#宮古酒場イツモノトコ", "#昭和レトロ酒場", "#宮古島グルメ"],
          },
        ],
        hashtags: ["#島料理", "#沖縄料理", "#宮古島グルメ"],
      },
      {
        number: "02",
        title: "三線とにぎやかな雰囲気を楽しむ夜",
        area: "民謡居酒屋 / グループ旅行",
        text: "食事だけでなく、宮古島らしい夜の雰囲気までしっかり楽しみたい人におすすめ。三線ライブや島唄が響く店内で、旅行らしい特別な夜を過ごせます。",
        shops: [
          {
            name: "美ら島",
            area: "平良",
            genre: "民謡居酒屋",
            text: "三線の生演奏と島唄で、宮古島らしい夜を盛り上げてくれる人気店。旅行の夜をとことん楽しみたい人やグループ旅行におすすめですが、かなり混み合うため予約は必須です。",
            rows: [["価格帯", "¥4,000〜8,000"], ["電話", "0980-79-9788"]],
            recommendedMenu: "沖縄料理 / 島料理",
            businessHours: "18:00〜23:30",
            closedDays: "なし",
            instagramPostUrl:
              "https://www.instagram.com/p/DaX6W86Tpn4/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            mapUrl: map("美ら島 宮古島 民謡居酒屋"),
            hashtags: ["#美ら島", "#宮古島グルメ", "#夜遊び"],
          },
          {
            name: "うまりずま",
            area: "平良",
            genre: "民謡居酒屋",
            text: "島料理と沖縄料理を中心に、友達同士でも入りやすい雰囲気の一軒。にぎやかに過ごしたい夜にちょうどよく、旅の思い出に残る夜ご飯になります。",
            rows: [["価格帯", "¥2,000〜5,000"], ["電話", "0980-79-0335"]],
            recommendedMenu: "沖縄料理 / 島料理",
            businessHours: "17:00〜23:00",
            closedDays: "月",
            instagramPostUrl:
              "https://www.instagram.com/reel/DT199YOkd5g/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            mapUrl: map("うまりずま 宮古島 平良"),
            hashtags: ["#うまりずま", "#宮古島グルメ", "#夜ご飯"],
          },
        ],
        hashtags: ["#民謡居酒屋", "#夜遊び", "#宮古島グルメ"],
      },
      {
        number: "03",
        title: "海鮮・宮古牛でしっかり食べる夜",
        area: "海鮮 / 焼肉 / 炉端焼き",
        text: "海で遊んだ後や、旅の締めくくりにしっかり食べたい夜向けのグループ。新鮮な海鮮や宮古牛など、ボリュームと満足感のあるメニューを揃えました。",
        shops: [
          {
            name: "北琉笑店 いころ",
            area: "平良",
            genre: "海鮮居酒屋",
            text: "新鮮な海鮮をつまみに、しっかり飲んで食べたい夜にぴったりの海鮮居酒屋。人気があるため、行きたい日は予約しておくと安心です。",
            rows: [["価格帯", "1人あたり¥2,000〜6,000"], ["電話", "0980-75-4108"]],
            businessHours: "18:00〜0:00",
            closedDays: "木",
            instagramPostUrl:
              "https://www.instagram.com/p/C-G51sOyHEA/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            mapUrl: map("北琉笑店 いころ 宮古島 平良"),
            hashtags: ["#いころ", "#宮古島グルメ", "#海鮮居酒屋"],
          },
          {
            name: "海鮮 炭火 ABURI",
            area: "平良",
            genre: "海鮮炭火焼き",
            text: "全国各地から届く新鮮な海鮮を、炭火でじっくり炙って楽しめるお店。宮古島にいながら日本各地の魚介を味わえる、ちょっと贅沢な夜ご飯になります。",
            rows: [["価格帯", "¥4,000〜5,000"], ["電話", "0980-79-6715"]],
            businessHours: "18:00〜0:00",
            closedDays: "水",
            instagramPostUrl:
              "https://www.instagram.com/p/Dc3OqmnmQxc/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            mapUrl: map("海鮮炭火ABURI 宮古島 平良"),
            hashtags: ["#ABURI", "#宮古島グルメ", "#海鮮"],
          },
          {
            name: "宮古牛の焼肉 喜八",
            area: "平良",
            genre: "宮古牛 / 焼肉",
            text: "宮古牛をしっかり味わいたい夜に選びたい焼肉店。特別感のある食事にしやすく、旅の締めくくりや記念日のディナーにもおすすめです。",
            rows: [["価格帯", "1人あたり ¥5,000〜10,000"], ["電話", "0980-73-3859"]],
            recommendedMenu: "宮古牛 / 焼肉",
            businessHours: "火〜日 18:00〜23:00",
            closedDays: "月曜日",
            instagramPostUrl:
              "https://www.instagram.com/p/CZl99KOlHYy/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            mapUrl: map("宮古牛の焼肉 喜八 宮古島 平良"),
            hashtags: ["#焼肉喜八", "#宮古牛", "#宮古島グルメ"],
          },
          {
            name: "宮古炉端 素燻",
            area: "平良",
            genre: "モダン居酒屋レストラン",
            text: "島の海鮮や野菜、お肉料理まで炉端焼きでまとめて楽しめるお店。おしゃれな雰囲気で、旅先の特別な夜ご飯にもぴったりです。",
            rows: [["電話", "0980-79-0032"]],
            businessHours: "火〜日 18:00〜23:00",
            closedDays: "月曜日",
            instagramPostUrl:
              "https://www.instagram.com/reel/Dc-MzXIyu7l/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            mapUrl: map("宮古炉端 素燻 宮古島 平良"),
            hashtags: ["#宮古炉端素燻", "#宮古島グルメ", "#炉端焼き"],
          },
          {
            name: "Pork&Fish Dining HULAR",
            area: "平良",
            genre: "南国ダイニング / しゃぶしゃぶ / 魚介",
            text: "陽気で元気な南国ダイニング。こだわり出汁のしゃぶしゃぶや魚介料理を楽しめます。",
            rows: [["価格帯", "1人あたり ¥3,000〜4,000"], ["電話", "0980-79-0477"], ["住所", "〒906-0013 沖縄県宮古島市平良下里33"]],
            recommendedMenu: "こだわり出汁のしゃぶしゃぶ / 魚介料理",
            businessHours: "水〜月 17:00〜23:00",
            closedDays: "火曜日",
            instagramPostUrl: "https://www.instagram.com/p/Ch1LG-Lv5Vi/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            mapUrl: map("Pork&Fish Dining HULAR 宮古島"),
          },
          {
            name: "わとわ 宮古島店",
            area: "平良",
            genre: "宮古牛 / 沖縄料理 / 居酒屋",
            text: "炭火焼き宮古牛と沖縄料理を楽しめる、個室完備の居酒屋。全席禁煙で子ども連れにも対応し、予約は電話のみ・事前予約必須です。",
            rows: [["価格帯", "1人あたり ¥3,000〜6,000"], ["電話", "0980-73-7329"], ["住所", "〒906-0013 沖縄県宮古島市平良下里566-2"], ["予約", "電話での事前予約必須"]],
            recommendedMenu: "炭火焼き宮古牛 / 沖縄料理",
            businessHours: "毎日 18:00〜0:00",
            closedDays: "なし",
            instagramPostUrl: "https://www.instagram.com/p/DTxbdMKkaGv/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            mapUrl: map("わとわ 宮古島店"),
          },
          {
            name: "にんにく焼肉 プルシン宮古島店",
            area: "平良",
            genre: "黒毛和牛 / にんにく焼肉",
            text: "宮崎県都城市の黒毛和牛と青森県産にんにくを使用した焼肉店。セルフ飲み放題も楽しめます。",
            rows: [["価格帯", "1人あたり ¥3,000〜6,000"], ["電話", "0980-79-5529"], ["住所", "〒906-0013 沖縄県宮古島市平良下里83-3"]],
            recommendedMenu: "黒毛和牛のにんにく焼肉 / セルフ飲み放題",
            businessHours: "月〜水・金・日 11:30〜14:00 / 17:00〜23:00、木・土 17:00〜23:00",
            closedDays: "なし",
            instagramPostUrl: "https://www.instagram.com/p/DOIeKBAAdZn/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            mapUrl: map("にんにく焼肉 プルシン宮古島店"),
          },
          {
            name: "ホルモン人 宮古島本店",
            area: "平良",
            genre: "焼肉 / ホルモン",
            text: "コストパフォーマンスよく焼肉とホルモンを楽しめる宮古島本店。",
            rows: [["価格帯", "1人あたり ¥3,000〜6,000"], ["電話", "0980-73-2911"], ["住所", "〒906-0013 沖縄県宮古島市平良下里596-1"]],
            recommendedMenu: "焼肉 / ホルモン",
            businessHours: "毎日 17:30〜23:00",
            closedDays: "なし",
            instagramPostUrl: "https://www.instagram.com/p/CpuOTfivKfj/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            mapUrl: map("ホルモン人 宮古島本店"),
          },
        ],
        hashtags: ["#宮古牛", "#海鮮", "#焼肉"],
      },
      {
        number: "04",
        title: "落ち着いてゆっくり食事したい夜",
        area: "しゃぶしゃぶ / 静かな夜",
        text: "にぎやかな居酒屋とは違う、静かな時間を過ごしたい夜にはこちら。旅の合間にほっとひと息つける、落ち着いた雰囲気のお店です。",
        shops: [
          {
            name: "沖縄やんばるアグーしゃぶしゃぶ 嘉福",
            area: "平良",
            genre: "しゃぶしゃぶ",
            text: "沖縄の銘柄豚「アグー豚」を、ハマグリと雪塩を使用した出汁で味わえる絶品しゃぶしゃぶ。落ち着いた雰囲気でゆっくり食事を楽しめます。事前予約必須です。",
            rows: [["価格帯", "1人あたり ¥5,000〜9,000"], ["電話", "0980-79-6575"], ["予約", "事前予約必須"]],
            recommendedMenu: "アグー豚のしゃぶしゃぶ",
            businessHours: "月・火・木〜日 16:00〜0:00 / 水 16:00〜23:00",
            closedDays: "なし",
            instagramPostUrl:
              "https://www.instagram.com/reel/C-R3LgkP9rE/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA==",
            mapUrl: map("沖縄やんばるアグーしゃぶしゃぶ 嘉福 宮古島 平良"),
            hashtags: ["#嘉福", "#アグーしゃぶしゃぶ", "#宮古島グルメ"],
          },
        ],
        hashtags: ["#しゃぶしゃぶ", "#落ち着いた雰囲気"],
      },
    ],
  },

  "miyakojima-girls-trip-spots": {
    id: 40,
    slug: "miyakojima-girls-trip-spots",
    template: "normal",
    categoryKey: "spot",
    category: "Spot",
    title: "宮古島周辺でおすすめの女子旅スポット",
    description:
      "宮古島女子旅で行きたい、ビーチ、橋、カフェ、サンセット、秘境SUP、撮影スポットを紹介。SNSに残したくなるスポットを中心にまとめました。",
    date: "2026.08.08",
    readTime: "6分",
    tags: ["#宮古島", "#女子旅", "#映えスポット", "#カフェ巡り", "#撮影"],
    mainImage: img("v1784945639/DSC00440-2_syxyio.webp"),
    leadText:
      "宮古島周辺には、女子旅で行きたいスポットがたくさんあります。海がきれいに見える橋、写真を撮りたくなるビーチ、南国感のあるカフェ、夕方に行きたいサンセットスポットまで、旅の雰囲気ごと残せる場所をまとめました。",
    tocImage: img("v1784945639/DSC00440-2_syxyio.webp"),
    toc: [
      "宮古ブルーを感じる橋とビーチ",
      "写真を撮りたくなるカフェ",
      "夕方に行きたいサンセットスポット",
      "SUPでしか行けない秘境スポット",
    ],
    cta: {
      title: "女子旅の写真と映像をプロに任せる",
      text: "秘境スポットやプライベートビーチをご案内し、写真・動画・ドローン映像まで残します。",
      buttonText: "秘境フォトツアーを見る",
      path: "/tours/one-day-photogenic-tour",
    },
    points: [
      {
        number: "01",
        title: "宮古ブルーを感じる橋とビーチ",
        area: "Blue Spot",
        image: img("v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp"),
        text: "伊良部大橋、池間大橋、来間大橋は、宮古島らしい海のグラデーションを感じやすいスポットです。ビーチなら与那覇前浜、17END、砂山ビーチなどが定番。晴れた日の午前〜昼は海の色が出やすく、写真にも残しやすいです。",
        rows: [
          ["おすすめ", "伊良部大橋 / 17END / 与那覇前浜"],
          ["撮影", "海の色が出る晴れた時間帯"],
          ["注意", "風が強い日は髪や服装も考えておくと安心"],
        ],
        hashtags: ["#宮古ブルー", "#ビーチ", "#映えスポット"],
      },
      {
        number: "02",
        title: "写真を撮りたくなるカフェ",
        area: "Cafe",
        image: img(
          "v1783352339/AD_4nXf2yA3puqm63h-XEHfk_ltPQ-m0Sy4IQCU-m0yCaojShxZt7-CDQQ1B8UUjJ5iQC-szsuwzS9Vq4ScPOBElN52vu_oxEkcKu2UbdK-gsQe_WVuQKT9E9iGjaVqKC7vIMduz6M-_ylvli6.png",
        ),
        text: "女子旅なら、海が見えるカフェや南国感のあるスイーツスポットも入れたいところ。Seahorse club cafe、OHAMAテラス、Pani Pani、ブルータートルマンゴーカフェなど、写真に残したくなるカフェを旅の途中に組み込むのがおすすめです。",
        rows: [
          ["おすすめ", "海カフェ / マンゴースイーツ / テラス席"],
          ["相性", "ドライブ休憩 / ランチ / カフェ巡り"],
          ["撮影", "料理だけでなく背景の海や緑も入れる"],
        ],
        hashtags: ["#カフェ巡り", "#宮古島カフェ", "#女子旅"],
      },
      {
        number: "03",
        title: "夕方に行きたいサンセットスポット",
        area: "Sunset",
        image: img("v1784466423/DJI_20260718160638_0015_D_gh8w0n.webp"),
        text: "夕方は17END、佐和田の浜、トゥリバーサンセットビーチなどが候補です。日中とは違う柔らかい光で、雰囲気のある写真や動画を残せます。日没時間より少し早めに着くと、空の色が変わる流れまで楽しめます。",
        rows: [
          ["おすすめ", "17END / 佐和田の浜 / トゥリバー"],
          ["時間", "日没の30〜45分前に到着"],
          ["撮影", "逆光やシルエットを活かす"],
        ],
        hashtags: ["#サンセット", "#旅動画", "#撮影"],
      },
      {
        number: "04",
        title: "SUPでしか行けない秘境スポット",
        area: "Hidden SUP",
        image: img("v1785005393/DSC00191_small_lhfvnk.jpg"),
        text: "普通の観光では行きにくい場所を体験したいなら、秘境SUPも女子旅にぴったりです。透明な海の上でゆっくり過ごしながら、写真や動画まで残せるので、宮古島らしい非日常体験になります。",
        rows: [
          ["体験", "秘境SUP / 写真 / 動画"],
          ["おすすめ", "人が少ない海で癒されたい方"],
          ["相性", "女子旅 / 写真好き / 非日常体験"],
        ],
        hashtags: ["#SUP", "#秘境", "#非日常体験"],
      },
    ],
  },

  "miyakojima-surfing": {
    id: 6,
    slug: "miyakojima-surfing",
    template: "normal",
    categoryKey: "tour",
    category: "Tour",
    title: "宮古島でサーフィンをするべき理由3選",
    description:
      "宮古島でサーフィンをするべき理由を3つにまとめました。人が少ない海、宮古ブルーでの特別な体験、ローカルガイド付きで安全に楽しめるサーフィン体験を紹介します。",
    date: "2026.07.19",
    readTime: "5分",
    mainImage: img(
      "v1784354836/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-07-18_15.06.59_noluwe.png",
    ),
    leadText:
      "宮古島といえばシュノーケルやSUPのイメージが強いですが、実はサーフィンも楽しめます。まだあまり知られていないからこそ、人が少ない海でゆっくり波に向き合えるのが大きな魅力です。今回は、宮古島でサーフィンをするべき理由を3つに絞って紹介します。",
    tocImage: img("v1784350646/DJI_20260706065434_0044_D_kd2pm5.webp"),
    youtubeUrl: "https://www.youtube.com/watch?v=PbeyNc1Q9ec",
    youtubeTitle: "宮古島サーフィン体験の雰囲気",
    guideInstagram: {
      url: "https://www.instagram.com/swell_miyako_island/",
      handle: "@swell_miyako_island",
      title: "ガイドのInstagram",
      text: "当日の海の雰囲気やサーフィンの様子はこちらから確認できます。",
      cta: "Instagramを見る",
    },
    galleryImages: [
      img("v1784468640/DJI_20260719073835_0076_D_cx0wos.webp"),
      img(
        "v1784354836/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-07-18_15.06.59_noluwe.png",
      ),
      img("v1784350646/DJI_20260706065434_0044_D_kd2pm5.webp"),
      img("v1784350658/DJI_20260706094707_0054_D_t0d3pv.webp"),
      img("v1784350164/DJI_20260708172917_0004_D_n0pzoh.webp"),
    ],
    toc: [
      "理由1：ローカルガイド付きなら初心者でも挑戦しやすい",
      "理由2：人が少ない海でゆっくり楽しめる",
      "理由3：宮古ブルーの海で特別な写真や動画を残せる",
    ],
    cta: {
      title: "宮古島の海でサーフィン体験",
      text: "ローカル出身のガイドがその日の海況に合わせてポイントへご案内します。手ぶらOKで、ドローン撮影オプションも追加できます。",
      buttonText: "サーフィン体験を見る",
      path: "/tours/surfing",
    },
    points: [
      {
        number: "01",
        title: "理由1：ローカルガイド付きなら初心者でも挑戦しやすい",
        area: "Local Guide",
        image: img("v1784350658/DJI_20260706094707_0054_D_t0d3pv.webp"),
        text: "宮古島の海は美しい一方で、リーフや潮の流れなど注意が必要です。ローカル出身のガイドがその日の風・波・潮位を見て、安全に楽しめるポイントへご案内します。サーフボードとリーフブーツのレンタル、レッスン代も含まれているので手ぶらで参加でき、美しい海に浮かびながら、パワーのある波でガイドが押して初心者の方でも必ずハマるはずです。",
        rows: [
          ["料金", "¥15,000 / 1名"],
          ["含まれるもの", "レッスン代 / サーフボード / リーフブーツ"],
          ["集合", "現地集合 / 集合場所は事前にご案内"],
        ],
        hashtags: [
          "#ローカルガイド",
          "#手ぶらOK",
          "#宮古島ツアー",
          "#マリンアクティビティ",
        ],
      },
      {
        number: "02",
        title: "理由2：人が少ない海でゆっくり楽しめる",
        area: "Quiet Surf",
        image: img("v1784350164/DJI_20260708172917_0004_D_n0pzoh.webp"),
        text: "宮古島でサーフィンができることは、まだあまり知られていません。だからこそ、有名なサーフスポットに比べると海が混雑しにくく、自分のペースで波に向き合いやすいのが魅力です。初めての方でも、周りを気にしすぎず落ち着いて体験できます。",
        rows: [
          ["おすすめ", "初心者 / 朝活 / 旅行中のアクティビティ"],
          ["魅力", "人が少ない海でゆっくり練習できる"],
          ["時間", "7:00頃スタート / 約3時間"],
        ],
        hashtags: ["#宮古島サーフィン", "#宮古島旅行", "#マリンアクティビティ"],
      },
      {
        number: "03",
        title: "理由3：宮古ブルーの海で特別な写真や動画を残せる",
        area: "Photo & Movie",
        image: img("v1784350646/DJI_20260706065434_0044_D_kd2pm5.webp"),
        text: "透明度の高い宮古島の海でサーフィンをすると、ただ海に入るだけでも特別な思い出になります。さらにドローン撮影を追加すれば、波に乗る瞬間や海の色まで写真・動画で残せます。旅行の思い出としても、SNSに残す素材としても相性が良い体験です。",
        rows: [
          [
            "撮影オプション",
            "ドローン撮影 +¥10,000 / 1グループ、4名以上 +¥16,000",
          ],
          ["受け渡し", "レッスン終了後にAirDropでお渡し"],
          ["おすすめ", "旅行の思い出 / SNS投稿 / ショート動画"],
        ],
        hashtags: [
          "#ドローン撮影",
          "#ドローン",
          "#旅動画",
          "#宮古島サーフィン",
          "#マリンアクティビティ",
        ],
      },
    ],
  },

  "miyakojima-surfing-experience": {
    id: 15,
    slug: "miyakojima-surfing-experience",
    template: "normal",
    categoryKey: "tour",
    category: "Tour",
    title: "宮古島サーフィン体験の様子",
    description:
      "宮古島で楽しめるサーフィン体験の雰囲気を、実際の動画と写真で紹介します。朝の海、レッスン、波に乗る瞬間、写真・映像データのお渡しまで流れがわかる記事です。",
    date: "2026.07.27",
    readTime: "4分",
    tags: [
      "#宮古島",
      "#サーフィン",
      "#マリンアクティビティ",
      "#撮影",
      "#ドローン",
      "#旅動画",
    ],
    mainMedia: {
      videoUrl:
        "https://res.cloudinary.com/drxijtp8g/video/upload/v1785121816/video_623905920757268499-LdwiKycC_wynogm.mp4",
    },
    mainImage: img("v1785121770/IMG_5983_abqsgh.webp"),
    leadText:
      "宮古島でサーフィンができることは、まだあまり知られていません。透明度の高い海、人が少ないポイント、ローカルガイド付きの安心感がそろうと、初心者でも特別な朝の体験になります。この記事では、実際の動画と写真でサーフィン体験の様子を紹介します。",
    tocImage: img("v1785121767/IMG_5991_lvh285.webp"),
    galleryImages: [
      {
        videoUrl:
          "https://res.cloudinary.com/drxijtp8g/video/upload/v1785121816/video_623905920757268499-LdwiKycC_wynogm.mp4",
      },
      {
        videoUrl:
          "https://res.cloudinary.com/drxijtp8g/video/upload/v1785121807/IMG_5988_ldy1tk.mp4",
      },
      {
        videoUrl:
          "https://res.cloudinary.com/drxijtp8g/video/upload/v1785121801/IMG_5987_cqdl6x.mp4",
      },
      img("v1785121770/IMG_5983_abqsgh.webp"),
      img("v1785121767/IMG_5991_lvh285.webp"),
      img("v1785121763/IMG_5979_zjma3g.webp"),
      img("v1785121759/IMG_5975_oupbsb.webp"),
      img("v1785121754/IMG_5973_g1mbb7.webp"),
      img("v1785121750/IMG_5957_eclbjq.webp"),
      img("v1785121747/IMG_5945_ycqcjo.webp"),
      img("v1785121745/IMG_5943_ouoeo6.webp"),
    ],
    toc: [
      "朝の海で現地集合",
      "ローカルガイドのレッスンで安心して挑戦",
      "写真・映像でサーフィンの思い出を残せる",
      "多言語でも楽しめるベテランガイドのサポート",
    ],
    cta: {
      title: "宮古島でサーフィン体験",
      text: "サーフボード、リーフブーツ、レッスン代込み。ローカルガイドが海況を見て安全に楽しめるポイントへご案内します。",
      buttonText: "サーフィン体験を見る",
      path: "/tours/surfing",
    },
    points: [
      {
        number: "01",
        title: "朝の海で現地集合",
        area: "Morning Surf",
        media: {
          videoUrl:
            "https://res.cloudinary.com/drxijtp8g/video/upload/v1785121807/IMG_5988_ldy1tk.mp4",
        },
        text: "サーフィン体験は朝7:00ごろスタート。時間・集合場所はその日の風・波・潮位を見て事前にご案内します。人が少ない時間帯の海で、落ち着いて宮古島の波を楽しめます。",
        rows: [
          ["集合", "現地集合 / 集合場所は事前にご案内"],
          ["開始時間", "朝7:00ごろ"],
          ["所要時間", "約3時間"],
        ],
        hashtags: ["#宮古島サーフィン", "#朝活", "#マリンアクティビティ"],
      },
      {
        number: "02",
        title: "ローカルガイドのレッスンで安心して挑戦",
        area: "Local Lesson",
        image: img("v1785121747/IMG_5945_ycqcjo.webp"),
        text: "宮古島の海は美しい一方で、リーフや潮の流れなど注意が必要です。ローカルガイドが安全説明と基本レッスンを行い、その日のコンディションに合わせてサポートします。",
        rows: [
          ["集合", "現地集合 / 集合場所は事前にご案内"],
          ["含まれるもの", "レッスン代 / サーフボード / リーフブーツ"],
          ["対象", "初心者OK"],
          ["料金", "¥15,000 / 1名"],
        ],
        hashtags: ["#ローカルガイド", "#初心者OK", "#手ぶらOK"],
      },
      {
        number: "03",
        title: "写真・映像でサーフィンの思い出を残せる",
        area: "Photo & Movie",
        image: img("v1785121763/IMG_5979_zjma3g.webp"),
        text: "海に入っている姿や波に乗る瞬間は、自分ではなかなか残せません。撮影オプションを追加すれば、写真や映像データを体験後にお渡しできます。",
        rows: [
          ["撮影オプション", "ドローン撮影 +¥10,000 / 1グループ"],
          ["4名以上", "ドローン撮影 +¥16,000"],
          ["受け渡し", "体験後に写真・映像データをお渡し"],
        ],
        hashtags: ["#撮影", "#ドローン", "#旅動画", "#宮古ブルー"],
      },
      {
        number: "04",
        title: "多言語でも楽しめるベテランガイドのサポート",
        area: "Multilingual Guide",
        media: {
          videoUrl:
            "https://res.cloudinary.com/drxijtp8g/video/upload/v1785121801/IMG_5987_cqdl6x.mp4",
        },
        text: "言葉が違っても、海に入れば楽しさは自然と伝わります。これまで多くの海外ゲストを案内してきたベテランのローカルガイドが、ジェスチャーや簡単な英語も交えながら、その日の海に合わせて楽しくサポートします。言語の壁を超えて、宮古島の波に乗る特別な時間を体験できます。",
        rows: [
          ["対応", "日本語 / 簡単な英語 / ジェスチャーでサポート"],
          ["ガイド", "海外ゲストの案内経験が豊富なローカルガイド"],
          ["安心ポイント", "言葉が不安な方でも楽しみやすい体験"],
        ],
        hashtags: [
          "#多言語対応",
          "#ローカルガイド",
          "#宮古島サーフィン",
          "#海外ゲスト歓迎",
        ],
      },
    ],
  },

  "miyakojima-surfing-guide": {
    id: 31,
    slug: "miyakojima-surfing-guide",
    template: "normal",
    categoryKey: "tour",
    category: "Tour",
    title: "宮古島来たらサーフィンしないと！",
    description:
      "宮古島でサーフィンをしたい方へ。海から見るサンライズ、初心者でも安心のローカルガイド、多言語対応、実際のサーフィン体験動画をまとめて紹介します。",
    date: "2026.09.01",
    readTime: "5分",
    tags: [
      "#宮古島",
      "#宮古島サーフィン",
      "#サーフィン",
      "#マリンアクティビティ",
      "#ローカルガイド",
      "#朝活",
      "#多言語対応",
      "#撮影",
    ],
    mainMedia: {
      videoUrl:
        "https://res.cloudinary.com/drxijtp8g/video/upload/v1788263810/wCGeXhwWqflCHrdp-wJnYSacxuLxAIi6GDkWvmYqpmk_d5qger.mp4",
    },
    mainImage: img("v1788263939/IMG_6136_isxw3s.jpg"),
    leadText:
      "宮古島でサーフィンができることは、まだあまり知られていません。人が少ない朝の海で、ローカルガイドと一緒に波に乗る時間は、普通の観光では味わえない特別な体験です。初心者の方でも安心して楽しめるように、当日の海況に合わせてベストなポイントへご案内します。",
    tocImage: img("v1788264796/IMG_6101_wqf7cj.jpg"),
    guideInstagram: {
      url: "https://www.instagram.com/swell_miyako_island/",
      handle: "@swell_miyako_island",
      title: "ガイド紹介",
      text: "ローカルの宮古島の波を知り尽くしたベテランガイドが、その日ベストな場所へお連れします。初心者の方でも安心してお楽しみいただけます。",
      cta: "Instagramを見る",
    },
    galleryImages: [
      {
        videoUrl:
          "https://res.cloudinary.com/drxijtp8g/video/upload/v1788263810/wCGeXhwWqflCHrdp-wJnYSacxuLxAIi6GDkWvmYqpmk_d5qger.mp4",
      },
      {
        videoUrl:
          "https://res.cloudinary.com/drxijtp8g/video/upload/v1788263844/IMG_6105_gaklln.mp4",
      },
      img("v1788263939/IMG_6136_isxw3s.jpg"),
      {
        videoUrl:
          "https://res.cloudinary.com/drxijtp8g/video/upload/v1788264032/Qi4t099FLq-uZPQ_ee-pVViTLl1P0LkntBWHjhLgUo4_vaiswg.mp4",
      },
      {
        videoUrl:
          "https://res.cloudinary.com/drxijtp8g/video/upload/v1788264061/IMG_6133_hp2ezk.mp4",
      },
    ],
    toc: [
      "透明度抜群の海で波にのる他では絶対にできない経験",
      "多言語対応で海外の方も楽しめる",
      "初心者でも安心のレッスン",
      "ガイド紹介",
    ],
    cta: {
      title: "宮古島でサーフィン体験",
      text: "ローカルガイドがその日の風・波・潮位を見て、安全に楽しめるポイントへご案内します。サーフボード、リーフブーツ、レッスン代込みで手ぶら参加OKです。",
      buttonText: "サーフィン体験を見る",
      path: "/tours/surfing",
    },
    points: [
      {
        number: "01",
        title: "透明度抜群の海で波にのる他では絶対にできない経験",
        area: "Sunrise Surf",
        media: {
          videoUrl:
            "https://res.cloudinary.com/drxijtp8g/video/upload/v1788263810/wCGeXhwWqflCHrdp-wJnYSacxuLxAIi6GDkWvmYqpmk_d5qger.mp4",
        },
        text: "透明度抜群の宮古ブルーの海で波にのる体験は、他ではなかなか味わえない特別な時間です。朝の静かな海に入り、海の上からサンライズを見る瞬間も宮古島ならでは。人が少ない時間帯だからこそ、ゆっくり波と向き合いながら特別な朝を過ごせます。",
        rows: [
          ["おすすめ", "朝活 / 女子旅 / 初めてのサーフィン"],
          ["開始時間", "朝7:00ごろ"],
          ["雰囲気", "人が少ない海でゆっくり楽しめる"],
        ],
        hashtags: ["#宮古島サーフィン", "#サンライズ", "#朝活"],
      },
      {
        number: "02",
        title: "多言語対応",
        area: "Multilingual Guide",
        image: img("v1788263939/IMG_6136_isxw3s.jpg"),
        text: "言葉が違っても、サーフィンの楽しさはしっかり伝わります。海外の方をたくさんガイドしてきたベテランのローカルガイドが、簡単な英語やジェスチャーも交えながらサポートします。",
        rows: [
          ["対応", "日本語 / 簡単な英語 / ジェスチャー"],
          ["安心ポイント", "海外ゲストのガイド経験あり"],
          ["おすすめ", "海外の友人との旅行にも"],
        ],
        hashtags: ["#多言語対応", "#海外ゲスト歓迎", "#ローカルガイド"],
      },
      {
        number: "03",
        title: "サーフィン初心者でも安心",
        area: "Beginner Lesson",
        media: {
          videoUrl:
            "https://res.cloudinary.com/drxijtp8g/video/upload/v1788264032/Qi4t099FLq-uZPQ_ee-pVViTLl1P0LkntBWHjhLgUo4_vaiswg.mp4",
        },
        text: "サーフィン初心者でも安心。宮古島の波を知り尽くしたベテランガイドによるレッスンで、初めての方でも立てるように丁寧にサポートします。",
        rows: [
          ["含まれるもの", "レッスン代 / サーフボード / リーフブーツ"],
          ["対象", "初心者OK"],
          ["料金", "¥15,000 / 1名"],
        ],
        hashtags: ["#初心者OK", "#手ぶらOK", "#サーフィン体験"],
      },
      {
        number: "04",
        title: "波に乗る瞬間を映像で残せる",
        area: "Surf Movie",
        media: {
          videoUrl:
            "https://res.cloudinary.com/drxijtp8g/video/upload/v1788264061/IMG_6133_hp2ezk.mp4",
        },
        text: "波に乗る瞬間や海の透明感は、動画で見るとより伝わります。宮古島でのサーフィン体験を、旅の思い出として何度も見返せる形で残せます。",
        rows: [
          [
            "撮影オプション",
            "ドローン撮影 +¥10,000 / 1グループ、4名以上 +¥16,000",
          ],
          ["受け渡し", "体験後にデータをお渡し"],
          ["おすすめ", "SNSに載せたい旅動画にも"],
        ],
        hashtags: ["#旅動画", "#撮影", "#宮古ブルー"],
      },
    ],
  },
};

export const blogArticleList = Object.values(blogArticles);
